import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: Date; output: Date; }
};

export type AddYourselfInput = {
  projectId: Scalars['String']['input'];
  responses: Array<ProjectSurveyResponseInput>;
};

export type AgentChangeInfo = {
  __typename?: 'AgentChangeInfo';
  agentId: Scalars['String']['output'];
  agentName: Scalars['String']['output'];
  deviationAmount: Scalars['Float']['output'];
  topShiftedQuestions: Array<QuestionShift>;
  triggerAxis: Scalars['String']['output'];
};

export type AgentCollection = {
  __typename?: 'AgentCollection';
  agentCount: Scalars['Int']['output'];
  agents: Array<CustomAgent>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  digitalTwinCount: Scalars['Int']['output'];
  digitalTwins: Array<DigitalTwin>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type AgentConfigInput = {
  maxTokens?: InputMaybe<Scalars['Int']['input']>;
  systemPrompt?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
};

export type AgentHealthSummary = {
  __typename?: 'AgentHealthSummary';
  error: Scalars['Int']['output'];
  healthy: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  warning: Scalars['Int']['output'];
};

export type AgentMonitoringLog = {
  __typename?: 'AgentMonitoringLog';
  behaviorFlags?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  responseTime?: Maybe<Scalars['Int']['output']>;
  scanDate: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type AgentOrgShare = {
  __typename?: 'AgentOrgShare';
  canEdit: Scalars['Boolean']['output'];
  organizationId: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
};

export type AgentOwner = {
  __typename?: 'AgentOwner';
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type AnswerSimilarity = {
  __typename?: 'AnswerSimilarity';
  question: Scalars['String']['output'];
  similarity?: Maybe<Scalars['Float']['output']>;
};

export type AuthResponse = {
  __typename?: 'AuthResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type BackfillChangesResult = {
  __typename?: 'BackfillChangesResult';
  changesDetected: Scalars['Int']['output'];
  processed: Scalars['Int']['output'];
};

export type BehaviorChange = {
  __typename?: 'BehaviorChange';
  customAgent?: Maybe<CustomAgent>;
  detectedAt: Scalars['String']['output'];
  deviationAmount: Scalars['Float']['output'];
  digitalTwin?: Maybe<DigitalTwin>;
  id: Scalars['String']['output'];
  measurementX: Scalars['Float']['output'];
  measurementY: Scalars['Float']['output'];
  movingAverageX: Scalars['Float']['output'];
  movingAverageY: Scalars['Float']['output'];
  project: Project;
  standardDeviationX: Scalars['Float']['output'];
  standardDeviationY: Scalars['Float']['output'];
  triggerAxis: Scalars['String']['output'];
};

export type CheckInResult = {
  __typename?: 'CheckInResult';
  changedAgents: Array<AgentChangeInfo>;
  hasChange: Scalars['Boolean']['output'];
  lastChangeDetectedAt?: Maybe<Scalars['String']['output']>;
  latestProjectId?: Maybe<Scalars['String']['output']>;
  totalProjects: Scalars['Int']['output'];
};

export type CompactionResult = {
  __typename?: 'CompactionResult';
  candidates: Array<SteeringCandidate>;
  recommended?: Maybe<SteeringCandidate>;
};

export type Comparison = {
  __typename?: 'Comparison';
  customAgent?: Maybe<CustomAgent>;
  digitalTwin?: Maybe<DigitalTwin>;
  id: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  type: ComparisonType;
};

export enum ComparisonType {
  Dissimilar = 'DISSIMILAR',
  Similar = 'SIMILAR'
}

export type ConfirmSubtopicsInput = {
  projectId: Scalars['String']['input'];
  subtopics: Array<Scalars['String']['input']>;
  subtopicsChanged: Scalars['Boolean']['input'];
  topic: Scalars['String']['input'];
};

export type CongressData = {
  __typename?: 'CongressData';
  chamber: Scalars['String']['output'];
  linkedinHandle?: Maybe<Scalars['String']['output']>;
  party: Scalars['String']['output'];
  state: Scalars['String']['output'];
  twitterHandle?: Maybe<Scalars['String']['output']>;
};

export type ConnectionTestResult = {
  __typename?: 'ConnectionTestResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  protocol: Scalars['String']['output'];
  responseTimeMs?: Maybe<Scalars['Int']['output']>;
  status: ConnectionTestStatus;
  statusCode?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
  testedAt: Scalars['String']['output'];
};

export enum ConnectionTestStatus {
  Failure = 'FAILURE',
  Success = 'SUCCESS',
  Timeout = 'TIMEOUT'
}

export enum ConnectionType {
  Connector = 'CONNECTOR',
  Direct = 'DIRECT'
}

export type ConnectorEnrollmentResult = {
  __typename?: 'ConnectorEnrollmentResult';
  enrollmentCode: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  instructions: Scalars['String']['output'];
};

export enum ConnectorEnrollmentStatus {
  Enrolled = 'ENROLLED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Revoked = 'REVOKED'
}

export type ConnectorSession = {
  __typename?: 'ConnectorSession';
  cwd?: Maybe<Scalars['String']['output']>;
  lastModified: Scalars['Float']['output'];
  sessionId: Scalars['String']['output'];
  sizeBytes: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type ConnectorSetupEmailResult = {
  __typename?: 'ConnectorSetupEmailResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  sentTo?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum ConnectorStatus {
  Disconnected = 'DISCONNECTED',
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export type ConnectorStatusResult = {
  __typename?: 'ConnectorStatusResult';
  connectedSince?: Maybe<Scalars['String']['output']>;
  enrollmentStatus?: Maybe<ConnectorEnrollmentStatus>;
  gatewayHealth?: Maybe<GatewayHealth>;
  gatewayHealthReason?: Maybe<Scalars['String']['output']>;
  lastPingAt?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type Conversation = {
  __typename?: 'Conversation';
  demographic?: Maybe<Scalars['String']['output']>;
  digitalTwins: Array<DigitalTwin>;
  id: Scalars['String']['output'];
  messages?: Maybe<Array<Message>>;
  projectId?: Maybe<Scalars['String']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: ConversationType;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export enum ConversationType {
  Demographic = 'DEMOGRAPHIC',
  Panel = 'PANEL',
  Persona = 'PERSONA'
}

export type CreateAbTestInput = {
  baseQuestion: Scalars['String']['input'];
  messageA: Scalars['String']['input'];
  messageAContext?: InputMaybe<Scalars['String']['input']>;
  messageB: Scalars['String']['input'];
  messageBContext?: InputMaybe<Scalars['String']['input']>;
  surveyGroupId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateAgentCollectionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateCustomAgentInput = {
  apiAuthType: Scalars['String']['input'];
  apiCredentials?: InputMaybe<Scalars['String']['input']>;
  apiEndpoint: Scalars['String']['input'];
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  maxTokens?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  systemPrompt?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateEvaluationResponse = {
  __typename?: 'CreateEvaluationResponse';
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  evaluationId?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type CreatePlanningProbeInput = {
  customAgentIds: Array<Scalars['String']['input']>;
  projectDescription: Scalars['String']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
  tasks: Array<PlanningTaskInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProjectInput = {
  collectionId?: InputMaybe<Scalars['String']['input']>;
  customAgentId?: InputMaybe<Scalars['String']['input']>;
  digitalTwinId?: InputMaybe<Scalars['String']['input']>;
  dtType?: InputMaybe<DtType>;
  selectedAll?: InputMaybe<Scalars['Boolean']['input']>;
  selectedDemographics?: InputMaybe<Array<SelectedDemographicsInput>>;
  subtopicId?: InputMaybe<Scalars['String']['input']>;
  subtopicIds?: InputMaybe<Array<Scalars['String']['input']>>;
  subtopics?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProposalInput = {
  dtType?: InputMaybe<DtType>;
  notes?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: ProposalType;
};

export type CreateSurveyWithQuestionsInput = {
  bountyInCents?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  questions: Array<SurveyQuestionInput>;
  surveyGroupId: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: SurveyType;
};

export type CustomAgent = {
  __typename?: 'CustomAgent';
  apiAuthType: Scalars['String']['output'];
  apiEndpoint: Scalars['String']['output'];
  avatarUrl?: Maybe<Scalars['String']['output']>;
  canEdit: Scalars['Boolean']['output'];
  connectionType: ConnectionType;
  connectorStatus?: Maybe<ConnectorStatus>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  gatewayHealth?: Maybe<GatewayHealth>;
  gatewayHealthReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isOwner: Scalars['Boolean']['output'];
  lastConnectionTestAt?: Maybe<Scalars['String']['output']>;
  lastConnectorPingAt?: Maybe<Scalars['String']['output']>;
  maxTokens?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  orgShares?: Maybe<Array<AgentOrgShare>>;
  organizationId?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<AgentOwner>;
  projectCount: Scalars['Int']['output'];
  shareCount: Scalars['Int']['output'];
  snapshot?: Maybe<CustomAgentSnapshot>;
  snapshotEnabled: Scalars['Boolean']['output'];
  status: CustomAgentStatus;
  systemPrompt?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
};

export type CustomAgentSnapshot = {
  __typename?: 'CustomAgentSnapshot';
  apiAuthType: Scalars['String']['output'];
  apiEndpoint: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  maxTokens?: Maybe<Scalars['Int']['output']>;
  systemPrompt?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['String']['output'];
};

export enum CustomAgentStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  PendingVerification = 'PENDING_VERIFICATION',
  Suspended = 'SUSPENDED'
}

export type DigitalTwin = {
  __typename?: 'DigitalTwin';
  blurb?: Maybe<Scalars['String']['output']>;
  congressData?: Maybe<CongressData>;
  earlyStageVcData?: Maybe<EarlyStageVcData>;
  fedMemberData?: Maybe<FedMemberData>;
  fortuneCeoData?: Maybe<FortuneCeoData>;
  id: Scalars['String']['output'];
  modelData?: Maybe<ModelData>;
  moviesMediumFullData?: Maybe<MoviesMediumFullData>;
  moviesSimpleData?: Maybe<MoviesSimpleData>;
  name: Scalars['String']['output'];
  nycMayorData?: Maybe<NycMayorData>;
  projects?: Maybe<Array<Project>>;
  sendrilData?: Maybe<SendrilData>;
  surveyUserData?: Maybe<SurveyUserData>;
  type: DtType;
};

export type DigitalTwinsResponse = {
  __typename?: 'DigitalTwinsResponse';
  totalCount: Scalars['Int']['output'];
  twins: Array<DigitalTwin>;
};

export type DisconnectResponse = {
  __typename?: 'DisconnectResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DtCollection = {
  __typename?: 'DtCollection';
  digitalTwins?: Maybe<Array<DigitalTwin>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum DtParty {
  Democrat = 'DEMOCRAT',
  Independent = 'INDEPENDENT',
  Republican = 'REPUBLICAN'
}

export enum DtType {
  Congressperson = 'CONGRESSPERSON',
  EarlyStageVcs = 'EARLY_STAGE_VCS',
  FedMember = 'FED_MEMBER',
  FortuneCeos = 'FORTUNE_CEOS',
  Influencer = 'INFLUENCER',
  Mixed = 'MIXED',
  Model = 'MODEL',
  MoviesFull = 'MOVIES_FULL',
  MoviesMedium = 'MOVIES_MEDIUM',
  MoviesSimple = 'MOVIES_SIMPLE',
  MovieGoers = 'MOVIE_GOERS',
  None = 'NONE',
  NycMayoralCandidate = 'NYC_MAYORAL_CANDIDATE',
  Sendril = 'SENDRIL',
  Tiktoker = 'TIKTOKER'
}

export type EarlyStageVcData = {
  __typename?: 'EarlyStageVcData';
  firm: Scalars['String']['output'];
  linkedinHandle?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  twitterHandle?: Maybe<Scalars['String']['output']>;
};

export enum FeatureRequestFeedbackType {
  Feature = 'FEATURE',
  Feedback = 'FEEDBACK'
}

export type FedMemberData = {
  __typename?: 'FedMemberData';
  bank: Scalars['String']['output'];
  bio?: Maybe<Scalars['String']['output']>;
  bioSource?: Maybe<Scalars['String']['output']>;
  isChair: Scalars['Boolean']['output'];
  isGovernor: Scalars['Boolean']['output'];
  isVoting: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  office: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type FortuneCeoData = {
  __typename?: 'FortuneCeoData';
  company: Scalars['String']['output'];
  industry: Scalars['String']['output'];
  linkedinHandle?: Maybe<Scalars['String']['output']>;
  twitterHandle?: Maybe<Scalars['String']['output']>;
};

export enum GatewayHealth {
  Healthy = 'HEALTHY',
  Unknown = 'UNKNOWN',
  Unreachable = 'UNREACHABLE'
}

export type GenerateProjectInput = {
  projectId: Scalars['String']['input'];
};

export enum InvitationStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

export type InviteToOrganizationInput = {
  email: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  role: OrganizationRole;
};

export type Message = {
  __typename?: 'Message';
  content: Scalars['String']['output'];
  digitalTwin?: Maybe<DigitalTwin>;
  id: Scalars['String']['output'];
  retrievedContent?: Maybe<Array<RetrievedContent>>;
  timestamp: Scalars['String']['output'];
  userSender: Scalars['Boolean']['output'];
};

export type MessageResponse = {
  __typename?: 'MessageResponse';
  response: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type ModelData = {
  __typename?: 'ModelData';
  baseModel?: Maybe<Scalars['String']['output']>;
  maxNewTokens?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numReturnSequences?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  systemPrompt?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
};

export type MonitoringSubtopic = {
  __typename?: 'MonitoringSubtopic';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  questions: Array<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
  spectrumLeftTitle: Scalars['String']['output'];
  spectrumRightTitle: Scalars['String']['output'];
};

export type MonitoringTopic = {
  __typename?: 'MonitoringTopic';
  applicableDtTypes: Array<DtType>;
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  subtopics: Array<MonitoringSubtopic>;
};

export type MoviesMediumFullData = {
  __typename?: 'MoviesMediumFullData';
  age: Scalars['String']['output'];
  childrenData: Scalars['String']['output'];
  education: Scalars['String']['output'];
  employment: Scalars['String']['output'];
  ethnicity: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  income: Scalars['String']['output'];
  locationType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  race: Scalars['String']['output'];
  region: Scalars['String']['output'];
};

export type MoviesSimpleData = {
  __typename?: 'MoviesSimpleData';
  age: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvitation: Organization;
  acceptTos?: Maybe<User>;
  addAgentToCollection: AgentCollection;
  addAgentToProject: Scalars['Boolean']['output'];
  addDigitalTwinToCollection: AgentCollection;
  addPersonaToCollection: Scalars['Boolean']['output'];
  addUserToOrganization: Scalars['Boolean']['output'];
  addYourself: Project;
  authenticateAIService: AuthResponse;
  backfillBehaviorChanges: BackfillChangesResult;
  confirmSubtopics: Project;
  createABTest: Survey;
  createAgentCollection: AgentCollection;
  createCustomAgent: CustomAgent;
  createEvaluation: CreateEvaluationResponse;
  createFeatureRequestFeedback: Scalars['Boolean']['output'];
  createOrganization: Organization;
  createOrganizationWithOwner: Organization;
  createPlanningProbe: Project;
  createProject: Project;
  createProposal: Proposal;
  createSurveyWithQuestions: Survey;
  createUser?: Maybe<User>;
  declineInvitation: Scalars['Boolean']['output'];
  deleteAgentCollection: Scalars['Boolean']['output'];
  deleteCustomAgent: Scalars['Boolean']['output'];
  deleteExplorable: Scalars['Boolean']['output'];
  deleteMyAccount: Scalars['Boolean']['output'];
  deleteOrganization: Scalars['Boolean']['output'];
  deletePersona: Scalars['Boolean']['output'];
  deleteProjectFile: ProjectFile;
  deleteProjectTemplate: Scalars['Boolean']['output'];
  deleteProposal?: Maybe<Scalars['Boolean']['output']>;
  deleteUser: Scalars['Boolean']['output'];
  disconnectAIService: DisconnectResponse;
  generateConnectorEnrollment: ConnectorEnrollmentResult;
  generatePlanningTasks: Array<PlanningTask>;
  generateProject: Project;
  getAIMessageResponse: Conversation;
  inviteToOrganization: OrganizationInvitation;
  leaveOrganization: Scalars['Boolean']['output'];
  markConversationViewed: Conversation;
  markProjectViewed: Project;
  markTwinViewed: Scalars['Boolean']['output'];
  refreshAgentSnapshot: CustomAgentSnapshot;
  removeAgentFromCollection: AgentCollection;
  removeAgentFromProject: Scalars['Boolean']['output'];
  removeDigitalTwinFromCollection: AgentCollection;
  removeMember: Scalars['Boolean']['output'];
  resendInvitation: OrganizationInvitation;
  retryProject: Project;
  revertAgentToSnapshot: CustomAgent;
  revokeConnectorEnrollment: Scalars['Boolean']['output'];
  revokeInvitation: Scalars['Boolean']['output'];
  sendAIMessage: Conversation;
  sendConnectorSetupEmail: ConnectorSetupEmailResult;
  setUserOrganization?: Maybe<User>;
  shareAgentWithOrganization: CustomAgent;
  shareProject: ShareProjectResponse;
  startConversation: Conversation;
  submitOnboarding?: Maybe<User>;
  suggestWatchTitle: Scalars['String']['output'];
  testAgentConnection: ConnectionTestResult;
  transferOwnership: Organization;
  triggerCompactionAnalysis: SteeringRun;
  triggerInjectionAnalysis: SteeringRun;
  triggerProjectUpdate: Project;
  unshareAgentWithOrganization: CustomAgent;
  updateAgentCollection: AgentCollection;
  updateCustomAgent: CustomAgent;
  updateMemberRole: OrganizationMember;
  updateProjectSettings: ProjectSettings;
  upvoteProposal: Proposal;
  verifyAgent: CustomAgent;
};


export type MutationAcceptInvitationArgs = {
  token: Scalars['String']['input'];
};


export type MutationAddAgentToCollectionArgs = {
  agentId: Scalars['String']['input'];
  collectionId: Scalars['String']['input'];
};


export type MutationAddAgentToProjectArgs = {
  agentId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type MutationAddDigitalTwinToCollectionArgs = {
  collectionId: Scalars['String']['input'];
  digitalTwinId: Scalars['String']['input'];
};


export type MutationAddPersonaToCollectionArgs = {
  collectionId: Scalars['String']['input'];
  personaId: Scalars['String']['input'];
};


export type MutationAddUserToOrganizationArgs = {
  organizationId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAddYourselfArgs = {
  input: AddYourselfInput;
};


export type MutationConfirmSubtopicsArgs = {
  input: ConfirmSubtopicsInput;
};


export type MutationCreateAbTestArgs = {
  input: CreateAbTestInput;
};


export type MutationCreateAgentCollectionArgs = {
  input: CreateAgentCollectionInput;
};


export type MutationCreateCustomAgentArgs = {
  input: CreateCustomAgentInput;
};


export type MutationCreateEvaluationArgs = {
  evaluationName: Scalars['String']['input'];
  fileUrl: Scalars['String']['input'];
};


export type MutationCreateFeatureRequestFeedbackArgs = {
  description: Scalars['String']['input'];
  type: FeatureRequestFeedbackType;
};


export type MutationCreateOrganizationArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateOrganizationWithOwnerArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreatePlanningProbeArgs = {
  input: CreatePlanningProbeInput;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreateProposalArgs = {
  input: CreateProposalInput;
};


export type MutationCreateSurveyWithQuestionsArgs = {
  input: CreateSurveyWithQuestionsInput;
};


export type MutationCreateUserArgs = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


export type MutationDeclineInvitationArgs = {
  token: Scalars['String']['input'];
};


export type MutationDeleteAgentCollectionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCustomAgentArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteExplorableArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationDeletePersonaArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteProjectFileArgs = {
  fileId: Scalars['ID']['input'];
};


export type MutationDeleteProjectTemplateArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteProposalArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationGenerateConnectorEnrollmentArgs = {
  agentId: Scalars['String']['input'];
};


export type MutationGeneratePlanningTasksArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  projectDescription: Scalars['String']['input'];
};


export type MutationGenerateProjectArgs = {
  input: GenerateProjectInput;
};


export type MutationGetAiMessageResponseArgs = {
  conversationId: Scalars['String']['input'];
};


export type MutationInviteToOrganizationArgs = {
  input: InviteToOrganizationInput;
};


export type MutationLeaveOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationMarkConversationViewedArgs = {
  id: Scalars['String']['input'];
};


export type MutationMarkProjectViewedArgs = {
  id: Scalars['String']['input'];
};


export type MutationMarkTwinViewedArgs = {
  id: Scalars['String']['input'];
};


export type MutationRefreshAgentSnapshotArgs = {
  agentId: Scalars['String']['input'];
  input?: InputMaybe<AgentConfigInput>;
};


export type MutationRemoveAgentFromCollectionArgs = {
  agentId: Scalars['String']['input'];
  collectionId: Scalars['String']['input'];
};


export type MutationRemoveAgentFromProjectArgs = {
  agentId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type MutationRemoveDigitalTwinFromCollectionArgs = {
  collectionId: Scalars['String']['input'];
  digitalTwinId: Scalars['String']['input'];
};


export type MutationRemoveMemberArgs = {
  organizationId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationResendInvitationArgs = {
  invitationId: Scalars['String']['input'];
};


export type MutationRetryProjectArgs = {
  projectId: Scalars['String']['input'];
};


export type MutationRevertAgentToSnapshotArgs = {
  agentId: Scalars['String']['input'];
};


export type MutationRevokeConnectorEnrollmentArgs = {
  agentId: Scalars['String']['input'];
};


export type MutationRevokeInvitationArgs = {
  invitationId: Scalars['String']['input'];
};


export type MutationSendAiMessageArgs = {
  conversationId: Scalars['String']['input'];
  message: Scalars['String']['input'];
};


export type MutationSendConnectorSetupEmailArgs = {
  agentId: Scalars['String']['input'];
};


export type MutationSetUserOrganizationArgs = {
  orgId: Scalars['String']['input'];
};


export type MutationShareAgentWithOrganizationArgs = {
  agentId: Scalars['String']['input'];
  canEdit?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationShareProjectArgs = {
  input: ShareProjectInput;
};


export type MutationStartConversationArgs = {
  demographic?: InputMaybe<Scalars['String']['input']>;
  digitalTwinIds: Array<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  type: ConversationType;
};


export type MutationSubmitOnboardingArgs = {
  input: SubmitOnboardingInput;
};


export type MutationSuggestWatchTitleArgs = {
  projectDescription: Scalars['String']['input'];
};


export type MutationTestAgentConnectionArgs = {
  agentId: Scalars['String']['input'];
};


export type MutationTransferOwnershipArgs = {
  newOwnerId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationTriggerCompactionAnalysisArgs = {
  input: TriggerCompactionAnalysisInput;
};


export type MutationTriggerInjectionAnalysisArgs = {
  input: TriggerInjectionAnalysisInput;
};


export type MutationTriggerProjectUpdateArgs = {
  input: TriggerProjectUpdateInput;
};


export type MutationUnshareAgentWithOrganizationArgs = {
  agentId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationUpdateAgentCollectionArgs = {
  id: Scalars['String']['input'];
  input: UpdateAgentCollectionInput;
};


export type MutationUpdateCustomAgentArgs = {
  id: Scalars['String']['input'];
  input: UpdateCustomAgentInput;
};


export type MutationUpdateMemberRoleArgs = {
  input: UpdateMemberRoleInput;
};


export type MutationUpdateProjectSettingsArgs = {
  input: UpdateProjectSettingsInput;
};


export type MutationUpvoteProposalArgs = {
  id: Scalars['String']['input'];
  isUpvote: Scalars['Boolean']['input'];
};


export type MutationVerifyAgentArgs = {
  agentId: Scalars['String']['input'];
};

export type NycMayorData = {
  __typename?: 'NYCMayorData';
  name: Scalars['String']['output'];
  twitterHandle: Scalars['String']['output'];
  website: Scalars['String']['output'];
};

export enum NotificationChannel {
  Email = 'EMAIL',
  InApp = 'IN_APP'
}

export enum NotificationFrequency {
  EveryUpdate = 'EVERY_UPDATE',
  Interval = 'INTERVAL',
  Never = 'NEVER',
  OnChange = 'ON_CHANGE'
}

export type Opinion = {
  __typename?: 'Opinion';
  answer: Scalars['String']['output'];
  id: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type Organization = {
  __typename?: 'Organization';
  id: Scalars['String']['output'];
  initialProjects?: Maybe<Array<Project>>;
  name: Scalars['String']['output'];
  personaAccessTypes?: Maybe<Array<DtType>>;
  surveyGroups?: Maybe<Array<SurveyGroup>>;
  users?: Maybe<Array<User>>;
};

export type OrganizationInvitation = {
  __typename?: 'OrganizationInvitation';
  createdAt: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  invitedByUser?: Maybe<User>;
  organization?: Maybe<Organization>;
  role: OrganizationRole;
  status: InvitationStatus;
  token?: Maybe<Scalars['String']['output']>;
};

export type OrganizationMember = {
  __typename?: 'OrganizationMember';
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  joinedAt: Scalars['Date']['output'];
  role: OrganizationRole;
};

export enum OrganizationRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

export type OrganizationWithMembers = {
  __typename?: 'OrganizationWithMembers';
  currentUserRole?: Maybe<OrganizationRole>;
  id: Scalars['String']['output'];
  members: Array<OrganizationMember>;
  name: Scalars['String']['output'];
  pendingInvitations: Array<OrganizationInvitation>;
  type: Scalars['String']['output'];
};

export type OrganizationWithRole = {
  __typename?: 'OrganizationWithRole';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  role: OrganizationRole;
  type: Scalars['String']['output'];
};

export type Perspective = {
  __typename?: 'Perspective';
  blurb: Scalars['String']['output'];
  comparisons?: Maybe<Array<Comparison>>;
  customAgent?: Maybe<CustomAgent>;
  digitalTwin?: Maybe<DigitalTwin>;
  id: Scalars['String']['output'];
  judgeNotes?: Maybe<Scalars['String']['output']>;
  opinions?: Maybe<Array<Opinion>>;
  qualityScore?: Maybe<Scalars['Float']['output']>;
  topic: Scalars['String']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type PlanSimilarity = {
  __typename?: 'PlanSimilarity';
  similarity?: Maybe<Scalars['Float']['output']>;
  task: Scalars['String']['output'];
};

export type PlanningTask = {
  __typename?: 'PlanningTask';
  name: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  task: Scalars['String']['output'];
};

export type PlanningTaskInput = {
  name: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
};

export type PlatformStats = {
  __typename?: 'PlatformStats';
  totalAgents: Scalars['Int']['output'];
  totalChangesDetected: Scalars['Int']['output'];
};

export type Project = {
  __typename?: 'Project';
  canManageWatch?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByYou?: Maybe<Scalars['Boolean']['output']>;
  digitalTwinCollection?: Maybe<DtCollection>;
  digitalTwinType: DtType;
  errorMessage?: Maybe<Scalars['String']['output']>;
  evalInputTokens?: Maybe<Scalars['Int']['output']>;
  evalOutputTokens?: Maybe<Scalars['Int']['output']>;
  files?: Maybe<Array<ProjectFile>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numberTwins?: Maybe<Scalars['Int']['output']>;
  perspectives?: Maybe<Array<Perspective>>;
  projectTemplateId?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Array<ProjectQuestion>>;
  sessionId?: Maybe<Scalars['String']['output']>;
  stagedAgents?: Maybe<Array<StagedAgent>>;
  status: ProjectStatus;
  subtopics?: Maybe<Array<Subtopic>>;
  subtopicsShortened?: Maybe<Array<Scalars['String']['output']>>;
  timelineProjects?: Maybe<Array<TimelineProject>>;
  topic: Scalars['String']['output'];
  topicShortened?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ProjectType>;
  userSurveyResponse?: Maybe<UserProjectSurvey>;
  viewedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProjectFile = {
  __typename?: 'ProjectFile';
  fileName: Scalars['String']['output'];
  fileSize?: Maybe<Scalars['Int']['output']>;
  fileUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Project>;
};

export type ProjectQuestion = {
  __typename?: 'ProjectQuestion';
  question: Scalars['String']['output'];
  topic: Scalars['String']['output'];
};

export type ProjectSettings = {
  __typename?: 'ProjectSettings';
  autoUpdateEnabled: Scalars['Boolean']['output'];
  burnInPeriod: Scalars['Int']['output'];
  changeDetectionEnabled: Scalars['Boolean']['output'];
  customUpdateIntervalHours?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  lastUpdatedAt?: Maybe<Scalars['String']['output']>;
  nextScheduledUpdate?: Maybe<Scalars['String']['output']>;
  notificationChannels: Array<NotificationChannel>;
  notificationEmail?: Maybe<Scalars['String']['output']>;
  notificationFrequency: NotificationFrequency;
  notificationsEnabled: Scalars['Boolean']['output'];
  notifyOnCompletion: Scalars['Boolean']['output'];
  notifyOnErrors: Scalars['Boolean']['output'];
  notifyOnNewInsights: Scalars['Boolean']['output'];
  qualityTrackingEnabled: Scalars['Boolean']['output'];
  sensitivityStdDevs: Scalars['Float']['output'];
  summaryIntervalHours?: Maybe<Scalars['Int']['output']>;
  updateFrequency: UpdateFrequency;
};

export enum ProjectStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export type ProjectSurveyResponse = {
  __typename?: 'ProjectSurveyResponse';
  question: Scalars['String']['output'];
  response: ProjectSurveyResponseType;
  topic: Scalars['String']['output'];
};

export type ProjectSurveyResponseInput = {
  question: Scalars['String']['input'];
  response: ProjectSurveyResponseType;
  topic: Scalars['String']['input'];
};

export enum ProjectSurveyResponseType {
  Agree = 'AGREE',
  Disagree = 'DISAGREE',
  Neutral = 'NEUTRAL',
  StronglyAgree = 'STRONGLY_AGREE',
  StronglyDisagree = 'STRONGLY_DISAGREE'
}

export type ProjectTemplate = {
  __typename?: 'ProjectTemplate';
  agentCount?: Maybe<Scalars['Int']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  autoUpdateEnabled?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByYou?: Maybe<Scalars['Boolean']['output']>;
  digitalTwinCollection?: Maybe<DtCollection>;
  digitalTwinType: DtType;
  hasCompletedProject?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  latestCompletedProjectId?: Maybe<Scalars['String']['output']>;
  latestProjectDate?: Maybe<Scalars['String']['output']>;
  latestProjectErrorMessage?: Maybe<Scalars['String']['output']>;
  latestProjectId?: Maybe<Scalars['String']['output']>;
  latestProjectStatus?: Maybe<ProjectStatus>;
  name: Scalars['String']['output'];
  nextScheduledUpdate?: Maybe<Scalars['String']['output']>;
  projectCount?: Maybe<Scalars['Int']['output']>;
  projects?: Maybe<Array<Project>>;
  questions?: Maybe<Array<ProjectQuestion>>;
  subtopics?: Maybe<Array<Subtopic>>;
  subtopicsShortened?: Maybe<Array<Scalars['String']['output']>>;
  topic: Scalars['String']['output'];
  topicShortened?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ProjectType>;
  updateFrequency?: Maybe<UpdateFrequency>;
};

export enum ProjectType {
  Evaluation = 'EVALUATION',
  Explorable = 'EXPLORABLE',
  PlanningProbe = 'PLANNING_PROBE'
}

export type Proposal = {
  __typename?: 'Proposal';
  createdByYou: Scalars['Boolean']['output'];
  dtType?: Maybe<DtType>;
  id: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: ProposalType;
  upvoteData: UpvoteData;
};

export enum ProposalType {
  Collection = 'COLLECTION',
  DigitalTwin = 'DIGITAL_TWIN',
  Project = 'PROJECT'
}

export type Query = {
  __typename?: 'Query';
  checkIn: CheckInResult;
  getAgentCollection?: Maybe<AgentCollection>;
  getAgentHealthSummary: AgentHealthSummary;
  getAgentMonitoringLogs: Array<AgentMonitoringLog>;
  getAgentsByProject: Array<CustomAgent>;
  getAllConversations?: Maybe<Array<Conversation>>;
  getAllDigitalTwins?: Maybe<DigitalTwinsResponse>;
  getAllDigitalTwinsBasicData?: Maybe<Array<DigitalTwin>>;
  getAllRequests?: Maybe<Array<Proposal>>;
  getAnswerSimilarities: Array<AnswerSimilarity>;
  getBehaviorChanges: Array<BehaviorChange>;
  getBehaviorChangesCount: Scalars['Int']['output'];
  getBehaviorChangesCountForDigitalTwin: Scalars['Int']['output'];
  getConnectorStatus?: Maybe<ConnectorStatusResult>;
  getConversation: Conversation;
  getCustomAgent?: Maybe<CustomAgent>;
  getDigitalTwinWithProjects: DigitalTwin;
  getDigitalTwinsByProjectId?: Maybe<Array<DigitalTwin>>;
  getDtTypeAccess?: Maybe<Array<DtType>>;
  getInvitationByToken?: Maybe<OrganizationInvitation>;
  getMonitoringTopics: Array<MonitoringTopic>;
  getMyAgentCollections: Array<AgentCollection>;
  getMyCustomAgents: Array<CustomAgent>;
  getMyOrganizationsWithRoles: Array<OrganizationWithRole>;
  getMyProjectTemplates?: Maybe<Array<ProjectTemplate>>;
  getMyProjects?: Maybe<Array<Project>>;
  getOrganizationWithMembers: OrganizationWithMembers;
  getPendingInvitations: Array<OrganizationInvitation>;
  getPerspective: Perspective;
  getPerspectiveByDtTopicProject: Perspective;
  getPlanSimilarities: Array<PlanSimilarity>;
  getPlatformStats: PlatformStats;
  getProjectSettings?: Maybe<ProjectSettings>;
  getRecentConversationsBasicData?: Maybe<Array<Conversation>>;
  getSurveyById: Survey;
  getSurveyGroupById: SurveyGroup;
  getSurveyGroupsBasicData?: Maybe<Array<SurveyGroup>>;
  getSurveyGroupsWithDetails?: Maybe<Array<SurveyGroup>>;
  getSurveys?: Maybe<Array<Survey>>;
  getTrendingProposals?: Maybe<Array<Proposal>>;
  listConnectorSessions: Array<ConnectorSession>;
  popularProjects?: Maybe<Array<Project>>;
  project?: Maybe<Project>;
  projectFiles?: Maybe<Array<ProjectFile>>;
  recentlyViewed?: Maybe<Array<RecentlyViewed>>;
  steeringRun?: Maybe<SteeringRun>;
  user?: Maybe<User>;
};


export type QueryCheckInArgs = {
  projectTemplateId: Scalars['String']['input'];
};


export type QueryGetAgentCollectionArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetAgentMonitoringLogsArgs = {
  agentId: Scalars['String']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAgentsByProjectArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetAllDigitalTwinsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Array<DtType>>;
};


export type QueryGetAllDigitalTwinsBasicDataArgs = {
  type?: InputMaybe<DtType>;
};


export type QueryGetAnswerSimilaritiesArgs = {
  agentId: Scalars['String']['input'];
  topic: Scalars['String']['input'];
  versionAId: Scalars['String']['input'];
  versionBId: Scalars['String']['input'];
};


export type QueryGetBehaviorChangesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBehaviorChangesCountArgs = {
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBehaviorChangesCountForDigitalTwinArgs = {
  digitalTwinId: Scalars['String']['input'];
};


export type QueryGetConnectorStatusArgs = {
  agentId: Scalars['String']['input'];
};


export type QueryGetConversationArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetCustomAgentArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetDigitalTwinWithProjectsArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetDigitalTwinsByProjectIdArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetInvitationByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetMonitoringTopicsArgs = {
  dtType?: InputMaybe<DtType>;
};


export type QueryGetMyCustomAgentsArgs = {
  ownedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetOrganizationWithMembersArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetPerspectiveArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetPerspectiveByDtTopicProjectArgs = {
  dtId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};


export type QueryGetPlanSimilaritiesArgs = {
  agentId: Scalars['String']['input'];
  versionAId: Scalars['String']['input'];
  versionBId: Scalars['String']['input'];
};


export type QueryGetProjectSettingsArgs = {
  projectTemplateId: Scalars['String']['input'];
};


export type QueryGetRecentConversationsBasicDataArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetSurveyByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSurveyGroupByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTrendingProposalsArgs = {
  type?: InputMaybe<ProposalType>;
};


export type QueryListConnectorSessionsArgs = {
  agentId: Scalars['String']['input'];
};


export type QueryProjectArgs = {
  id: Scalars['String']['input'];
};


export type QueryProjectFilesArgs = {
  projectId: Scalars['ID']['input'];
};


export type QuerySteeringRunArgs = {
  id: Scalars['String']['input'];
};

export type QuestionShift = {
  __typename?: 'QuestionShift';
  currentAnswer: Scalars['String']['output'];
  previousAnswer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type RecentlyViewed = {
  __typename?: 'RecentlyViewed';
  conversation?: Maybe<Conversation>;
  id: Scalars['String']['output'];
  project?: Maybe<Project>;
  twin?: Maybe<DigitalTwin>;
  type: RecentlyViewedType;
  viewedAt: Scalars['Date']['output'];
};

export enum RecentlyViewedType {
  Conversation = 'CONVERSATION',
  Project = 'PROJECT',
  Twin = 'TWIN'
}

export type ResponseCount = {
  __typename?: 'ResponseCount';
  answer: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type RetrievedContent = {
  __typename?: 'RetrievedContent';
  postedAt?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type SelectedDemographicsInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type SendrilData = {
  __typename?: 'SendrilData';
  facebookHandle?: Maybe<Scalars['String']['output']>;
  instagramHandle?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  substackHandle?: Maybe<Scalars['String']['output']>;
  tiktokHandle?: Maybe<Scalars['String']['output']>;
  twitterHandle?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  youtubeHandle?: Maybe<Scalars['String']['output']>;
};

export type ShareProjectInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  recipientEmails: Array<Scalars['String']['input']>;
};

export type ShareProjectResponse = {
  __typename?: 'ShareProjectResponse';
  failedTo: Array<Scalars['String']['output']>;
  sentTo: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type StagedAgent = {
  __typename?: 'StagedAgent';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SteeringCandidate = {
  __typename?: 'SteeringCandidate';
  isBaseline: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  similarity?: Maybe<Scalars['Float']['output']>;
};

export type SteeringRun = {
  __typename?: 'SteeringRun';
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  progressDone?: Maybe<Scalars['Int']['output']>;
  progressLabel?: Maybe<Scalars['String']['output']>;
  progressTotal?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<CompactionResult>;
  sessionId: Scalars['String']['output'];
  status: SteeringStatus;
  toolType: Scalars['String']['output'];
};

export enum SteeringStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type SubmitOnboardingInput = {
  dobDay: Scalars['Int']['input'];
  dobMonth: Scalars['Int']['input'];
  dobYear: Scalars['Int']['input'];
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  metroArea?: InputMaybe<Scalars['String']['input']>;
};

export type Subtopic = {
  __typename?: 'Subtopic';
  leftTitle?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  rightTitle?: Maybe<Scalars['String']['output']>;
};

export type Survey = {
  __typename?: 'Survey';
  baseQuestion?: Maybe<Scalars['String']['output']>;
  bountyInCents?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  questions?: Maybe<Array<SurveyQuestion>>;
  responses?: Maybe<Array<SurveyResponse>>;
  status: SurveyStatus;
  title: Scalars['String']['output'];
  type: SurveyType;
};

export type SurveyGroup = {
  __typename?: 'SurveyGroup';
  digitalTwins?: Maybe<Array<DigitalTwin>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  surveys?: Maybe<Array<Survey>>;
};

export type SurveyQuestion = {
  __typename?: 'SurveyQuestion';
  aiContext?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: SurveyQuestionType;
};

export type SurveyQuestionInput = {
  aiContext?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: SurveyQuestionType;
};

export type SurveyQuestionResponse = {
  __typename?: 'SurveyQuestionResponse';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  question: SurveyQuestion;
  response?: Maybe<Array<Scalars['String']['output']>>;
  responseCounts?: Maybe<Array<ResponseCount>>;
};

export enum SurveyQuestionType {
  MultipleChoice = 'MULTIPLE_CHOICE',
  MultiSelect = 'MULTI_SELECT',
  Scale = 'SCALE',
  Text = 'TEXT',
  TextLong = 'TEXT_LONG',
  TextNumeric = 'TEXT_NUMERIC'
}

export type SurveyResponse = {
  __typename?: 'SurveyResponse';
  createdAt?: Maybe<Scalars['String']['output']>;
  digitalTwin?: Maybe<DigitalTwin>;
  id: Scalars['String']['output'];
  questionResponses?: Maybe<Array<SurveyQuestionResponse>>;
};

export enum SurveyStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Generating = 'GENERATING',
  Inactive = 'INACTIVE',
  PendingGeneration = 'PENDING_GENERATION'
}

export enum SurveyType {
  AbTesting = 'AB_TESTING',
  Questionnaire = 'QUESTIONNAIRE'
}

export type SurveyUserData = {
  __typename?: 'SurveyUserData';
  age?: Maybe<Scalars['String']['output']>;
  childrenUnder18?: Maybe<Scalars['String']['output']>;
  education?: Maybe<Scalars['String']['output']>;
  employmentStatus?: Maybe<Scalars['String']['output']>;
  ethnicity?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  householdIncome?: Maybe<Scalars['String']['output']>;
  householdSize?: Maybe<Scalars['Int']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type TimelineProject = {
  __typename?: 'TimelineProject';
  dateCreated: Scalars['String']['output'];
  evalInputTokens?: Maybe<Scalars['Int']['output']>;
  evalOutputTokens?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
};

export type TriggerCompactionAnalysisInput = {
  agentId: Scalars['String']['input'];
  referenceVersionId?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
  updateWatch?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TriggerInjectionAnalysisInput = {
  agentId: Scalars['String']['input'];
  referenceVersionId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

export type TriggerProjectUpdateInput = {
  projectTemplateId: Scalars['String']['input'];
};

export type UpdateAgentCollectionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomAgentInput = {
  apiAuthType?: InputMaybe<Scalars['String']['input']>;
  apiCredentials?: InputMaybe<Scalars['String']['input']>;
  apiEndpoint?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  maxTokens?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  snapshotEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<CustomAgentStatus>;
  systemPrompt?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
};

export enum UpdateFrequency {
  Custom = 'CUSTOM',
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Manual = 'MANUAL',
  SixHours = 'SIX_HOURS',
  ThirtyMinutes = 'THIRTY_MINUTES',
  Weekly = 'WEEKLY'
}

export type UpdateMemberRoleInput = {
  organizationId: Scalars['String']['input'];
  role: OrganizationRole;
  userId: Scalars['String']['input'];
};

export type UpdateProjectSettingsInput = {
  autoUpdateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  burnInPeriod?: InputMaybe<Scalars['Int']['input']>;
  changeDetectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  customUpdateIntervalHours?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationChannels?: InputMaybe<Array<NotificationChannel>>;
  notificationEmail?: InputMaybe<Scalars['String']['input']>;
  notificationFrequency?: InputMaybe<NotificationFrequency>;
  notificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnCompletion?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnErrors?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnNewInsights?: InputMaybe<Scalars['Boolean']['input']>;
  projectTemplateId: Scalars['String']['input'];
  qualityTrackingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sensitivityStdDevs?: InputMaybe<Scalars['Float']['input']>;
  summaryIntervalHours?: InputMaybe<Scalars['Int']['input']>;
  updateFrequency?: InputMaybe<UpdateFrequency>;
};

export type UpvoteData = {
  __typename?: 'UpvoteData';
  count: Scalars['Int']['output'];
  upvotedByYou: Scalars['Boolean']['output'];
};

export type UsageLimits = {
  __typename?: 'UsageLimits';
  canCreateAgent: Scalars['Boolean']['output'];
  canCreateProject: Scalars['Boolean']['output'];
  changesDetectedThisMonth: Scalars['Int']['output'];
  currentAgentCount: Scalars['Int']['output'];
  currentProjectCount: Scalars['Int']['output'];
  maxAgents: Scalars['Int']['output'];
  maxProjects: Scalars['Int']['output'];
  plan: UserPlan;
  updateFrequencyInHours: Scalars['Int']['output'];
};

export type User = {
  __typename?: 'User';
  canCreateProject?: Maybe<Scalars['Boolean']['output']>;
  canSendMessage?: Maybe<Scalars['Boolean']['output']>;
  currentOrganization?: Maybe<Organization>;
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  hasOnboarded?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  organizations?: Maybe<Array<Organization>>;
  plan?: Maybe<UserPlan>;
  tokenConfiguration?: Maybe<UserTokenUsageConfiguration>;
  tosVerified: Scalars['Boolean']['output'];
  usageLimits?: Maybe<UsageLimits>;
};

export enum UserPlan {
  Free = 'FREE',
  Pro = 'PRO',
  Research = 'RESEARCH',
  Team = 'TEAM'
}

export type UserProjectSurvey = {
  __typename?: 'UserProjectSurvey';
  id: Scalars['String']['output'];
  responses: Array<ProjectSurveyResponse>;
};

export type UserTokenUsageConfiguration = {
  __typename?: 'UserTokenUsageConfiguration';
  id: Scalars['String']['output'];
  monthlyTokenLimit: Scalars['Int']['output'];
  resetDate: Scalars['String']['output'];
  tokensUsedThisMonth: Scalars['Int']['output'];
};

export type GetPlatformStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlatformStatsQuery = { __typename?: 'Query', getPlatformStats: { __typename?: 'PlatformStats', totalAgents: number, totalChangesDetected: number } };

export type CreateUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  uid: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'User', id: string, fullName: string, email: string, tosVerified: boolean, hasOnboarded?: boolean | null, currentOrganization?: { __typename?: 'Organization', id: string, name: string, personaAccessTypes?: Array<DtType> | null, initialProjects?: Array<{ __typename?: 'Project', id: string, topic: string, name: string }> | null } | null } | null };

export type AcceptTosMutationVariables = Exact<{ [key: string]: never; }>;


export type AcceptTosMutation = { __typename?: 'Mutation', acceptTos?: { __typename?: 'User', id: string, tosVerified: boolean } | null };

export type SubmitOnboardingMutationVariables = Exact<{
  input: SubmitOnboardingInput;
}>;


export type SubmitOnboardingMutation = { __typename?: 'Mutation', submitOnboarding?: { __typename?: 'User', id: string, hasOnboarded?: boolean | null } | null };

export type StartConversationMutationVariables = Exact<{
  digitalTwinIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  type: ConversationType;
  projectId?: InputMaybe<Scalars['String']['input']>;
  demographic?: InputMaybe<Scalars['String']['input']>;
}>;


export type StartConversationMutation = { __typename?: 'Mutation', startConversation: { __typename?: 'Conversation', id: string, title: string, digitalTwins: Array<{ __typename?: 'DigitalTwin', id: string, name: string }> } };

export type GetAllDigitalTwinsBasicDataQueryVariables = Exact<{
  type: DtType;
}>;


export type GetAllDigitalTwinsBasicDataQuery = { __typename?: 'Query', getAllDigitalTwinsBasicData?: Array<{ __typename?: 'DigitalTwin', id: string, name: string }> | null };

export type GetDtTypeAccessQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDtTypeAccessQuery = { __typename?: 'Query', getDtTypeAccess?: Array<DtType> | null };

export type SendAiMessageMutationVariables = Exact<{
  message: Scalars['String']['input'];
  conversationId: Scalars['String']['input'];
}>;


export type SendAiMessageMutation = { __typename?: 'Mutation', sendAIMessage: { __typename?: 'Conversation', id: string, messages?: Array<{ __typename?: 'Message', id: string, timestamp: string, content: string, userSender: boolean, digitalTwin?: { __typename?: 'DigitalTwin', id: string, name: string } | null, retrievedContent?: Array<{ __typename?: 'RetrievedContent', text?: string | null, source?: string | null, postedAt?: string | null, score?: number | null }> | null }> | null } };

export type GetAiMessageResponseMutationVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;


export type GetAiMessageResponseMutation = { __typename?: 'Mutation', getAIMessageResponse: { __typename?: 'Conversation', id: string, title: string, messages?: Array<{ __typename?: 'Message', id: string, timestamp: string, content: string, userSender: boolean, digitalTwin?: { __typename?: 'DigitalTwin', id: string, name: string } | null, retrievedContent?: Array<{ __typename?: 'RetrievedContent', text?: string | null, source?: string | null, postedAt?: string | null, score?: number | null }> | null }> | null } };

export type ConversationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConversationsQuery = { __typename?: 'Query', getDtTypeAccess?: Array<DtType> | null, getAllConversations?: Array<{ __typename?: 'Conversation', id: string, title: string, updatedAt?: string | null, demographic?: string | null, type: ConversationType, digitalTwins: Array<{ __typename?: 'DigitalTwin', id: string, name: string, type: DtType }> }> | null };

export type GetDigitalTwinsByProjectIdQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetDigitalTwinsByProjectIdQuery = { __typename?: 'Query', getDigitalTwinsByProjectId?: Array<{ __typename?: 'DigitalTwin', id: string, name: string }> | null };

export type GetConversationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetConversationQuery = { __typename?: 'Query', getConversation: { __typename?: 'Conversation', id: string, title: string, projectId?: string | null, projectName?: string | null, updatedAt?: string | null, demographic?: string | null, type: ConversationType, digitalTwins: Array<{ __typename?: 'DigitalTwin', id: string, name: string, type: DtType }>, messages?: Array<{ __typename?: 'Message', id: string, timestamp: string, content: string, userSender: boolean, digitalTwin?: { __typename?: 'DigitalTwin', id: string, name: string } | null, retrievedContent?: Array<{ __typename?: 'RetrievedContent', text?: string | null, source?: string | null, postedAt?: string | null, score?: number | null }> | null }> | null } };

export type MarkConversationViewedMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MarkConversationViewedMutation = { __typename?: 'Mutation', markConversationViewed: { __typename?: 'Conversation', id: string, title: string, updatedAt?: string | null } };

export type ConversationDataFragment = { __typename?: 'Conversation', id: string, title: string, projectId?: string | null, projectName?: string | null, updatedAt?: string | null, demographic?: string | null, type: ConversationType, digitalTwins: Array<{ __typename?: 'DigitalTwin', id: string, name: string, type: DtType }>, messages?: Array<{ __typename?: 'Message', id: string, timestamp: string, content: string, userSender: boolean, digitalTwin?: { __typename?: 'DigitalTwin', id: string, name: string } | null, retrievedContent?: Array<{ __typename?: 'RetrievedContent', text?: string | null, source?: string | null, postedAt?: string | null, score?: number | null }> | null }> | null };

export type MessageDataFragment = { __typename?: 'Message', id: string, timestamp: string, content: string, userSender: boolean, digitalTwin?: { __typename?: 'DigitalTwin', id: string, name: string } | null, retrievedContent?: Array<{ __typename?: 'RetrievedContent', text?: string | null, source?: string | null, postedAt?: string | null, score?: number | null }> | null };

export type RetrievedContentDataFragment = { __typename?: 'RetrievedContent', text?: string | null, source?: string | null, postedAt?: string | null, score?: number | null };

export type DashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardQuery = { __typename?: 'Query', getTrendingProposals?: Array<{ __typename?: 'Proposal', id: string, title: string, notes?: string | null, type: ProposalType, createdByYou: boolean, dtType?: DtType | null, upvoteData: { __typename?: 'UpvoteData', count: number, upvotedByYou: boolean } }> | null, getMyProjects?: Array<{ __typename?: 'Project', id: string, topicShortened?: string | null, subtopicsShortened?: Array<string> | null, digitalTwinType: DtType, createdAt?: string | null }> | null, recentlyViewed?: Array<{ __typename?: 'RecentlyViewed', id: string, type: RecentlyViewedType, project?: { __typename?: 'Project', id: string, topicShortened?: string | null, topic: string, digitalTwinType: DtType, subtopicsShortened?: Array<string> | null } | null, twin?: { __typename?: 'DigitalTwin', id: string, name: string, type: DtType } | null, conversation?: { __typename?: 'Conversation', id: string, title: string, type: ConversationType, digitalTwins: Array<{ __typename?: 'DigitalTwin', id: string, name: string }> } | null }> | null, popularProjects?: Array<{ __typename?: 'Project', id: string, topicShortened?: string | null, topic: string, digitalTwinType: DtType, subtopicsShortened?: Array<string> | null }> | null, getAllConversations?: Array<{ __typename?: 'Conversation', id: string, title: string, type: ConversationType, demographic?: string | null, updatedAt?: string | null, projectId?: string | null, projectName?: string | null, digitalTwins: Array<{ __typename?: 'DigitalTwin', id: string, name: string }> }> | null };

export type MyProjectDataFragment = { __typename?: 'Project', id: string, topicShortened?: string | null, subtopicsShortened?: Array<string> | null, digitalTwinType: DtType, createdAt?: string | null };

export type RecentlyViewedDataFragment = { __typename?: 'RecentlyViewed', id: string, type: RecentlyViewedType, project?: { __typename?: 'Project', id: string, topicShortened?: string | null, topic: string, digitalTwinType: DtType, subtopicsShortened?: Array<string> | null } | null, twin?: { __typename?: 'DigitalTwin', id: string, name: string, type: DtType } | null, conversation?: { __typename?: 'Conversation', id: string, title: string, type: ConversationType, digitalTwins: Array<{ __typename?: 'DigitalTwin', id: string, name: string }> } | null };

export type DashboardTwinDataFragment = { __typename?: 'DigitalTwin', id: string, name: string, type: DtType };

export type DashboardConversationDataFragment = { __typename?: 'Conversation', id: string, title: string, type: ConversationType, digitalTwins: Array<{ __typename?: 'DigitalTwin', id: string, name: string }> };

export type DashboardProjectDataFragment = { __typename?: 'Project', id: string, topicShortened?: string | null, topic: string, digitalTwinType: DtType, subtopicsShortened?: Array<string> | null };

export type ProposalDataFragment = { __typename?: 'Proposal', id: string, title: string, notes?: string | null, type: ProposalType, createdByYou: boolean, dtType?: DtType | null, upvoteData: { __typename?: 'UpvoteData', count: number, upvotedByYou: boolean } };

export type UpvoteProposalMutationVariables = Exact<{
  id: Scalars['String']['input'];
  isUpvote: Scalars['Boolean']['input'];
}>;


export type UpvoteProposalMutation = { __typename?: 'Mutation', upvoteProposal: { __typename?: 'Proposal', id: string, title: string, notes?: string | null, type: ProposalType, createdByYou: boolean, dtType?: DtType | null, upvoteData: { __typename?: 'UpvoteData', count: number, upvotedByYou: boolean } } };

export type MyConversationDataFragment = { __typename?: 'Conversation', id: string, title: string, type: ConversationType, demographic?: string | null, updatedAt?: string | null, projectId?: string | null, projectName?: string | null, digitalTwins: Array<{ __typename?: 'DigitalTwin', id: string, name: string }> };

export type DigitalTwinsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Array<DtType> | DtType>;
}>;


export type DigitalTwinsQuery = { __typename?: 'Query', getAllDigitalTwins?: { __typename?: 'DigitalTwinsResponse', totalCount: number, twins: Array<{ __typename?: 'DigitalTwin', id: string, name: string, type: DtType, congressData?: { __typename?: 'CongressData', chamber: string, party: string, state: string, linkedinHandle?: string | null, twitterHandle?: string | null } | null, sendrilData?: { __typename?: 'SendrilData', name: string, twitterHandle?: string | null, tiktokHandle?: string | null, instagramHandle?: string | null, youtubeHandle?: string | null, facebookHandle?: string | null, substackHandle?: string | null, website?: string | null } | null, earlyStageVcData?: { __typename?: 'EarlyStageVcData', firm: string, title?: string | null, linkedinHandle?: string | null, twitterHandle?: string | null, location?: string | null } | null, fortuneCeoData?: { __typename?: 'FortuneCeoData', company: string, linkedinHandle?: string | null, twitterHandle?: string | null, industry: string } | null, modelData?: { __typename?: 'ModelData', name?: string | null, score?: number | null, baseModel?: string | null, systemPrompt?: string | null, temperature?: number | null, maxNewTokens?: number | null, numReturnSequences?: number | null } | null, moviesSimpleData?: { __typename?: 'MoviesSimpleData', name: string, gender: string, age: string } | null, moviesMediumFullData?: { __typename?: 'MoviesMediumFullData', name: string, gender: string, age: string, race: string, region: string, education: string, employment: string, income: string, ethnicity: string, locationType: string, childrenData: string } | null, fedMemberData?: { __typename?: 'FedMemberData', name: string, bio?: string | null, bioSource?: string | null, title: string, office: string, bank: string, isVoting: boolean, isChair: boolean, isGovernor: boolean } | null, projects?: Array<{ __typename?: 'Project', id: string, name: string, topic: string, topicShortened?: string | null, digitalTwinType: DtType, status: ProjectStatus }> | null }> } | null };

export type GetDigitalTwinQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetDigitalTwinQuery = { __typename?: 'Query', getDigitalTwinWithProjects: { __typename?: 'DigitalTwin', id: string, name: string, type: DtType, blurb?: string | null, congressData?: { __typename?: 'CongressData', chamber: string, party: string, state: string, linkedinHandle?: string | null, twitterHandle?: string | null } | null, sendrilData?: { __typename?: 'SendrilData', name: string, twitterHandle?: string | null, tiktokHandle?: string | null, instagramHandle?: string | null, youtubeHandle?: string | null, facebookHandle?: string | null, substackHandle?: string | null, website?: string | null } | null, earlyStageVcData?: { __typename?: 'EarlyStageVcData', firm: string, title?: string | null, linkedinHandle?: string | null, twitterHandle?: string | null, location?: string | null } | null, fortuneCeoData?: { __typename?: 'FortuneCeoData', company: string, linkedinHandle?: string | null, twitterHandle?: string | null, industry: string } | null, modelData?: { __typename?: 'ModelData', name?: string | null, score?: number | null, baseModel?: string | null, systemPrompt?: string | null, temperature?: number | null, maxNewTokens?: number | null, numReturnSequences?: number | null } | null, moviesMediumFullData?: { __typename?: 'MoviesMediumFullData', name: string, gender: string, age: string, race: string, region: string, education: string, employment: string, income: string, ethnicity: string, locationType: string, childrenData: string } | null, moviesSimpleData?: { __typename?: 'MoviesSimpleData', name: string, gender: string, age: string } | null, fedMemberData?: { __typename?: 'FedMemberData', name: string, bio?: string | null, bioSource?: string | null, title: string, office: string, bank: string, isVoting: boolean, isChair: boolean, isGovernor: boolean } | null, projects?: Array<{ __typename?: 'Project', id: string, topic: string, name: string, createdAt?: string | null, digitalTwinType: DtType, viewedAt?: Date | null, subtopicsShortened?: Array<string> | null, topicShortened?: string | null, subtopics?: Array<{ __typename?: 'Subtopic', name: string }> | null }> | null } };

export type DigitalTwinViewDataFragment = { __typename?: 'DigitalTwin', id: string, name: string, type: DtType, blurb?: string | null, congressData?: { __typename?: 'CongressData', chamber: string, party: string, state: string, linkedinHandle?: string | null, twitterHandle?: string | null } | null, sendrilData?: { __typename?: 'SendrilData', name: string, twitterHandle?: string | null, tiktokHandle?: string | null, instagramHandle?: string | null, youtubeHandle?: string | null, facebookHandle?: string | null, substackHandle?: string | null, website?: string | null } | null, earlyStageVcData?: { __typename?: 'EarlyStageVcData', firm: string, title?: string | null, linkedinHandle?: string | null, twitterHandle?: string | null, location?: string | null } | null, fortuneCeoData?: { __typename?: 'FortuneCeoData', company: string, linkedinHandle?: string | null, twitterHandle?: string | null, industry: string } | null, modelData?: { __typename?: 'ModelData', name?: string | null, score?: number | null, baseModel?: string | null, systemPrompt?: string | null, temperature?: number | null, maxNewTokens?: number | null, numReturnSequences?: number | null } | null, moviesMediumFullData?: { __typename?: 'MoviesMediumFullData', name: string, gender: string, age: string, race: string, region: string, education: string, employment: string, income: string, ethnicity: string, locationType: string, childrenData: string } | null, moviesSimpleData?: { __typename?: 'MoviesSimpleData', name: string, gender: string, age: string } | null, fedMemberData?: { __typename?: 'FedMemberData', name: string, bio?: string | null, bioSource?: string | null, title: string, office: string, bank: string, isVoting: boolean, isChair: boolean, isGovernor: boolean } | null, projects?: Array<{ __typename?: 'Project', id: string, topic: string, name: string, createdAt?: string | null, digitalTwinType: DtType, viewedAt?: Date | null, subtopicsShortened?: Array<string> | null, topicShortened?: string | null, subtopics?: Array<{ __typename?: 'Subtopic', name: string }> | null }> | null };

export type SendrilMetadataFragment = { __typename?: 'SendrilData', name: string, twitterHandle?: string | null, tiktokHandle?: string | null, instagramHandle?: string | null, youtubeHandle?: string | null, facebookHandle?: string | null, substackHandle?: string | null, website?: string | null };

export type CongressMetadataFragment = { __typename?: 'CongressData', chamber: string, party: string, state: string, linkedinHandle?: string | null, twitterHandle?: string | null };

export type EarlyStageVcMetadataFragment = { __typename?: 'EarlyStageVcData', firm: string, title?: string | null, linkedinHandle?: string | null, twitterHandle?: string | null, location?: string | null };

export type FortuneCeoMetadataFragment = { __typename?: 'FortuneCeoData', company: string, linkedinHandle?: string | null, twitterHandle?: string | null, industry: string };

export type ModelMetadataFragment = { __typename?: 'ModelData', name?: string | null, score?: number | null, baseModel?: string | null, systemPrompt?: string | null, temperature?: number | null, maxNewTokens?: number | null, numReturnSequences?: number | null };

export type MoviesMediumFullMetadataFragment = { __typename?: 'MoviesMediumFullData', name: string, gender: string, age: string, race: string, region: string, education: string, employment: string, income: string, ethnicity: string, locationType: string, childrenData: string };

export type MoviesSimpleMetadataFragment = { __typename?: 'MoviesSimpleData', name: string, gender: string, age: string };

export type FedMemberMetadataFragment = { __typename?: 'FedMemberData', name: string, bio?: string | null, bioSource?: string | null, title: string, office: string, bank: string, isVoting: boolean, isChair: boolean, isGovernor: boolean };

export type GetBehaviorChangesCountForDigitalTwinQueryVariables = Exact<{
  digitalTwinId: Scalars['String']['input'];
}>;


export type GetBehaviorChangesCountForDigitalTwinQuery = { __typename?: 'Query', getBehaviorChangesCountForDigitalTwin: number };

export type CreateEvaluationMutationVariables = Exact<{
  evaluationName: Scalars['String']['input'];
  fileUrl: Scalars['String']['input'];
}>;


export type CreateEvaluationMutation = { __typename?: 'Mutation', createEvaluation: { __typename?: 'CreateEvaluationResponse', success: boolean, evaluationId?: string | null, errorMessage?: string | null, errorCode?: string | null } };

export type DeleteExplorableMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteExplorableMutation = { __typename?: 'Mutation', deleteExplorable: boolean };

export type DeletePersonaMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeletePersonaMutation = { __typename?: 'Mutation', deletePersona: boolean };

export type CreateOrganizationMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'Organization', id: string, name: string } };

export type AddUserToOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type AddUserToOrganizationMutation = { __typename?: 'Mutation', addUserToOrganization: boolean };

export type AddPersonaToCollectionMutationVariables = Exact<{
  collectionId: Scalars['String']['input'];
  personaId: Scalars['String']['input'];
}>;


export type AddPersonaToCollectionMutation = { __typename?: 'Mutation', addPersonaToCollection: boolean };

export type ProfileDropdownQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileDropdownQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, canSendMessage?: boolean | null, currentOrganization?: { __typename?: 'Organization', id: string, name: string } | null, organizations?: Array<{ __typename?: 'Organization', id: string, name: string }> | null, tokenConfiguration?: { __typename?: 'UserTokenUsageConfiguration', id: string, monthlyTokenLimit: number, tokensUsedThisMonth: number, resetDate: string } | null } | null };

export type SetUserOrganizationMutationVariables = Exact<{
  orgId: Scalars['String']['input'];
}>;


export type SetUserOrganizationMutation = { __typename?: 'Mutation', setUserOrganization?: { __typename?: 'User', id: string, currentOrganization?: { __typename?: 'Organization', id: string, name: string } | null } | null };

export type GetMyCustomAgentsQueryVariables = Exact<{
  ownedOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMyCustomAgentsQuery = { __typename?: 'Query', getMyCustomAgents: Array<{ __typename?: 'CustomAgent', id: string, name: string, description?: string | null, avatarUrl?: string | null, organizationId?: string | null, status: CustomAgentStatus, createdAt: string, lastConnectionTestAt?: string | null, apiEndpoint: string, apiAuthType: string, systemPrompt?: string | null, temperature?: number | null, maxTokens?: number | null, isOwner: boolean, canEdit: boolean, shareCount: number, projectCount: number, connectionType: ConnectionType, connectorStatus?: ConnectorStatus | null, lastConnectorPingAt?: string | null, gatewayHealth?: GatewayHealth | null, gatewayHealthReason?: string | null, owner?: { __typename?: 'AgentOwner', id: string, fullName: string, email: string } | null, orgShares?: Array<{ __typename?: 'AgentOrgShare', organizationId: string, organizationName: string, canEdit: boolean }> | null }> };

export type GetCustomAgentQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCustomAgentQuery = { __typename?: 'Query', getCustomAgent?: { __typename?: 'CustomAgent', id: string, name: string, description?: string | null, avatarUrl?: string | null, organizationId?: string | null, status: CustomAgentStatus, createdAt: string, lastConnectionTestAt?: string | null, apiEndpoint: string, apiAuthType: string, systemPrompt?: string | null, temperature?: number | null, maxTokens?: number | null, isOwner: boolean, canEdit: boolean, shareCount: number, projectCount: number, snapshotEnabled: boolean, connectionType: ConnectionType, connectorStatus?: ConnectorStatus | null, lastConnectorPingAt?: string | null, gatewayHealth?: GatewayHealth | null, gatewayHealthReason?: string | null, owner?: { __typename?: 'AgentOwner', id: string, fullName: string, email: string } | null, snapshot?: { __typename?: 'CustomAgentSnapshot', id: string, createdAt: string, updatedAt: string, systemPrompt?: string | null, temperature?: number | null, maxTokens?: number | null, apiEndpoint: string, apiAuthType: string } | null, orgShares?: Array<{ __typename?: 'AgentOrgShare', organizationId: string, organizationName: string, canEdit: boolean }> | null } | null };

export type GetAgentCreationLimitsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgentCreationLimitsQuery = { __typename?: 'Query', user?: { __typename?: 'User', usageLimits?: { __typename?: 'UsageLimits', maxAgents: number, currentAgentCount: number, canCreateAgent: boolean } | null } | null };

export type GetAgentMonitoringLogsQueryVariables = Exact<{
  agentId: Scalars['String']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAgentMonitoringLogsQuery = { __typename?: 'Query', getAgentMonitoringLogs: Array<{ __typename?: 'AgentMonitoringLog', id: string, scanDate: string, status: string, responseTime?: number | null, errorMessage?: string | null, behaviorFlags?: string | null }> };

export type GetAgentHealthSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgentHealthSummaryQuery = { __typename?: 'Query', getAgentHealthSummary: { __typename?: 'AgentHealthSummary', healthy: number, warning: number, error: number, total: number } };

export type GetAgentsByProjectQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetAgentsByProjectQuery = { __typename?: 'Query', getAgentsByProject: Array<{ __typename?: 'CustomAgent', id: string, name: string, description?: string | null, avatarUrl?: string | null, status: CustomAgentStatus, lastConnectionTestAt?: string | null, isOwner: boolean, canEdit: boolean, shareCount: number, connectionType: ConnectionType, connectorStatus?: ConnectorStatus | null, lastConnectorPingAt?: string | null, gatewayHealth?: GatewayHealth | null, gatewayHealthReason?: string | null, orgShares?: Array<{ __typename?: 'AgentOrgShare', organizationId: string, organizationName: string, canEdit: boolean }> | null }> };

export type CreateCustomAgentMutationVariables = Exact<{
  input: CreateCustomAgentInput;
}>;


export type CreateCustomAgentMutation = { __typename?: 'Mutation', createCustomAgent: { __typename?: 'CustomAgent', id: string, name: string, description?: string | null, avatarUrl?: string | null, organizationId?: string | null, status: CustomAgentStatus, lastConnectionTestAt?: string | null, apiEndpoint: string, apiAuthType: string, systemPrompt?: string | null, temperature?: number | null, maxTokens?: number | null, isOwner: boolean, canEdit: boolean, shareCount: number, projectCount: number, connectionType: ConnectionType, connectorStatus?: ConnectorStatus | null, lastConnectorPingAt?: string | null, gatewayHealth?: GatewayHealth | null, gatewayHealthReason?: string | null, orgShares?: Array<{ __typename?: 'AgentOrgShare', organizationId: string, organizationName: string, canEdit: boolean }> | null } };

export type UpdateCustomAgentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateCustomAgentInput;
}>;


export type UpdateCustomAgentMutation = { __typename?: 'Mutation', updateCustomAgent: { __typename?: 'CustomAgent', id: string, name: string, description?: string | null, avatarUrl?: string | null, organizationId?: string | null, status: CustomAgentStatus, lastConnectionTestAt?: string | null, apiEndpoint: string, apiAuthType: string, systemPrompt?: string | null, temperature?: number | null, maxTokens?: number | null, isOwner: boolean, canEdit: boolean, shareCount: number, projectCount: number, snapshotEnabled: boolean, connectionType: ConnectionType, connectorStatus?: ConnectorStatus | null, lastConnectorPingAt?: string | null, gatewayHealth?: GatewayHealth | null, gatewayHealthReason?: string | null, snapshot?: { __typename?: 'CustomAgentSnapshot', id: string, createdAt: string, updatedAt: string } | null, orgShares?: Array<{ __typename?: 'AgentOrgShare', organizationId: string, organizationName: string, canEdit: boolean }> | null } };

export type DeleteCustomAgentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteCustomAgentMutation = { __typename?: 'Mutation', deleteCustomAgent: boolean };

export type ShareAgentWithOrganizationMutationVariables = Exact<{
  agentId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  canEdit?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ShareAgentWithOrganizationMutation = { __typename?: 'Mutation', shareAgentWithOrganization: { __typename?: 'CustomAgent', id: string, shareCount: number, orgShares?: Array<{ __typename?: 'AgentOrgShare', organizationId: string, organizationName: string, canEdit: boolean }> | null } };

export type UnshareAgentWithOrganizationMutationVariables = Exact<{
  agentId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
}>;


export type UnshareAgentWithOrganizationMutation = { __typename?: 'Mutation', unshareAgentWithOrganization: { __typename?: 'CustomAgent', id: string, shareCount: number, orgShares?: Array<{ __typename?: 'AgentOrgShare', organizationId: string, organizationName: string, canEdit: boolean }> | null } };

export type AddAgentToProjectMutationVariables = Exact<{
  agentId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
}>;


export type AddAgentToProjectMutation = { __typename?: 'Mutation', addAgentToProject: boolean };

export type RemoveAgentFromProjectMutationVariables = Exact<{
  agentId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
}>;


export type RemoveAgentFromProjectMutation = { __typename?: 'Mutation', removeAgentFromProject: boolean };

export type VerifyAgentMutationVariables = Exact<{
  agentId: Scalars['String']['input'];
}>;


export type VerifyAgentMutation = { __typename?: 'Mutation', verifyAgent: { __typename?: 'CustomAgent', id: string, status: CustomAgentStatus, lastConnectionTestAt?: string | null } };

export type GetMyAgentCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyAgentCollectionsQuery = { __typename?: 'Query', getMyAgentCollections: Array<{ __typename?: 'AgentCollection', id: string, name: string, description?: string | null, createdAt: string, updatedAt: string, agentCount: number, digitalTwinCount: number, agents: Array<{ __typename?: 'CustomAgent', id: string, name: string, status: CustomAgentStatus, connectionType: ConnectionType, connectorStatus?: ConnectorStatus | null, gatewayHealth?: GatewayHealth | null, gatewayHealthReason?: string | null }>, digitalTwins: Array<{ __typename?: 'DigitalTwin', id: string, type: DtType }> }> };

export type GetAgentCollectionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAgentCollectionQuery = { __typename?: 'Query', getAgentCollection?: { __typename?: 'AgentCollection', id: string, name: string, description?: string | null, createdAt: string, updatedAt: string, agentCount: number, digitalTwinCount: number, agents: Array<{ __typename?: 'CustomAgent', id: string, name: string, description?: string | null, avatarUrl?: string | null, status: CustomAgentStatus, lastConnectionTestAt?: string | null, isOwner: boolean, canEdit: boolean, connectionType: ConnectionType, connectorStatus?: ConnectorStatus | null, lastConnectorPingAt?: string | null, gatewayHealth?: GatewayHealth | null, gatewayHealthReason?: string | null }>, digitalTwins: Array<{ __typename?: 'DigitalTwin', id: string, name: string, type: DtType }> } | null };

export type CreateAgentCollectionMutationVariables = Exact<{
  input: CreateAgentCollectionInput;
}>;


export type CreateAgentCollectionMutation = { __typename?: 'Mutation', createAgentCollection: { __typename?: 'AgentCollection', id: string, name: string, description?: string | null, createdAt: string, updatedAt: string, agentCount: number } };

export type UpdateAgentCollectionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateAgentCollectionInput;
}>;


export type UpdateAgentCollectionMutation = { __typename?: 'Mutation', updateAgentCollection: { __typename?: 'AgentCollection', id: string, name: string, description?: string | null, createdAt: string, updatedAt: string, agentCount: number } };

export type DeleteAgentCollectionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteAgentCollectionMutation = { __typename?: 'Mutation', deleteAgentCollection: boolean };

export type AddAgentToCollectionMutationVariables = Exact<{
  collectionId: Scalars['String']['input'];
  agentId: Scalars['String']['input'];
}>;


export type AddAgentToCollectionMutation = { __typename?: 'Mutation', addAgentToCollection: { __typename?: 'AgentCollection', id: string, name: string, agentCount: number } };

export type RemoveAgentFromCollectionMutationVariables = Exact<{
  collectionId: Scalars['String']['input'];
  agentId: Scalars['String']['input'];
}>;


export type RemoveAgentFromCollectionMutation = { __typename?: 'Mutation', removeAgentFromCollection: { __typename?: 'AgentCollection', id: string, name: string, agentCount: number } };

export type AddDigitalTwinToCollectionMutationVariables = Exact<{
  collectionId: Scalars['String']['input'];
  digitalTwinId: Scalars['String']['input'];
}>;


export type AddDigitalTwinToCollectionMutation = { __typename?: 'Mutation', addDigitalTwinToCollection: { __typename?: 'AgentCollection', id: string, name: string, agentCount: number, digitalTwinCount: number } };

export type RemoveDigitalTwinFromCollectionMutationVariables = Exact<{
  collectionId: Scalars['String']['input'];
  digitalTwinId: Scalars['String']['input'];
}>;


export type RemoveDigitalTwinFromCollectionMutation = { __typename?: 'Mutation', removeDigitalTwinFromCollection: { __typename?: 'AgentCollection', id: string, name: string, agentCount: number, digitalTwinCount: number } };

export type RevertAgentToSnapshotMutationVariables = Exact<{
  agentId: Scalars['String']['input'];
}>;


export type RevertAgentToSnapshotMutation = { __typename?: 'Mutation', revertAgentToSnapshot: { __typename?: 'CustomAgent', id: string, systemPrompt?: string | null, temperature?: number | null, maxTokens?: number | null, snapshotEnabled: boolean, snapshot?: { __typename?: 'CustomAgentSnapshot', id: string, createdAt: string, updatedAt: string } | null } };

export type RefreshAgentSnapshotMutationVariables = Exact<{
  agentId: Scalars['String']['input'];
}>;


export type RefreshAgentSnapshotMutation = { __typename?: 'Mutation', refreshAgentSnapshot: { __typename?: 'CustomAgentSnapshot', id: string, createdAt: string, updatedAt: string } };

export type GenerateConnectorEnrollmentMutationVariables = Exact<{
  agentId: Scalars['String']['input'];
}>;


export type GenerateConnectorEnrollmentMutation = { __typename?: 'Mutation', generateConnectorEnrollment: { __typename?: 'ConnectorEnrollmentResult', enrollmentCode: string, expiresAt: string, instructions: string } };

export type RevokeConnectorEnrollmentMutationVariables = Exact<{
  agentId: Scalars['String']['input'];
}>;


export type RevokeConnectorEnrollmentMutation = { __typename?: 'Mutation', revokeConnectorEnrollment: boolean };

export type GetConnectorStatusQueryVariables = Exact<{
  agentId: Scalars['String']['input'];
}>;


export type GetConnectorStatusQuery = { __typename?: 'Query', getConnectorStatus?: { __typename?: 'ConnectorStatusResult', status: string, lastPingAt?: string | null, connectedSince?: string | null, enrollmentStatus?: ConnectorEnrollmentStatus | null, gatewayHealth?: GatewayHealth | null, gatewayHealthReason?: string | null } | null };

export type ProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, canCreateProject?: boolean | null, canSendMessage?: boolean | null, currentOrganization?: { __typename?: 'Organization', id: string, initialProjects?: Array<{ __typename?: 'Project', id: string, numberTwins?: number | null, type?: ProjectType | null, createdByYou?: boolean | null, topic: string, name: string, status: ProjectStatus, createdAt?: string | null, digitalTwinType: DtType, viewedAt?: Date | null, subtopicsShortened?: Array<string> | null, topicShortened?: string | null, subtopics?: Array<{ __typename?: 'Subtopic', name: string }> | null }> | null } | null } | null };

export type ProjectTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectTemplatesQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, canCreateProject?: boolean | null, canSendMessage?: boolean | null } | null, getMyProjectTemplates?: Array<{ __typename?: 'ProjectTemplate', id: string, topic: string, topicShortened?: string | null, digitalTwinType: DtType, subtopicsShortened?: Array<string> | null, createdByYou?: boolean | null, projectCount?: number | null, latestProjectDate?: string | null, latestCompletedProjectId?: string | null, hasCompletedProject?: boolean | null, agentCount?: number | null, latestProjectId?: string | null, latestProjectStatus?: ProjectStatus | null, latestProjectErrorMessage?: string | null, nextScheduledUpdate?: string | null, updateFrequency?: UpdateFrequency | null, autoUpdateEnabled?: boolean | null, type?: ProjectType | null, agentName?: string | null }> | null };

export type ConversationsBasicDataFragment = { __typename?: 'Conversation', id: string, title: string, type: ConversationType, demographic?: string | null, updatedAt?: string | null, digitalTwins: Array<{ __typename?: 'DigitalTwin', id: string, name: string }> };

export type ProjectQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ProjectQuery = { __typename?: 'Query', getRecentConversationsBasicData?: Array<{ __typename?: 'Conversation', id: string, title: string, type: ConversationType, demographic?: string | null, updatedAt?: string | null, digitalTwins: Array<{ __typename?: 'DigitalTwin', id: string, name: string }> }> | null, project?: { __typename?: 'Project', type?: ProjectType | null, sessionId?: string | null, evalInputTokens?: number | null, evalOutputTokens?: number | null, createdByYou?: boolean | null, canManageWatch?: boolean | null, status: ProjectStatus, errorMessage?: string | null, id: string, digitalTwinType: DtType, createdAt?: string | null, topic: string, name: string, projectTemplateId?: string | null, timelineProjects?: Array<{ __typename?: 'TimelineProject', id: string, dateCreated: string, evalInputTokens?: number | null, evalOutputTokens?: number | null }> | null, files?: Array<{ __typename?: 'ProjectFile', id: string, fileName: string, fileUrl: string }> | null, stagedAgents?: Array<{ __typename?: 'StagedAgent', id: string, name: string }> | null, digitalTwinCollection?: { __typename?: 'DtCollection', id: string, name: string, digitalTwins?: Array<{ __typename?: 'DigitalTwin', id: string, name: string, type: DtType, congressData?: { __typename?: 'CongressData', chamber: string, party: string, state: string, linkedinHandle?: string | null, twitterHandle?: string | null } | null, sendrilData?: { __typename?: 'SendrilData', name: string, twitterHandle?: string | null, tiktokHandle?: string | null, instagramHandle?: string | null, youtubeHandle?: string | null, facebookHandle?: string | null, substackHandle?: string | null, website?: string | null } | null, earlyStageVcData?: { __typename?: 'EarlyStageVcData', firm: string, title?: string | null, linkedinHandle?: string | null, twitterHandle?: string | null, location?: string | null } | null, fortuneCeoData?: { __typename?: 'FortuneCeoData', company: string, linkedinHandle?: string | null, twitterHandle?: string | null, industry: string } | null, modelData?: { __typename?: 'ModelData', name?: string | null, score?: number | null, baseModel?: string | null, systemPrompt?: string | null, temperature?: number | null, maxNewTokens?: number | null, numReturnSequences?: number | null } | null, moviesSimpleData?: { __typename?: 'MoviesSimpleData', name: string, gender: string, age: string } | null, moviesMediumFullData?: { __typename?: 'MoviesMediumFullData', name: string, gender: string, age: string, race: string, region: string, education: string, employment: string, income: string, ethnicity: string, locationType: string, childrenData: string } | null, nycMayorData?: { __typename?: 'NYCMayorData', name: string, twitterHandle: string, website: string } | null }> | null } | null, perspectives?: Array<{ __typename?: 'Perspective', id: string, x: number, y: number, topic: string, blurb: string, qualityScore?: number | null, judgeNotes?: string | null, digitalTwin?: { __typename?: 'DigitalTwin', id: string, name: string, type: DtType, congressData?: { __typename?: 'CongressData', chamber: string, party: string, state: string, linkedinHandle?: string | null, twitterHandle?: string | null } | null, sendrilData?: { __typename?: 'SendrilData', name: string, twitterHandle?: string | null, tiktokHandle?: string | null, instagramHandle?: string | null, youtubeHandle?: string | null, facebookHandle?: string | null, substackHandle?: string | null, website?: string | null } | null, earlyStageVcData?: { __typename?: 'EarlyStageVcData', firm: string, title?: string | null, linkedinHandle?: string | null, twitterHandle?: string | null, location?: string | null } | null, fortuneCeoData?: { __typename?: 'FortuneCeoData', company: string, linkedinHandle?: string | null, twitterHandle?: string | null, industry: string } | null, modelData?: { __typename?: 'ModelData', name?: string | null, score?: number | null, baseModel?: string | null, systemPrompt?: string | null, temperature?: number | null, maxNewTokens?: number | null, numReturnSequences?: number | null } | null, moviesSimpleData?: { __typename?: 'MoviesSimpleData', name: string, gender: string, age: string } | null, moviesMediumFullData?: { __typename?: 'MoviesMediumFullData', name: string, gender: string, age: string, race: string, region: string, education: string, employment: string, income: string, ethnicity: string, locationType: string, childrenData: string } | null, nycMayorData?: { __typename?: 'NYCMayorData', name: string, twitterHandle: string, website: string } | null } | null, customAgent?: { __typename?: 'CustomAgent', id: string, name: string, description?: string | null, avatarUrl?: string | null, status: CustomAgentStatus, createdAt: string, apiEndpoint: string, apiAuthType: string, isOwner: boolean, canEdit: boolean, shareCount: number, projectCount: number, snapshotEnabled: boolean, connectionType: ConnectionType } | null }> | null, subtopics?: Array<{ __typename?: 'Subtopic', name: string, leftTitle?: string | null, rightTitle?: string | null }> | null, questions?: Array<{ __typename?: 'ProjectQuestion', topic: string, question: string }> | null, userSurveyResponse?: { __typename?: 'UserProjectSurvey', id: string, responses: Array<{ __typename?: 'ProjectSurveyResponse', question: string, topic: string, response: ProjectSurveyResponseType }> } | null } | null };

export type CustomAgentPerspectiveDataFragment = { __typename?: 'CustomAgent', id: string, name: string, description?: string | null, avatarUrl?: string | null, status: CustomAgentStatus, createdAt: string, apiEndpoint: string, apiAuthType: string, isOwner: boolean, canEdit: boolean, shareCount: number, projectCount: number, snapshotEnabled: boolean, connectionType: ConnectionType };

export type PerspectiveBaseInfoFragment = { __typename?: 'Perspective', id: string, x: number, y: number, topic: string, blurb: string, qualityScore?: number | null, judgeNotes?: string | null, digitalTwin?: { __typename?: 'DigitalTwin', id: string, name: string, type: DtType, congressData?: { __typename?: 'CongressData', chamber: string, party: string, state: string, linkedinHandle?: string | null, twitterHandle?: string | null } | null, sendrilData?: { __typename?: 'SendrilData', name: string, twitterHandle?: string | null, tiktokHandle?: string | null, instagramHandle?: string | null, youtubeHandle?: string | null, facebookHandle?: string | null, substackHandle?: string | null, website?: string | null } | null, earlyStageVcData?: { __typename?: 'EarlyStageVcData', firm: string, title?: string | null, linkedinHandle?: string | null, twitterHandle?: string | null, location?: string | null } | null, fortuneCeoData?: { __typename?: 'FortuneCeoData', company: string, linkedinHandle?: string | null, twitterHandle?: string | null, industry: string } | null, modelData?: { __typename?: 'ModelData', name?: string | null, score?: number | null, baseModel?: string | null, systemPrompt?: string | null, temperature?: number | null, maxNewTokens?: number | null, numReturnSequences?: number | null } | null, moviesSimpleData?: { __typename?: 'MoviesSimpleData', name: string, gender: string, age: string } | null, moviesMediumFullData?: { __typename?: 'MoviesMediumFullData', name: string, gender: string, age: string, race: string, region: string, education: string, employment: string, income: string, ethnicity: string, locationType: string, childrenData: string } | null, nycMayorData?: { __typename?: 'NYCMayorData', name: string, twitterHandle: string, website: string } | null } | null, customAgent?: { __typename?: 'CustomAgent', id: string, name: string, description?: string | null, avatarUrl?: string | null, status: CustomAgentStatus, createdAt: string, apiEndpoint: string, apiAuthType: string, isOwner: boolean, canEdit: boolean, shareCount: number, projectCount: number, snapshotEnabled: boolean, connectionType: ConnectionType } | null };

export type PerspectiveQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PerspectiveQuery = { __typename?: 'Query', getPerspective: { __typename?: 'Perspective', id: string, x: number, y: number, topic: string, blurb: string, qualityScore?: number | null, judgeNotes?: string | null, opinions?: Array<{ __typename?: 'Opinion', id: string, question: string, answer: string }> | null, comparisons?: Array<{ __typename?: 'Comparison', id: string, type: ComparisonType, score: number, digitalTwin?: { __typename?: 'DigitalTwin', id: string, name: string, type: DtType, congressData?: { __typename?: 'CongressData', chamber: string, party: string, state: string, linkedinHandle?: string | null, twitterHandle?: string | null } | null, sendrilData?: { __typename?: 'SendrilData', name: string, twitterHandle?: string | null, tiktokHandle?: string | null, instagramHandle?: string | null, youtubeHandle?: string | null, facebookHandle?: string | null, substackHandle?: string | null, website?: string | null } | null, earlyStageVcData?: { __typename?: 'EarlyStageVcData', firm: string, title?: string | null, linkedinHandle?: string | null, twitterHandle?: string | null, location?: string | null } | null, fortuneCeoData?: { __typename?: 'FortuneCeoData', company: string, linkedinHandle?: string | null, twitterHandle?: string | null, industry: string } | null, modelData?: { __typename?: 'ModelData', name?: string | null, score?: number | null, baseModel?: string | null, systemPrompt?: string | null, temperature?: number | null, maxNewTokens?: number | null, numReturnSequences?: number | null } | null, moviesSimpleData?: { __typename?: 'MoviesSimpleData', name: string, gender: string, age: string } | null, moviesMediumFullData?: { __typename?: 'MoviesMediumFullData', name: string, gender: string, age: string, race: string, region: string, education: string, employment: string, income: string, ethnicity: string, locationType: string, childrenData: string } | null, nycMayorData?: { __typename?: 'NYCMayorData', name: string, twitterHandle: string, website: string } | null } | null, customAgent?: { __typename?: 'CustomAgent', id: string, name: string, description?: string | null, avatarUrl?: string | null, status: CustomAgentStatus, createdAt: string, apiEndpoint: string, apiAuthType: string, isOwner: boolean, canEdit: boolean, shareCount: number, projectCount: number, snapshotEnabled: boolean, connectionType: ConnectionType } | null }> | null, digitalTwin?: { __typename?: 'DigitalTwin', id: string, name: string, type: DtType, congressData?: { __typename?: 'CongressData', chamber: string, party: string, state: string, linkedinHandle?: string | null, twitterHandle?: string | null } | null, sendrilData?: { __typename?: 'SendrilData', name: string, twitterHandle?: string | null, tiktokHandle?: string | null, instagramHandle?: string | null, youtubeHandle?: string | null, facebookHandle?: string | null, substackHandle?: string | null, website?: string | null } | null, earlyStageVcData?: { __typename?: 'EarlyStageVcData', firm: string, title?: string | null, linkedinHandle?: string | null, twitterHandle?: string | null, location?: string | null } | null, fortuneCeoData?: { __typename?: 'FortuneCeoData', company: string, linkedinHandle?: string | null, twitterHandle?: string | null, industry: string } | null, modelData?: { __typename?: 'ModelData', name?: string | null, score?: number | null, baseModel?: string | null, systemPrompt?: string | null, temperature?: number | null, maxNewTokens?: number | null, numReturnSequences?: number | null } | null, moviesSimpleData?: { __typename?: 'MoviesSimpleData', name: string, gender: string, age: string } | null, moviesMediumFullData?: { __typename?: 'MoviesMediumFullData', name: string, gender: string, age: string, race: string, region: string, education: string, employment: string, income: string, ethnicity: string, locationType: string, childrenData: string } | null, nycMayorData?: { __typename?: 'NYCMayorData', name: string, twitterHandle: string, website: string } | null } | null, customAgent?: { __typename?: 'CustomAgent', id: string, name: string, description?: string | null, avatarUrl?: string | null, status: CustomAgentStatus, createdAt: string, apiEndpoint: string, apiAuthType: string, isOwner: boolean, canEdit: boolean, shareCount: number, projectCount: number, snapshotEnabled: boolean, connectionType: ConnectionType } | null } };

export type DigitalTwinDataFragment = { __typename?: 'DigitalTwin', id: string, name: string, type: DtType, congressData?: { __typename?: 'CongressData', chamber: string, party: string, state: string, linkedinHandle?: string | null, twitterHandle?: string | null } | null, sendrilData?: { __typename?: 'SendrilData', name: string, twitterHandle?: string | null, tiktokHandle?: string | null, instagramHandle?: string | null, youtubeHandle?: string | null, facebookHandle?: string | null, substackHandle?: string | null, website?: string | null } | null, earlyStageVcData?: { __typename?: 'EarlyStageVcData', firm: string, title?: string | null, linkedinHandle?: string | null, twitterHandle?: string | null, location?: string | null } | null, fortuneCeoData?: { __typename?: 'FortuneCeoData', company: string, linkedinHandle?: string | null, twitterHandle?: string | null, industry: string } | null, modelData?: { __typename?: 'ModelData', name?: string | null, score?: number | null, baseModel?: string | null, systemPrompt?: string | null, temperature?: number | null, maxNewTokens?: number | null, numReturnSequences?: number | null } | null, moviesSimpleData?: { __typename?: 'MoviesSimpleData', name: string, gender: string, age: string } | null, moviesMediumFullData?: { __typename?: 'MoviesMediumFullData', name: string, gender: string, age: string, race: string, region: string, education: string, employment: string, income: string, ethnicity: string, locationType: string, childrenData: string } | null, nycMayorData?: { __typename?: 'NYCMayorData', name: string, twitterHandle: string, website: string } | null };

export type NycMayorMetadataFragment = { __typename?: 'NYCMayorData', name: string, twitterHandle: string, website: string };

export type CreateProjectProposalMutationVariables = Exact<{
  input: CreateProposalInput;
}>;


export type CreateProjectProposalMutation = { __typename?: 'Mutation', createProposal: { __typename?: 'Proposal', id: string, title: string, notes?: string | null, type: ProposalType, createdByYou: boolean, upvoteData: { __typename?: 'UpvoteData', count: number, upvotedByYou: boolean } } };

export type MarkAsViewedMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MarkAsViewedMutation = { __typename?: 'Mutation', markProjectViewed: { __typename?: 'Project', id: string, viewedAt?: Date | null } };

export type MarkTwisViewedMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MarkTwisViewedMutation = { __typename?: 'Mutation', markTwinViewed: boolean };

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteExplorable: boolean };

export type DeleteProjectTemplateMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteProjectTemplateMutation = { __typename?: 'Mutation', deleteProjectTemplate: boolean };

export type GetPerspectiveByDtTopicProjectQueryVariables = Exact<{
  dtId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  topic: Scalars['String']['input'];
}>;


export type GetPerspectiveByDtTopicProjectQuery = { __typename?: 'Query', getPerspectiveByDtTopicProject: { __typename?: 'Perspective', id: string, x: number, y: number, topic: string, blurb: string, qualityScore?: number | null, judgeNotes?: string | null, opinions?: Array<{ __typename?: 'Opinion', id: string, question: string, answer: string }> | null, comparisons?: Array<{ __typename?: 'Comparison', id: string, type: ComparisonType, score: number, digitalTwin?: { __typename?: 'DigitalTwin', id: string, name: string, type: DtType, congressData?: { __typename?: 'CongressData', chamber: string, party: string, state: string, linkedinHandle?: string | null, twitterHandle?: string | null } | null, sendrilData?: { __typename?: 'SendrilData', name: string, twitterHandle?: string | null, tiktokHandle?: string | null, instagramHandle?: string | null, youtubeHandle?: string | null, facebookHandle?: string | null, substackHandle?: string | null, website?: string | null } | null, earlyStageVcData?: { __typename?: 'EarlyStageVcData', firm: string, title?: string | null, linkedinHandle?: string | null, twitterHandle?: string | null, location?: string | null } | null, fortuneCeoData?: { __typename?: 'FortuneCeoData', company: string, linkedinHandle?: string | null, twitterHandle?: string | null, industry: string } | null, modelData?: { __typename?: 'ModelData', name?: string | null, score?: number | null, baseModel?: string | null, systemPrompt?: string | null, temperature?: number | null, maxNewTokens?: number | null, numReturnSequences?: number | null } | null, moviesSimpleData?: { __typename?: 'MoviesSimpleData', name: string, gender: string, age: string } | null, moviesMediumFullData?: { __typename?: 'MoviesMediumFullData', name: string, gender: string, age: string, race: string, region: string, education: string, employment: string, income: string, ethnicity: string, locationType: string, childrenData: string } | null, nycMayorData?: { __typename?: 'NYCMayorData', name: string, twitterHandle: string, website: string } | null } | null }> | null, digitalTwin?: { __typename?: 'DigitalTwin', id: string, name: string, type: DtType, congressData?: { __typename?: 'CongressData', chamber: string, party: string, state: string, linkedinHandle?: string | null, twitterHandle?: string | null } | null, sendrilData?: { __typename?: 'SendrilData', name: string, twitterHandle?: string | null, tiktokHandle?: string | null, instagramHandle?: string | null, youtubeHandle?: string | null, facebookHandle?: string | null, substackHandle?: string | null, website?: string | null } | null, earlyStageVcData?: { __typename?: 'EarlyStageVcData', firm: string, title?: string | null, linkedinHandle?: string | null, twitterHandle?: string | null, location?: string | null } | null, fortuneCeoData?: { __typename?: 'FortuneCeoData', company: string, linkedinHandle?: string | null, twitterHandle?: string | null, industry: string } | null, modelData?: { __typename?: 'ModelData', name?: string | null, score?: number | null, baseModel?: string | null, systemPrompt?: string | null, temperature?: number | null, maxNewTokens?: number | null, numReturnSequences?: number | null } | null, moviesSimpleData?: { __typename?: 'MoviesSimpleData', name: string, gender: string, age: string } | null, moviesMediumFullData?: { __typename?: 'MoviesMediumFullData', name: string, gender: string, age: string, race: string, region: string, education: string, employment: string, income: string, ethnicity: string, locationType: string, childrenData: string } | null, nycMayorData?: { __typename?: 'NYCMayorData', name: string, twitterHandle: string, website: string } | null } | null, customAgent?: { __typename?: 'CustomAgent', id: string, name: string, description?: string | null, avatarUrl?: string | null, status: CustomAgentStatus, createdAt: string, apiEndpoint: string, apiAuthType: string, isOwner: boolean, canEdit: boolean, shareCount: number, projectCount: number, snapshotEnabled: boolean, connectionType: ConnectionType } | null } };

export type GetAnswerSimilaritiesQueryVariables = Exact<{
  agentId: Scalars['String']['input'];
  topic: Scalars['String']['input'];
  versionAId: Scalars['String']['input'];
  versionBId: Scalars['String']['input'];
}>;


export type GetAnswerSimilaritiesQuery = { __typename?: 'Query', getAnswerSimilarities: Array<{ __typename?: 'AnswerSimilarity', question: string, similarity?: number | null }> };

export type GetPlanSimilaritiesQueryVariables = Exact<{
  agentId: Scalars['String']['input'];
  versionAId: Scalars['String']['input'];
  versionBId: Scalars['String']['input'];
}>;


export type GetPlanSimilaritiesQuery = { __typename?: 'Query', getPlanSimilarities: Array<{ __typename?: 'PlanSimilarity', task: string, similarity?: number | null }> };

export type GeneratePlanningTasksMutationVariables = Exact<{
  projectDescription: Scalars['String']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GeneratePlanningTasksMutation = { __typename?: 'Mutation', generatePlanningTasks: Array<{ __typename?: 'PlanningTask', name: string, task: string, prompt: string }> };

export type SuggestWatchTitleMutationVariables = Exact<{
  projectDescription: Scalars['String']['input'];
}>;


export type SuggestWatchTitleMutation = { __typename?: 'Mutation', suggestWatchTitle: string };

export type CreatePlanningProbeMutationVariables = Exact<{
  input: CreatePlanningProbeInput;
}>;


export type CreatePlanningProbeMutation = { __typename?: 'Mutation', createPlanningProbe: { __typename?: 'Project', id: string, type?: ProjectType | null, status: ProjectStatus, projectTemplateId?: string | null } };

export type AddYourselfMutationVariables = Exact<{
  input: AddYourselfInput;
}>;


export type AddYourselfMutation = { __typename?: 'Mutation', addYourself: { __typename?: 'Project', id: string, viewedAt?: Date | null, perspectives?: Array<{ __typename?: 'Perspective', id: string, x: number, y: number, topic: string, blurb: string, qualityScore?: number | null, judgeNotes?: string | null, digitalTwin?: { __typename?: 'DigitalTwin', id: string, name: string, type: DtType, congressData?: { __typename?: 'CongressData', chamber: string, party: string, state: string, linkedinHandle?: string | null, twitterHandle?: string | null } | null, sendrilData?: { __typename?: 'SendrilData', name: string, twitterHandle?: string | null, tiktokHandle?: string | null, instagramHandle?: string | null, youtubeHandle?: string | null, facebookHandle?: string | null, substackHandle?: string | null, website?: string | null } | null, earlyStageVcData?: { __typename?: 'EarlyStageVcData', firm: string, title?: string | null, linkedinHandle?: string | null, twitterHandle?: string | null, location?: string | null } | null, fortuneCeoData?: { __typename?: 'FortuneCeoData', company: string, linkedinHandle?: string | null, twitterHandle?: string | null, industry: string } | null, modelData?: { __typename?: 'ModelData', name?: string | null, score?: number | null, baseModel?: string | null, systemPrompt?: string | null, temperature?: number | null, maxNewTokens?: number | null, numReturnSequences?: number | null } | null, moviesSimpleData?: { __typename?: 'MoviesSimpleData', name: string, gender: string, age: string } | null, moviesMediumFullData?: { __typename?: 'MoviesMediumFullData', name: string, gender: string, age: string, race: string, region: string, education: string, employment: string, income: string, ethnicity: string, locationType: string, childrenData: string } | null, nycMayorData?: { __typename?: 'NYCMayorData', name: string, twitterHandle: string, website: string } | null } | null, customAgent?: { __typename?: 'CustomAgent', id: string, name: string, description?: string | null, avatarUrl?: string | null, status: CustomAgentStatus, createdAt: string, apiEndpoint: string, apiAuthType: string, isOwner: boolean, canEdit: boolean, shareCount: number, projectCount: number, snapshotEnabled: boolean, connectionType: ConnectionType } | null }> | null } };

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'Project', id: string, topic: string, name: string, digitalTwinType: DtType, projectTemplateId?: string | null } };

export type CreateNewProjectModalQueryVariables = Exact<{ [key: string]: never; }>;


export type CreateNewProjectModalQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, canSendMessage?: boolean | null, currentOrganization?: { __typename?: 'Organization', id: string, personaAccessTypes?: Array<DtType> | null } | null } | null };

export type GenerateProjectMutationVariables = Exact<{
  input: GenerateProjectInput;
}>;


export type GenerateProjectMutation = { __typename?: 'Mutation', generateProject: { __typename?: 'Project', id: string, topic: string, name: string, digitalTwinType: DtType, subtopics?: Array<{ __typename?: 'Subtopic', name: string }> | null } };

export type ConfirmSubtopicsMutationVariables = Exact<{
  input: ConfirmSubtopicsInput;
}>;


export type ConfirmSubtopicsMutation = { __typename?: 'Mutation', confirmSubtopics: { __typename?: 'Project', id: string, topic: string, subtopics?: Array<{ __typename?: 'Subtopic', name: string }> | null } };

export type GetProjectSettingsQueryVariables = Exact<{
  projectTemplateId: Scalars['String']['input'];
}>;


export type GetProjectSettingsQuery = { __typename?: 'Query', getProjectSettings?: { __typename?: 'ProjectSettings', id: string, updateFrequency: UpdateFrequency, customUpdateIntervalHours?: number | null, lastUpdatedAt?: string | null, nextScheduledUpdate?: string | null, autoUpdateEnabled: boolean, changeDetectionEnabled: boolean, sensitivityStdDevs: number, burnInPeriod: number, qualityTrackingEnabled: boolean, notificationFrequency: NotificationFrequency, summaryIntervalHours?: number | null, notificationsEnabled: boolean, notifyOnCompletion: boolean, notifyOnErrors: boolean, notifyOnNewInsights: boolean, notificationChannels: Array<NotificationChannel>, notificationEmail?: string | null } | null };

export type UpdateProjectSettingsMutationVariables = Exact<{
  input: UpdateProjectSettingsInput;
}>;


export type UpdateProjectSettingsMutation = { __typename?: 'Mutation', updateProjectSettings: { __typename?: 'ProjectSettings', id: string, updateFrequency: UpdateFrequency, customUpdateIntervalHours?: number | null, lastUpdatedAt?: string | null, nextScheduledUpdate?: string | null, autoUpdateEnabled: boolean, changeDetectionEnabled: boolean, sensitivityStdDevs: number, burnInPeriod: number, qualityTrackingEnabled: boolean, notificationFrequency: NotificationFrequency, summaryIntervalHours?: number | null, notificationsEnabled: boolean, notifyOnCompletion: boolean, notifyOnErrors: boolean, notifyOnNewInsights: boolean, notificationChannels: Array<NotificationChannel>, notificationEmail?: string | null } };

export type GetMonitoringTopicsQueryVariables = Exact<{
  dtType?: InputMaybe<DtType>;
}>;


export type GetMonitoringTopicsQuery = { __typename?: 'Query', getMonitoringTopics: Array<{ __typename?: 'MonitoringTopic', id: string, name: string, description?: string | null, category?: string | null, isActive: boolean, sortOrder: number, applicableDtTypes: Array<DtType>, subtopics: Array<{ __typename?: 'MonitoringSubtopic', id: string, name: string, description?: string | null, isActive: boolean, sortOrder: number, spectrumLeftTitle: string, spectrumRightTitle: string, questions: Array<string> }> }> };

export type ShareProjectMutationVariables = Exact<{
  input: ShareProjectInput;
}>;


export type ShareProjectMutation = { __typename?: 'Mutation', shareProject: { __typename?: 'ShareProjectResponse', success: boolean, sentTo: Array<string>, failedTo: Array<string> } };

export type TriggerProjectUpdateMutationVariables = Exact<{
  input: TriggerProjectUpdateInput;
}>;


export type TriggerProjectUpdateMutation = { __typename?: 'Mutation', triggerProjectUpdate: { __typename?: 'Project', id: string, topic: string, status: ProjectStatus } };

export type RetryProjectMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type RetryProjectMutation = { __typename?: 'Mutation', retryProject: { __typename?: 'Project', id: string, status: ProjectStatus, errorMessage?: string | null } };

export type GetOrganizationMembersForSharingQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetOrganizationMembersForSharingQuery = { __typename?: 'Query', getOrganizationWithMembers: { __typename?: 'OrganizationWithMembers', id: string, name: string, type: string, members: Array<{ __typename?: 'OrganizationMember', id: string, email: string, fullName: string }> } };

export type ListConnectorSessionsQueryVariables = Exact<{
  agentId: Scalars['String']['input'];
}>;


export type ListConnectorSessionsQuery = { __typename?: 'Query', listConnectorSessions: Array<{ __typename?: 'ConnectorSession', sessionId: string, title: string, lastModified: number, sizeBytes: number, cwd?: string | null }> };

export type TriggerCompactionAnalysisMutationVariables = Exact<{
  input: TriggerCompactionAnalysisInput;
}>;


export type TriggerCompactionAnalysisMutation = { __typename?: 'Mutation', triggerCompactionAnalysis: { __typename?: 'SteeringRun', id: string, status: SteeringStatus } };

export type TriggerInjectionAnalysisMutationVariables = Exact<{
  input: TriggerInjectionAnalysisInput;
}>;


export type TriggerInjectionAnalysisMutation = { __typename?: 'Mutation', triggerInjectionAnalysis: { __typename?: 'SteeringRun', id: string, status: SteeringStatus } };

export type SteeringRunQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SteeringRunQuery = { __typename?: 'Query', steeringRun?: { __typename?: 'SteeringRun', id: string, status: SteeringStatus, errorMessage?: string | null, progressDone?: number | null, progressTotal?: number | null, progressLabel?: string | null, results?: { __typename?: 'CompactionResult', recommended?: { __typename?: 'SteeringCandidate', message: string, similarity?: number | null, isBaseline: boolean } | null, candidates: Array<{ __typename?: 'SteeringCandidate', message: string, similarity?: number | null, isBaseline: boolean }> } | null } | null };

export type RequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type RequestsQuery = { __typename?: 'Query', getAllRequests?: Array<{ __typename?: 'Proposal', id: string, title: string, notes?: string | null, type: ProposalType, createdByYou: boolean, dtType?: DtType | null, upvoteData: { __typename?: 'UpvoteData', count: number, upvotedByYou: boolean } }> | null };

export type DeleteRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteRequestMutation = { __typename?: 'Mutation', deleteProposal?: boolean | null };

export type CreateFeatureRequestFeedbackMutationVariables = Exact<{
  description: Scalars['String']['input'];
  type: FeatureRequestFeedbackType;
}>;


export type CreateFeatureRequestFeedbackMutation = { __typename?: 'Mutation', createFeatureRequestFeedback: boolean };

export type GetMyOrganizationsWithRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyOrganizationsWithRolesQuery = { __typename?: 'Query', getMyOrganizationsWithRoles: Array<{ __typename?: 'OrganizationWithRole', id: string, name: string, role: OrganizationRole, type: string }> };

export type GetOrganizationWithMembersQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetOrganizationWithMembersQuery = { __typename?: 'Query', getOrganizationWithMembers: { __typename?: 'OrganizationWithMembers', id: string, name: string, currentUserRole?: OrganizationRole | null, members: Array<{ __typename?: 'OrganizationMember', id: string, email: string, fullName: string, role: OrganizationRole, joinedAt: Date }>, pendingInvitations: Array<{ __typename?: 'OrganizationInvitation', id: string, email: string, role: OrganizationRole, status: InvitationStatus, createdAt: Date, expiresAt: Date, invitedByUser?: { __typename?: 'User', id: string, fullName: string } | null }> } };

export type GetPendingInvitationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPendingInvitationsQuery = { __typename?: 'Query', getPendingInvitations: Array<{ __typename?: 'OrganizationInvitation', id: string, email: string, role: OrganizationRole, status: InvitationStatus, createdAt: Date, expiresAt: Date, token?: string | null, organization?: { __typename?: 'Organization', id: string, name: string } | null, invitedByUser?: { __typename?: 'User', id: string, fullName: string } | null }> };

export type GetInvitationByTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetInvitationByTokenQuery = { __typename?: 'Query', getInvitationByToken?: { __typename?: 'OrganizationInvitation', id: string, email: string, role: OrganizationRole, status: InvitationStatus, createdAt: Date, expiresAt: Date, organization?: { __typename?: 'Organization', id: string, name: string } | null, invitedByUser?: { __typename?: 'User', id: string, fullName: string } | null } | null };

export type CreateOrganizationWithOwnerMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateOrganizationWithOwnerMutation = { __typename?: 'Mutation', createOrganizationWithOwner: { __typename?: 'Organization', id: string, name: string } };

export type DeleteOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type DeleteOrganizationMutation = { __typename?: 'Mutation', deleteOrganization: boolean };

export type InviteToOrganizationMutationVariables = Exact<{
  input: InviteToOrganizationInput;
}>;


export type InviteToOrganizationMutation = { __typename?: 'Mutation', inviteToOrganization: { __typename?: 'OrganizationInvitation', id: string, email: string, role: OrganizationRole, status: InvitationStatus, createdAt: Date, expiresAt: Date } };

export type AcceptInvitationMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type AcceptInvitationMutation = { __typename?: 'Mutation', acceptInvitation: { __typename?: 'Organization', id: string, name: string } };

export type DeclineInvitationMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type DeclineInvitationMutation = { __typename?: 'Mutation', declineInvitation: boolean };

export type ResendInvitationMutationVariables = Exact<{
  invitationId: Scalars['String']['input'];
}>;


export type ResendInvitationMutation = { __typename?: 'Mutation', resendInvitation: { __typename?: 'OrganizationInvitation', id: string, email: string, expiresAt: Date } };

export type RevokeInvitationMutationVariables = Exact<{
  invitationId: Scalars['String']['input'];
}>;


export type RevokeInvitationMutation = { __typename?: 'Mutation', revokeInvitation: boolean };

export type UpdateMemberRoleMutationVariables = Exact<{
  input: UpdateMemberRoleInput;
}>;


export type UpdateMemberRoleMutation = { __typename?: 'Mutation', updateMemberRole: { __typename?: 'OrganizationMember', id: string, email: string, fullName: string, role: OrganizationRole } };

export type RemoveMemberMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type RemoveMemberMutation = { __typename?: 'Mutation', removeMember: boolean };

export type TransferOwnershipMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  newOwnerId: Scalars['String']['input'];
}>;


export type TransferOwnershipMutation = { __typename?: 'Mutation', transferOwnership: { __typename?: 'Organization', id: string, name: string } };

export type LeaveOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type LeaveOrganizationMutation = { __typename?: 'Mutation', leaveOrganization: boolean };

export type DeleteMyAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteMyAccountMutation = { __typename?: 'Mutation', deleteMyAccount: boolean };

export type GetUsageLimitsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsageLimitsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, plan?: UserPlan | null, usageLimits?: { __typename?: 'UsageLimits', plan: UserPlan, maxAgents: number, currentAgentCount: number, canCreateAgent: boolean, maxProjects: number, currentProjectCount: number, canCreateProject: boolean, updateFrequencyInHours: number, changesDetectedThisMonth: number } | null } | null };

export type GetSurveysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSurveysQuery = { __typename?: 'Query', getSurveys?: Array<{ __typename?: 'Survey', id: string, title: string, status: SurveyStatus, description?: string | null, type: SurveyType, bountyInCents?: number | null, createdAt?: string | null, createdByUser?: { __typename?: 'User', id: string, fullName: string } | null, organization?: { __typename?: 'Organization', id: string, name: string } | null, questions?: Array<{ __typename?: 'SurveyQuestion', id: string, title: string, type: SurveyQuestionType }> | null, responses?: Array<{ __typename?: 'SurveyResponse', id: string, questionResponses?: Array<{ __typename?: 'SurveyQuestionResponse', id: string, response?: Array<string> | null }> | null }> | null }> | null };

export type CreateSurveyWithQuestionsMutationVariables = Exact<{
  input: CreateSurveyWithQuestionsInput;
}>;


export type CreateSurveyWithQuestionsMutation = { __typename?: 'Mutation', createSurveyWithQuestions: { __typename?: 'Survey', id: string, title: string, description?: string | null, bountyInCents?: number | null } };

export type SurveyUserDataFragmentFragment = { __typename?: 'SurveyUserData', age?: string | null, gender?: string | null, zipcode?: string | null, education?: string | null, ethnicity?: string | null, householdSize?: number | null, maritalStatus?: string | null, employmentStatus?: string | null, householdIncome?: string | null, childrenUnder18?: string | null };

export type GetSurveyGroupByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSurveyGroupByIdQuery = { __typename?: 'Query', getSurveyGroupById: { __typename?: 'SurveyGroup', id: string, name: string, digitalTwins?: Array<{ __typename?: 'DigitalTwin', id: string, name: string, type: DtType, surveyUserData?: { __typename?: 'SurveyUserData', age?: string | null, gender?: string | null, zipcode?: string | null, education?: string | null, ethnicity?: string | null, householdSize?: number | null, maritalStatus?: string | null, employmentStatus?: string | null, householdIncome?: string | null, childrenUnder18?: string | null } | null }> | null, surveys?: Array<{ __typename?: 'Survey', id: string, title: string }> | null } };

export type GetSurveyByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSurveyByIdQuery = { __typename?: 'Query', getSurveyById: { __typename?: 'Survey', id: string, title: string, status: SurveyStatus, description?: string | null, baseQuestion?: string | null, bountyInCents?: number | null, createdAt?: string | null, type: SurveyType, createdByUser?: { __typename?: 'User', id: string, fullName: string } | null, questions?: Array<{ __typename?: 'SurveyQuestion', id: string, title: string, type: SurveyQuestionType }> | null, responses?: Array<{ __typename?: 'SurveyResponse', id: string, createdAt?: string | null, digitalTwin?: { __typename?: 'DigitalTwin', id: string, name: string, surveyUserData?: { __typename?: 'SurveyUserData', age?: string | null, gender?: string | null, zipcode?: string | null, education?: string | null, ethnicity?: string | null, householdSize?: number | null, maritalStatus?: string | null, employmentStatus?: string | null, householdIncome?: string | null, childrenUnder18?: string | null } | null } | null, questionResponses?: Array<{ __typename?: 'SurveyQuestionResponse', id: string, response?: Array<string> | null, responseCounts?: Array<{ __typename?: 'ResponseCount', answer: string, count: number }> | null, question: { __typename?: 'SurveyQuestion', id: string, title: string, type: SurveyQuestionType } }> | null }> | null } };

export type CreateAbTestMutationVariables = Exact<{
  input: CreateAbTestInput;
}>;


export type CreateAbTestMutation = { __typename?: 'Mutation', createABTest: { __typename?: 'Survey', id: string, title: string } };

export type GetSurveyGroupNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSurveyGroupNamesQuery = { __typename?: 'Query', getSurveyGroupsBasicData?: Array<{ __typename?: 'SurveyGroup', id: string, name: string }> | null };

export type GetSurveyGroupDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSurveyGroupDetailsQuery = { __typename?: 'Query', getSurveyGroupsWithDetails?: Array<{ __typename?: 'SurveyGroup', id: string, name: string, digitalTwins?: Array<{ __typename?: 'DigitalTwin', id: string, name: string, type: DtType, surveyUserData?: { __typename?: 'SurveyUserData', age?: string | null, gender?: string | null, zipcode?: string | null, education?: string | null, ethnicity?: string | null, householdSize?: number | null, maritalStatus?: string | null, employmentStatus?: string | null, householdIncome?: string | null, childrenUnder18?: string | null } | null }> | null, surveys?: Array<{ __typename?: 'Survey', id: string, title: string }> | null }> | null };

export const RetrievedContentDataFragmentDoc = gql`
    fragment RetrievedContentData on RetrievedContent {
  text
  source
  postedAt
  score
}
    `;
export const MessageDataFragmentDoc = gql`
    fragment MessageData on Message {
  id
  timestamp
  content
  userSender
  digitalTwin {
    id
    name
  }
  retrievedContent {
    ...RetrievedContentData
  }
}
    ${RetrievedContentDataFragmentDoc}`;
export const ConversationDataFragmentDoc = gql`
    fragment ConversationData on Conversation {
  id
  title
  projectId
  projectName
  digitalTwins {
    id
    name
    type
  }
  updatedAt
  messages {
    ...MessageData
  }
  demographic
  type
}
    ${MessageDataFragmentDoc}`;
export const MyProjectDataFragmentDoc = gql`
    fragment MyProjectData on Project {
  id
  topicShortened
  subtopicsShortened
  digitalTwinType
  createdAt
}
    `;
export const DashboardProjectDataFragmentDoc = gql`
    fragment DashboardProjectData on Project {
  id
  topicShortened
  topic
  digitalTwinType
  subtopicsShortened
}
    `;
export const DashboardTwinDataFragmentDoc = gql`
    fragment DashboardTwinData on DigitalTwin {
  id
  name
  type
}
    `;
export const DashboardConversationDataFragmentDoc = gql`
    fragment DashboardConversationData on Conversation {
  id
  title
  type
  digitalTwins {
    id
    name
  }
}
    `;
export const RecentlyViewedDataFragmentDoc = gql`
    fragment RecentlyViewedData on RecentlyViewed {
  id
  type
  project {
    ...DashboardProjectData
  }
  twin {
    ...DashboardTwinData
  }
  conversation {
    ...DashboardConversationData
  }
}
    ${DashboardProjectDataFragmentDoc}
${DashboardTwinDataFragmentDoc}
${DashboardConversationDataFragmentDoc}`;
export const ProposalDataFragmentDoc = gql`
    fragment ProposalData on Proposal {
  id
  title
  notes
  type
  createdByYou
  upvoteData {
    count
    upvotedByYou
  }
  dtType
}
    `;
export const MyConversationDataFragmentDoc = gql`
    fragment MyConversationData on Conversation {
  id
  title
  type
  digitalTwins {
    id
    name
  }
  demographic
  updatedAt
  projectId
  projectName
}
    `;
export const CongressMetadataFragmentDoc = gql`
    fragment CongressMetadata on CongressData {
  chamber
  party
  state
  linkedinHandle
  twitterHandle
}
    `;
export const SendrilMetadataFragmentDoc = gql`
    fragment SendrilMetadata on SendrilData {
  name
  twitterHandle
  tiktokHandle
  instagramHandle
  youtubeHandle
  facebookHandle
  substackHandle
  website
}
    `;
export const EarlyStageVcMetadataFragmentDoc = gql`
    fragment EarlyStageVcMetadata on EarlyStageVcData {
  firm
  title
  linkedinHandle
  twitterHandle
  location
}
    `;
export const FortuneCeoMetadataFragmentDoc = gql`
    fragment FortuneCeoMetadata on FortuneCeoData {
  company
  linkedinHandle
  twitterHandle
  industry
}
    `;
export const ModelMetadataFragmentDoc = gql`
    fragment ModelMetadata on ModelData {
  name
  score
  baseModel
  systemPrompt
  temperature
  maxNewTokens
  numReturnSequences
}
    `;
export const MoviesMediumFullMetadataFragmentDoc = gql`
    fragment MoviesMediumFullMetadata on MoviesMediumFullData {
  name
  gender
  age
  race
  region
  education
  employment
  income
  ethnicity
  locationType
  childrenData
}
    `;
export const MoviesSimpleMetadataFragmentDoc = gql`
    fragment MoviesSimpleMetadata on MoviesSimpleData {
  name
  gender
  age
}
    `;
export const FedMemberMetadataFragmentDoc = gql`
    fragment FedMemberMetadata on FedMemberData {
  name
  bio
  bioSource
  title
  office
  bank
  isVoting
  isChair
  isGovernor
}
    `;
export const DigitalTwinViewDataFragmentDoc = gql`
    fragment DigitalTwinViewData on DigitalTwin {
  id
  name
  type
  blurb
  congressData {
    ...CongressMetadata
  }
  sendrilData {
    ...SendrilMetadata
  }
  earlyStageVcData {
    ...EarlyStageVcMetadata
  }
  fortuneCeoData {
    ...FortuneCeoMetadata
  }
  modelData {
    ...ModelMetadata
  }
  moviesMediumFullData {
    ...MoviesMediumFullMetadata
  }
  moviesSimpleData {
    ...MoviesSimpleMetadata
  }
  fedMemberData {
    ...FedMemberMetadata
  }
  projects {
    id
    topic
    name
    createdAt
    subtopics {
      name
    }
    digitalTwinType
    viewedAt
    subtopicsShortened
    topicShortened
  }
}
    ${CongressMetadataFragmentDoc}
${SendrilMetadataFragmentDoc}
${EarlyStageVcMetadataFragmentDoc}
${FortuneCeoMetadataFragmentDoc}
${ModelMetadataFragmentDoc}
${MoviesMediumFullMetadataFragmentDoc}
${MoviesSimpleMetadataFragmentDoc}
${FedMemberMetadataFragmentDoc}`;
export const ConversationsBasicDataFragmentDoc = gql`
    fragment ConversationsBasicData on Conversation {
  id
  title
  type
  digitalTwins {
    id
    name
  }
  demographic
  updatedAt
}
    `;
export const NycMayorMetadataFragmentDoc = gql`
    fragment NycMayorMetadata on NYCMayorData {
  name
  twitterHandle
  website
}
    `;
export const DigitalTwinDataFragmentDoc = gql`
    fragment DigitalTwinData on DigitalTwin {
  id
  name
  type
  congressData {
    ...CongressMetadata
  }
  sendrilData {
    ...SendrilMetadata
  }
  earlyStageVcData {
    ...EarlyStageVcMetadata
  }
  fortuneCeoData {
    ...FortuneCeoMetadata
  }
  modelData {
    ...ModelMetadata
  }
  moviesSimpleData {
    ...MoviesSimpleMetadata
  }
  moviesMediumFullData {
    ...MoviesMediumFullMetadata
  }
  nycMayorData {
    ...NycMayorMetadata
  }
}
    ${CongressMetadataFragmentDoc}
${SendrilMetadataFragmentDoc}
${EarlyStageVcMetadataFragmentDoc}
${FortuneCeoMetadataFragmentDoc}
${ModelMetadataFragmentDoc}
${MoviesSimpleMetadataFragmentDoc}
${MoviesMediumFullMetadataFragmentDoc}
${NycMayorMetadataFragmentDoc}`;
export const CustomAgentPerspectiveDataFragmentDoc = gql`
    fragment CustomAgentPerspectiveData on CustomAgent {
  id
  name
  description
  avatarUrl
  status
  createdAt
  apiEndpoint
  apiAuthType
  isOwner
  canEdit
  shareCount
  projectCount
  snapshotEnabled
  connectionType
}
    `;
export const PerspectiveBaseInfoFragmentDoc = gql`
    fragment PerspectiveBaseInfo on Perspective {
  id
  x
  y
  topic
  blurb
  qualityScore
  judgeNotes
  digitalTwin {
    ...DigitalTwinData
  }
  customAgent {
    ...CustomAgentPerspectiveData
  }
}
    ${DigitalTwinDataFragmentDoc}
${CustomAgentPerspectiveDataFragmentDoc}`;
export const SurveyUserDataFragmentFragmentDoc = gql`
    fragment SurveyUserDataFragment on SurveyUserData {
  age
  gender
  zipcode
  education
  ethnicity
  householdSize
  maritalStatus
  employmentStatus
  householdIncome
  childrenUnder18
}
    `;
export const GetPlatformStatsDocument = gql`
    query GetPlatformStats {
  getPlatformStats {
    totalAgents
    totalChangesDetected
  }
}
    `;

/**
 * __useGetPlatformStatsQuery__
 *
 * To run a query within a React component, call `useGetPlatformStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlatformStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetPlatformStatsQuery, GetPlatformStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlatformStatsQuery, GetPlatformStatsQueryVariables>(GetPlatformStatsDocument, options);
      }
export function useGetPlatformStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlatformStatsQuery, GetPlatformStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlatformStatsQuery, GetPlatformStatsQueryVariables>(GetPlatformStatsDocument, options);
        }
// @ts-ignore
export function useGetPlatformStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlatformStatsQuery, GetPlatformStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlatformStatsQuery, GetPlatformStatsQueryVariables>;
export function useGetPlatformStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlatformStatsQuery, GetPlatformStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlatformStatsQuery | undefined, GetPlatformStatsQueryVariables>;
export function useGetPlatformStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlatformStatsQuery, GetPlatformStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlatformStatsQuery, GetPlatformStatsQueryVariables>(GetPlatformStatsDocument, options);
        }
export type GetPlatformStatsQueryHookResult = ReturnType<typeof useGetPlatformStatsQuery>;
export type GetPlatformStatsLazyQueryHookResult = ReturnType<typeof useGetPlatformStatsLazyQuery>;
export type GetPlatformStatsSuspenseQueryHookResult = ReturnType<typeof useGetPlatformStatsSuspenseQuery>;
export type GetPlatformStatsQueryResult = Apollo.QueryResult<GetPlatformStatsQuery, GetPlatformStatsQueryVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($email: String!, $uid: String!, $name: String!) {
  createUser(email: $email, uid: $uid, name: $name) {
    id
    fullName
    email
    currentOrganization {
      id
      name
      initialProjects {
        id
        topic
        name
      }
      personaAccessTypes
    }
    tosVerified
    hasOnboarded
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      uid: // value for 'uid'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const AcceptTosDocument = gql`
    mutation AcceptTos {
  acceptTos {
    id
    tosVerified
  }
}
    `;
export type AcceptTosMutationFn = Apollo.MutationFunction<AcceptTosMutation, AcceptTosMutationVariables>;

/**
 * __useAcceptTosMutation__
 *
 * To run a mutation, you first call `useAcceptTosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTosMutation, { data, loading, error }] = useAcceptTosMutation({
 *   variables: {
 *   },
 * });
 */
export function useAcceptTosMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTosMutation, AcceptTosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTosMutation, AcceptTosMutationVariables>(AcceptTosDocument, options);
      }
export type AcceptTosMutationHookResult = ReturnType<typeof useAcceptTosMutation>;
export type AcceptTosMutationResult = Apollo.MutationResult<AcceptTosMutation>;
export type AcceptTosMutationOptions = Apollo.BaseMutationOptions<AcceptTosMutation, AcceptTosMutationVariables>;
export const SubmitOnboardingDocument = gql`
    mutation SubmitOnboarding($input: SubmitOnboardingInput!) {
  submitOnboarding(input: $input) {
    id
    hasOnboarded
  }
}
    `;
export type SubmitOnboardingMutationFn = Apollo.MutationFunction<SubmitOnboardingMutation, SubmitOnboardingMutationVariables>;

/**
 * __useSubmitOnboardingMutation__
 *
 * To run a mutation, you first call `useSubmitOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitOnboardingMutation, { data, loading, error }] = useSubmitOnboardingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<SubmitOnboardingMutation, SubmitOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitOnboardingMutation, SubmitOnboardingMutationVariables>(SubmitOnboardingDocument, options);
      }
export type SubmitOnboardingMutationHookResult = ReturnType<typeof useSubmitOnboardingMutation>;
export type SubmitOnboardingMutationResult = Apollo.MutationResult<SubmitOnboardingMutation>;
export type SubmitOnboardingMutationOptions = Apollo.BaseMutationOptions<SubmitOnboardingMutation, SubmitOnboardingMutationVariables>;
export const StartConversationDocument = gql`
    mutation StartConversation($digitalTwinIds: [String!]!, $type: ConversationType!, $projectId: String, $demographic: String) {
  startConversation(
    digitalTwinIds: $digitalTwinIds
    projectId: $projectId
    type: $type
    demographic: $demographic
  ) {
    id
    title
    digitalTwins {
      id
      name
    }
  }
}
    `;
export type StartConversationMutationFn = Apollo.MutationFunction<StartConversationMutation, StartConversationMutationVariables>;

/**
 * __useStartConversationMutation__
 *
 * To run a mutation, you first call `useStartConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startConversationMutation, { data, loading, error }] = useStartConversationMutation({
 *   variables: {
 *      digitalTwinIds: // value for 'digitalTwinIds'
 *      type: // value for 'type'
 *      projectId: // value for 'projectId'
 *      demographic: // value for 'demographic'
 *   },
 * });
 */
export function useStartConversationMutation(baseOptions?: Apollo.MutationHookOptions<StartConversationMutation, StartConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartConversationMutation, StartConversationMutationVariables>(StartConversationDocument, options);
      }
export type StartConversationMutationHookResult = ReturnType<typeof useStartConversationMutation>;
export type StartConversationMutationResult = Apollo.MutationResult<StartConversationMutation>;
export type StartConversationMutationOptions = Apollo.BaseMutationOptions<StartConversationMutation, StartConversationMutationVariables>;
export const GetAllDigitalTwinsBasicDataDocument = gql`
    query GetAllDigitalTwinsBasicData($type: DtType!) {
  getAllDigitalTwinsBasicData(type: $type) {
    id
    name
  }
}
    `;

/**
 * __useGetAllDigitalTwinsBasicDataQuery__
 *
 * To run a query within a React component, call `useGetAllDigitalTwinsBasicDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDigitalTwinsBasicDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDigitalTwinsBasicDataQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetAllDigitalTwinsBasicDataQuery(baseOptions: Apollo.QueryHookOptions<GetAllDigitalTwinsBasicDataQuery, GetAllDigitalTwinsBasicDataQueryVariables> & ({ variables: GetAllDigitalTwinsBasicDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDigitalTwinsBasicDataQuery, GetAllDigitalTwinsBasicDataQueryVariables>(GetAllDigitalTwinsBasicDataDocument, options);
      }
export function useGetAllDigitalTwinsBasicDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDigitalTwinsBasicDataQuery, GetAllDigitalTwinsBasicDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDigitalTwinsBasicDataQuery, GetAllDigitalTwinsBasicDataQueryVariables>(GetAllDigitalTwinsBasicDataDocument, options);
        }
// @ts-ignore
export function useGetAllDigitalTwinsBasicDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllDigitalTwinsBasicDataQuery, GetAllDigitalTwinsBasicDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllDigitalTwinsBasicDataQuery, GetAllDigitalTwinsBasicDataQueryVariables>;
export function useGetAllDigitalTwinsBasicDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllDigitalTwinsBasicDataQuery, GetAllDigitalTwinsBasicDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllDigitalTwinsBasicDataQuery | undefined, GetAllDigitalTwinsBasicDataQueryVariables>;
export function useGetAllDigitalTwinsBasicDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllDigitalTwinsBasicDataQuery, GetAllDigitalTwinsBasicDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllDigitalTwinsBasicDataQuery, GetAllDigitalTwinsBasicDataQueryVariables>(GetAllDigitalTwinsBasicDataDocument, options);
        }
export type GetAllDigitalTwinsBasicDataQueryHookResult = ReturnType<typeof useGetAllDigitalTwinsBasicDataQuery>;
export type GetAllDigitalTwinsBasicDataLazyQueryHookResult = ReturnType<typeof useGetAllDigitalTwinsBasicDataLazyQuery>;
export type GetAllDigitalTwinsBasicDataSuspenseQueryHookResult = ReturnType<typeof useGetAllDigitalTwinsBasicDataSuspenseQuery>;
export type GetAllDigitalTwinsBasicDataQueryResult = Apollo.QueryResult<GetAllDigitalTwinsBasicDataQuery, GetAllDigitalTwinsBasicDataQueryVariables>;
export const GetDtTypeAccessDocument = gql`
    query GetDtTypeAccess {
  getDtTypeAccess
}
    `;

/**
 * __useGetDtTypeAccessQuery__
 *
 * To run a query within a React component, call `useGetDtTypeAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDtTypeAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDtTypeAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDtTypeAccessQuery(baseOptions?: Apollo.QueryHookOptions<GetDtTypeAccessQuery, GetDtTypeAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDtTypeAccessQuery, GetDtTypeAccessQueryVariables>(GetDtTypeAccessDocument, options);
      }
export function useGetDtTypeAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDtTypeAccessQuery, GetDtTypeAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDtTypeAccessQuery, GetDtTypeAccessQueryVariables>(GetDtTypeAccessDocument, options);
        }
// @ts-ignore
export function useGetDtTypeAccessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDtTypeAccessQuery, GetDtTypeAccessQueryVariables>): Apollo.UseSuspenseQueryResult<GetDtTypeAccessQuery, GetDtTypeAccessQueryVariables>;
export function useGetDtTypeAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDtTypeAccessQuery, GetDtTypeAccessQueryVariables>): Apollo.UseSuspenseQueryResult<GetDtTypeAccessQuery | undefined, GetDtTypeAccessQueryVariables>;
export function useGetDtTypeAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDtTypeAccessQuery, GetDtTypeAccessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDtTypeAccessQuery, GetDtTypeAccessQueryVariables>(GetDtTypeAccessDocument, options);
        }
export type GetDtTypeAccessQueryHookResult = ReturnType<typeof useGetDtTypeAccessQuery>;
export type GetDtTypeAccessLazyQueryHookResult = ReturnType<typeof useGetDtTypeAccessLazyQuery>;
export type GetDtTypeAccessSuspenseQueryHookResult = ReturnType<typeof useGetDtTypeAccessSuspenseQuery>;
export type GetDtTypeAccessQueryResult = Apollo.QueryResult<GetDtTypeAccessQuery, GetDtTypeAccessQueryVariables>;
export const SendAiMessageDocument = gql`
    mutation sendAIMessage($message: String!, $conversationId: String!) {
  sendAIMessage(message: $message, conversationId: $conversationId) {
    id
    messages {
      ...MessageData
    }
  }
}
    ${MessageDataFragmentDoc}`;
export type SendAiMessageMutationFn = Apollo.MutationFunction<SendAiMessageMutation, SendAiMessageMutationVariables>;

/**
 * __useSendAiMessageMutation__
 *
 * To run a mutation, you first call `useSendAiMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAiMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAiMessageMutation, { data, loading, error }] = useSendAiMessageMutation({
 *   variables: {
 *      message: // value for 'message'
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useSendAiMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendAiMessageMutation, SendAiMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAiMessageMutation, SendAiMessageMutationVariables>(SendAiMessageDocument, options);
      }
export type SendAiMessageMutationHookResult = ReturnType<typeof useSendAiMessageMutation>;
export type SendAiMessageMutationResult = Apollo.MutationResult<SendAiMessageMutation>;
export type SendAiMessageMutationOptions = Apollo.BaseMutationOptions<SendAiMessageMutation, SendAiMessageMutationVariables>;
export const GetAiMessageResponseDocument = gql`
    mutation getAIMessageResponse($conversationId: String!) {
  getAIMessageResponse(conversationId: $conversationId) {
    id
    messages {
      ...MessageData
    }
    title
  }
}
    ${MessageDataFragmentDoc}`;
export type GetAiMessageResponseMutationFn = Apollo.MutationFunction<GetAiMessageResponseMutation, GetAiMessageResponseMutationVariables>;

/**
 * __useGetAiMessageResponseMutation__
 *
 * To run a mutation, you first call `useGetAiMessageResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetAiMessageResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getAiMessageResponseMutation, { data, loading, error }] = useGetAiMessageResponseMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useGetAiMessageResponseMutation(baseOptions?: Apollo.MutationHookOptions<GetAiMessageResponseMutation, GetAiMessageResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetAiMessageResponseMutation, GetAiMessageResponseMutationVariables>(GetAiMessageResponseDocument, options);
      }
export type GetAiMessageResponseMutationHookResult = ReturnType<typeof useGetAiMessageResponseMutation>;
export type GetAiMessageResponseMutationResult = Apollo.MutationResult<GetAiMessageResponseMutation>;
export type GetAiMessageResponseMutationOptions = Apollo.BaseMutationOptions<GetAiMessageResponseMutation, GetAiMessageResponseMutationVariables>;
export const ConversationsDocument = gql`
    query Conversations {
  getDtTypeAccess
  getAllConversations {
    id
    title
    digitalTwins {
      id
      name
      type
    }
    updatedAt
    demographic
    type
  }
}
    `;

/**
 * __useConversationsQuery__
 *
 * To run a query within a React component, call `useConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConversationsQuery(baseOptions?: Apollo.QueryHookOptions<ConversationsQuery, ConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversationsQuery, ConversationsQueryVariables>(ConversationsDocument, options);
      }
export function useConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationsQuery, ConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversationsQuery, ConversationsQueryVariables>(ConversationsDocument, options);
        }
// @ts-ignore
export function useConversationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConversationsQuery, ConversationsQueryVariables>): Apollo.UseSuspenseQueryResult<ConversationsQuery, ConversationsQueryVariables>;
export function useConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConversationsQuery, ConversationsQueryVariables>): Apollo.UseSuspenseQueryResult<ConversationsQuery | undefined, ConversationsQueryVariables>;
export function useConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConversationsQuery, ConversationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConversationsQuery, ConversationsQueryVariables>(ConversationsDocument, options);
        }
export type ConversationsQueryHookResult = ReturnType<typeof useConversationsQuery>;
export type ConversationsLazyQueryHookResult = ReturnType<typeof useConversationsLazyQuery>;
export type ConversationsSuspenseQueryHookResult = ReturnType<typeof useConversationsSuspenseQuery>;
export type ConversationsQueryResult = Apollo.QueryResult<ConversationsQuery, ConversationsQueryVariables>;
export const GetDigitalTwinsByProjectIdDocument = gql`
    query GetDigitalTwinsByProjectId($projectId: String!) {
  getDigitalTwinsByProjectId(projectId: $projectId) {
    id
    name
  }
}
    `;

/**
 * __useGetDigitalTwinsByProjectIdQuery__
 *
 * To run a query within a React component, call `useGetDigitalTwinsByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDigitalTwinsByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDigitalTwinsByProjectIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetDigitalTwinsByProjectIdQuery(baseOptions: Apollo.QueryHookOptions<GetDigitalTwinsByProjectIdQuery, GetDigitalTwinsByProjectIdQueryVariables> & ({ variables: GetDigitalTwinsByProjectIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDigitalTwinsByProjectIdQuery, GetDigitalTwinsByProjectIdQueryVariables>(GetDigitalTwinsByProjectIdDocument, options);
      }
export function useGetDigitalTwinsByProjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDigitalTwinsByProjectIdQuery, GetDigitalTwinsByProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDigitalTwinsByProjectIdQuery, GetDigitalTwinsByProjectIdQueryVariables>(GetDigitalTwinsByProjectIdDocument, options);
        }
// @ts-ignore
export function useGetDigitalTwinsByProjectIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDigitalTwinsByProjectIdQuery, GetDigitalTwinsByProjectIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetDigitalTwinsByProjectIdQuery, GetDigitalTwinsByProjectIdQueryVariables>;
export function useGetDigitalTwinsByProjectIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDigitalTwinsByProjectIdQuery, GetDigitalTwinsByProjectIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetDigitalTwinsByProjectIdQuery | undefined, GetDigitalTwinsByProjectIdQueryVariables>;
export function useGetDigitalTwinsByProjectIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDigitalTwinsByProjectIdQuery, GetDigitalTwinsByProjectIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDigitalTwinsByProjectIdQuery, GetDigitalTwinsByProjectIdQueryVariables>(GetDigitalTwinsByProjectIdDocument, options);
        }
export type GetDigitalTwinsByProjectIdQueryHookResult = ReturnType<typeof useGetDigitalTwinsByProjectIdQuery>;
export type GetDigitalTwinsByProjectIdLazyQueryHookResult = ReturnType<typeof useGetDigitalTwinsByProjectIdLazyQuery>;
export type GetDigitalTwinsByProjectIdSuspenseQueryHookResult = ReturnType<typeof useGetDigitalTwinsByProjectIdSuspenseQuery>;
export type GetDigitalTwinsByProjectIdQueryResult = Apollo.QueryResult<GetDigitalTwinsByProjectIdQuery, GetDigitalTwinsByProjectIdQueryVariables>;
export const GetConversationDocument = gql`
    query GetConversation($id: String!) {
  getConversation(id: $id) {
    ...ConversationData
  }
}
    ${ConversationDataFragmentDoc}`;

/**
 * __useGetConversationQuery__
 *
 * To run a query within a React component, call `useGetConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConversationQuery(baseOptions: Apollo.QueryHookOptions<GetConversationQuery, GetConversationQueryVariables> & ({ variables: GetConversationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationQuery, GetConversationQueryVariables>(GetConversationDocument, options);
      }
export function useGetConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationQuery, GetConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationQuery, GetConversationQueryVariables>(GetConversationDocument, options);
        }
// @ts-ignore
export function useGetConversationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConversationQuery, GetConversationQueryVariables>): Apollo.UseSuspenseQueryResult<GetConversationQuery, GetConversationQueryVariables>;
export function useGetConversationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversationQuery, GetConversationQueryVariables>): Apollo.UseSuspenseQueryResult<GetConversationQuery | undefined, GetConversationQueryVariables>;
export function useGetConversationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversationQuery, GetConversationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConversationQuery, GetConversationQueryVariables>(GetConversationDocument, options);
        }
export type GetConversationQueryHookResult = ReturnType<typeof useGetConversationQuery>;
export type GetConversationLazyQueryHookResult = ReturnType<typeof useGetConversationLazyQuery>;
export type GetConversationSuspenseQueryHookResult = ReturnType<typeof useGetConversationSuspenseQuery>;
export type GetConversationQueryResult = Apollo.QueryResult<GetConversationQuery, GetConversationQueryVariables>;
export const MarkConversationViewedDocument = gql`
    mutation MarkConversationViewed($id: String!) {
  markConversationViewed(id: $id) {
    id
    title
    updatedAt
  }
}
    `;
export type MarkConversationViewedMutationFn = Apollo.MutationFunction<MarkConversationViewedMutation, MarkConversationViewedMutationVariables>;

/**
 * __useMarkConversationViewedMutation__
 *
 * To run a mutation, you first call `useMarkConversationViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkConversationViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markConversationViewedMutation, { data, loading, error }] = useMarkConversationViewedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkConversationViewedMutation(baseOptions?: Apollo.MutationHookOptions<MarkConversationViewedMutation, MarkConversationViewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkConversationViewedMutation, MarkConversationViewedMutationVariables>(MarkConversationViewedDocument, options);
      }
export type MarkConversationViewedMutationHookResult = ReturnType<typeof useMarkConversationViewedMutation>;
export type MarkConversationViewedMutationResult = Apollo.MutationResult<MarkConversationViewedMutation>;
export type MarkConversationViewedMutationOptions = Apollo.BaseMutationOptions<MarkConversationViewedMutation, MarkConversationViewedMutationVariables>;
export const DashboardDocument = gql`
    query Dashboard {
  getTrendingProposals {
    ...ProposalData
  }
  getMyProjects {
    ...MyProjectData
  }
  recentlyViewed {
    ...RecentlyViewedData
  }
  popularProjects {
    ...DashboardProjectData
  }
  getAllConversations {
    ...MyConversationData
  }
}
    ${ProposalDataFragmentDoc}
${MyProjectDataFragmentDoc}
${RecentlyViewedDataFragmentDoc}
${DashboardProjectDataFragmentDoc}
${MyConversationDataFragmentDoc}`;

/**
 * __useDashboardQuery__
 *
 * To run a query within a React component, call `useDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardQuery(baseOptions?: Apollo.QueryHookOptions<DashboardQuery, DashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, options);
      }
export function useDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardQuery, DashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, options);
        }
// @ts-ignore
export function useDashboardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardQuery, DashboardQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardQuery, DashboardQueryVariables>;
export function useDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardQuery, DashboardQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardQuery | undefined, DashboardQueryVariables>;
export function useDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardQuery, DashboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, options);
        }
export type DashboardQueryHookResult = ReturnType<typeof useDashboardQuery>;
export type DashboardLazyQueryHookResult = ReturnType<typeof useDashboardLazyQuery>;
export type DashboardSuspenseQueryHookResult = ReturnType<typeof useDashboardSuspenseQuery>;
export type DashboardQueryResult = Apollo.QueryResult<DashboardQuery, DashboardQueryVariables>;
export const UpvoteProposalDocument = gql`
    mutation UpvoteProposal($id: String!, $isUpvote: Boolean!) {
  upvoteProposal(id: $id, isUpvote: $isUpvote) {
    ...ProposalData
  }
}
    ${ProposalDataFragmentDoc}`;
export type UpvoteProposalMutationFn = Apollo.MutationFunction<UpvoteProposalMutation, UpvoteProposalMutationVariables>;

/**
 * __useUpvoteProposalMutation__
 *
 * To run a mutation, you first call `useUpvoteProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpvoteProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upvoteProposalMutation, { data, loading, error }] = useUpvoteProposalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isUpvote: // value for 'isUpvote'
 *   },
 * });
 */
export function useUpvoteProposalMutation(baseOptions?: Apollo.MutationHookOptions<UpvoteProposalMutation, UpvoteProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpvoteProposalMutation, UpvoteProposalMutationVariables>(UpvoteProposalDocument, options);
      }
export type UpvoteProposalMutationHookResult = ReturnType<typeof useUpvoteProposalMutation>;
export type UpvoteProposalMutationResult = Apollo.MutationResult<UpvoteProposalMutation>;
export type UpvoteProposalMutationOptions = Apollo.BaseMutationOptions<UpvoteProposalMutation, UpvoteProposalMutationVariables>;
export const DigitalTwinsDocument = gql`
    query DigitalTwins($limit: Int, $offset: Int, $search: String, $typeFilter: [DtType!]) {
  getAllDigitalTwins(
    limit: $limit
    offset: $offset
    search: $search
    typeFilter: $typeFilter
  ) {
    twins {
      id
      name
      type
      congressData {
        ...CongressMetadata
      }
      sendrilData {
        ...SendrilMetadata
      }
      earlyStageVcData {
        ...EarlyStageVcMetadata
      }
      fortuneCeoData {
        ...FortuneCeoMetadata
      }
      modelData {
        ...ModelMetadata
      }
      moviesSimpleData {
        ...MoviesSimpleMetadata
      }
      moviesMediumFullData {
        ...MoviesMediumFullMetadata
      }
      fedMemberData {
        ...FedMemberMetadata
      }
      projects {
        id
        name
        topic
        topicShortened
        digitalTwinType
        status
      }
    }
    totalCount
  }
}
    ${CongressMetadataFragmentDoc}
${SendrilMetadataFragmentDoc}
${EarlyStageVcMetadataFragmentDoc}
${FortuneCeoMetadataFragmentDoc}
${ModelMetadataFragmentDoc}
${MoviesSimpleMetadataFragmentDoc}
${MoviesMediumFullMetadataFragmentDoc}
${FedMemberMetadataFragmentDoc}`;

/**
 * __useDigitalTwinsQuery__
 *
 * To run a query within a React component, call `useDigitalTwinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDigitalTwinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDigitalTwinsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      typeFilter: // value for 'typeFilter'
 *   },
 * });
 */
export function useDigitalTwinsQuery(baseOptions?: Apollo.QueryHookOptions<DigitalTwinsQuery, DigitalTwinsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DigitalTwinsQuery, DigitalTwinsQueryVariables>(DigitalTwinsDocument, options);
      }
export function useDigitalTwinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DigitalTwinsQuery, DigitalTwinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DigitalTwinsQuery, DigitalTwinsQueryVariables>(DigitalTwinsDocument, options);
        }
// @ts-ignore
export function useDigitalTwinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DigitalTwinsQuery, DigitalTwinsQueryVariables>): Apollo.UseSuspenseQueryResult<DigitalTwinsQuery, DigitalTwinsQueryVariables>;
export function useDigitalTwinsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DigitalTwinsQuery, DigitalTwinsQueryVariables>): Apollo.UseSuspenseQueryResult<DigitalTwinsQuery | undefined, DigitalTwinsQueryVariables>;
export function useDigitalTwinsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DigitalTwinsQuery, DigitalTwinsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DigitalTwinsQuery, DigitalTwinsQueryVariables>(DigitalTwinsDocument, options);
        }
export type DigitalTwinsQueryHookResult = ReturnType<typeof useDigitalTwinsQuery>;
export type DigitalTwinsLazyQueryHookResult = ReturnType<typeof useDigitalTwinsLazyQuery>;
export type DigitalTwinsSuspenseQueryHookResult = ReturnType<typeof useDigitalTwinsSuspenseQuery>;
export type DigitalTwinsQueryResult = Apollo.QueryResult<DigitalTwinsQuery, DigitalTwinsQueryVariables>;
export const GetDigitalTwinDocument = gql`
    query GetDigitalTwin($id: String!) {
  getDigitalTwinWithProjects(id: $id) {
    ...DigitalTwinViewData
  }
}
    ${DigitalTwinViewDataFragmentDoc}`;

/**
 * __useGetDigitalTwinQuery__
 *
 * To run a query within a React component, call `useGetDigitalTwinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDigitalTwinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDigitalTwinQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDigitalTwinQuery(baseOptions: Apollo.QueryHookOptions<GetDigitalTwinQuery, GetDigitalTwinQueryVariables> & ({ variables: GetDigitalTwinQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDigitalTwinQuery, GetDigitalTwinQueryVariables>(GetDigitalTwinDocument, options);
      }
export function useGetDigitalTwinLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDigitalTwinQuery, GetDigitalTwinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDigitalTwinQuery, GetDigitalTwinQueryVariables>(GetDigitalTwinDocument, options);
        }
// @ts-ignore
export function useGetDigitalTwinSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDigitalTwinQuery, GetDigitalTwinQueryVariables>): Apollo.UseSuspenseQueryResult<GetDigitalTwinQuery, GetDigitalTwinQueryVariables>;
export function useGetDigitalTwinSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDigitalTwinQuery, GetDigitalTwinQueryVariables>): Apollo.UseSuspenseQueryResult<GetDigitalTwinQuery | undefined, GetDigitalTwinQueryVariables>;
export function useGetDigitalTwinSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDigitalTwinQuery, GetDigitalTwinQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDigitalTwinQuery, GetDigitalTwinQueryVariables>(GetDigitalTwinDocument, options);
        }
export type GetDigitalTwinQueryHookResult = ReturnType<typeof useGetDigitalTwinQuery>;
export type GetDigitalTwinLazyQueryHookResult = ReturnType<typeof useGetDigitalTwinLazyQuery>;
export type GetDigitalTwinSuspenseQueryHookResult = ReturnType<typeof useGetDigitalTwinSuspenseQuery>;
export type GetDigitalTwinQueryResult = Apollo.QueryResult<GetDigitalTwinQuery, GetDigitalTwinQueryVariables>;
export const GetBehaviorChangesCountForDigitalTwinDocument = gql`
    query GetBehaviorChangesCountForDigitalTwin($digitalTwinId: String!) {
  getBehaviorChangesCountForDigitalTwin(digitalTwinId: $digitalTwinId)
}
    `;

/**
 * __useGetBehaviorChangesCountForDigitalTwinQuery__
 *
 * To run a query within a React component, call `useGetBehaviorChangesCountForDigitalTwinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBehaviorChangesCountForDigitalTwinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBehaviorChangesCountForDigitalTwinQuery({
 *   variables: {
 *      digitalTwinId: // value for 'digitalTwinId'
 *   },
 * });
 */
export function useGetBehaviorChangesCountForDigitalTwinQuery(baseOptions: Apollo.QueryHookOptions<GetBehaviorChangesCountForDigitalTwinQuery, GetBehaviorChangesCountForDigitalTwinQueryVariables> & ({ variables: GetBehaviorChangesCountForDigitalTwinQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBehaviorChangesCountForDigitalTwinQuery, GetBehaviorChangesCountForDigitalTwinQueryVariables>(GetBehaviorChangesCountForDigitalTwinDocument, options);
      }
export function useGetBehaviorChangesCountForDigitalTwinLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBehaviorChangesCountForDigitalTwinQuery, GetBehaviorChangesCountForDigitalTwinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBehaviorChangesCountForDigitalTwinQuery, GetBehaviorChangesCountForDigitalTwinQueryVariables>(GetBehaviorChangesCountForDigitalTwinDocument, options);
        }
// @ts-ignore
export function useGetBehaviorChangesCountForDigitalTwinSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBehaviorChangesCountForDigitalTwinQuery, GetBehaviorChangesCountForDigitalTwinQueryVariables>): Apollo.UseSuspenseQueryResult<GetBehaviorChangesCountForDigitalTwinQuery, GetBehaviorChangesCountForDigitalTwinQueryVariables>;
export function useGetBehaviorChangesCountForDigitalTwinSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBehaviorChangesCountForDigitalTwinQuery, GetBehaviorChangesCountForDigitalTwinQueryVariables>): Apollo.UseSuspenseQueryResult<GetBehaviorChangesCountForDigitalTwinQuery | undefined, GetBehaviorChangesCountForDigitalTwinQueryVariables>;
export function useGetBehaviorChangesCountForDigitalTwinSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBehaviorChangesCountForDigitalTwinQuery, GetBehaviorChangesCountForDigitalTwinQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBehaviorChangesCountForDigitalTwinQuery, GetBehaviorChangesCountForDigitalTwinQueryVariables>(GetBehaviorChangesCountForDigitalTwinDocument, options);
        }
export type GetBehaviorChangesCountForDigitalTwinQueryHookResult = ReturnType<typeof useGetBehaviorChangesCountForDigitalTwinQuery>;
export type GetBehaviorChangesCountForDigitalTwinLazyQueryHookResult = ReturnType<typeof useGetBehaviorChangesCountForDigitalTwinLazyQuery>;
export type GetBehaviorChangesCountForDigitalTwinSuspenseQueryHookResult = ReturnType<typeof useGetBehaviorChangesCountForDigitalTwinSuspenseQuery>;
export type GetBehaviorChangesCountForDigitalTwinQueryResult = Apollo.QueryResult<GetBehaviorChangesCountForDigitalTwinQuery, GetBehaviorChangesCountForDigitalTwinQueryVariables>;
export const CreateEvaluationDocument = gql`
    mutation CreateEvaluation($evaluationName: String!, $fileUrl: String!) {
  createEvaluation(evaluationName: $evaluationName, fileUrl: $fileUrl) {
    success
    evaluationId
    errorMessage
    errorCode
  }
}
    `;
export type CreateEvaluationMutationFn = Apollo.MutationFunction<CreateEvaluationMutation, CreateEvaluationMutationVariables>;

/**
 * __useCreateEvaluationMutation__
 *
 * To run a mutation, you first call `useCreateEvaluationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEvaluationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEvaluationMutation, { data, loading, error }] = useCreateEvaluationMutation({
 *   variables: {
 *      evaluationName: // value for 'evaluationName'
 *      fileUrl: // value for 'fileUrl'
 *   },
 * });
 */
export function useCreateEvaluationMutation(baseOptions?: Apollo.MutationHookOptions<CreateEvaluationMutation, CreateEvaluationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEvaluationMutation, CreateEvaluationMutationVariables>(CreateEvaluationDocument, options);
      }
export type CreateEvaluationMutationHookResult = ReturnType<typeof useCreateEvaluationMutation>;
export type CreateEvaluationMutationResult = Apollo.MutationResult<CreateEvaluationMutation>;
export type CreateEvaluationMutationOptions = Apollo.BaseMutationOptions<CreateEvaluationMutation, CreateEvaluationMutationVariables>;
export const DeleteExplorableDocument = gql`
    mutation DeleteExplorable($id: String!) {
  deleteExplorable(id: $id)
}
    `;
export type DeleteExplorableMutationFn = Apollo.MutationFunction<DeleteExplorableMutation, DeleteExplorableMutationVariables>;

/**
 * __useDeleteExplorableMutation__
 *
 * To run a mutation, you first call `useDeleteExplorableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExplorableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExplorableMutation, { data, loading, error }] = useDeleteExplorableMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExplorableMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExplorableMutation, DeleteExplorableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExplorableMutation, DeleteExplorableMutationVariables>(DeleteExplorableDocument, options);
      }
export type DeleteExplorableMutationHookResult = ReturnType<typeof useDeleteExplorableMutation>;
export type DeleteExplorableMutationResult = Apollo.MutationResult<DeleteExplorableMutation>;
export type DeleteExplorableMutationOptions = Apollo.BaseMutationOptions<DeleteExplorableMutation, DeleteExplorableMutationVariables>;
export const DeletePersonaDocument = gql`
    mutation DeletePersona($id: String!) {
  deletePersona(id: $id)
}
    `;
export type DeletePersonaMutationFn = Apollo.MutationFunction<DeletePersonaMutation, DeletePersonaMutationVariables>;

/**
 * __useDeletePersonaMutation__
 *
 * To run a mutation, you first call `useDeletePersonaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePersonaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePersonaMutation, { data, loading, error }] = useDeletePersonaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePersonaMutation(baseOptions?: Apollo.MutationHookOptions<DeletePersonaMutation, DeletePersonaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePersonaMutation, DeletePersonaMutationVariables>(DeletePersonaDocument, options);
      }
export type DeletePersonaMutationHookResult = ReturnType<typeof useDeletePersonaMutation>;
export type DeletePersonaMutationResult = Apollo.MutationResult<DeletePersonaMutation>;
export type DeletePersonaMutationOptions = Apollo.BaseMutationOptions<DeletePersonaMutation, DeletePersonaMutationVariables>;
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($name: String!) {
  createOrganization(name: $name) {
    id
    name
  }
}
    `;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const AddUserToOrganizationDocument = gql`
    mutation AddUserToOrganization($organizationId: String!, $userId: String!) {
  addUserToOrganization(organizationId: $organizationId, userId: $userId)
}
    `;
export type AddUserToOrganizationMutationFn = Apollo.MutationFunction<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>;

/**
 * __useAddUserToOrganizationMutation__
 *
 * To run a mutation, you first call `useAddUserToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToOrganizationMutation, { data, loading, error }] = useAddUserToOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddUserToOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>(AddUserToOrganizationDocument, options);
      }
export type AddUserToOrganizationMutationHookResult = ReturnType<typeof useAddUserToOrganizationMutation>;
export type AddUserToOrganizationMutationResult = Apollo.MutationResult<AddUserToOrganizationMutation>;
export type AddUserToOrganizationMutationOptions = Apollo.BaseMutationOptions<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>;
export const AddPersonaToCollectionDocument = gql`
    mutation AddPersonaToCollection($collectionId: String!, $personaId: String!) {
  addPersonaToCollection(collectionId: $collectionId, personaId: $personaId)
}
    `;
export type AddPersonaToCollectionMutationFn = Apollo.MutationFunction<AddPersonaToCollectionMutation, AddPersonaToCollectionMutationVariables>;

/**
 * __useAddPersonaToCollectionMutation__
 *
 * To run a mutation, you first call `useAddPersonaToCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPersonaToCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPersonaToCollectionMutation, { data, loading, error }] = useAddPersonaToCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      personaId: // value for 'personaId'
 *   },
 * });
 */
export function useAddPersonaToCollectionMutation(baseOptions?: Apollo.MutationHookOptions<AddPersonaToCollectionMutation, AddPersonaToCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPersonaToCollectionMutation, AddPersonaToCollectionMutationVariables>(AddPersonaToCollectionDocument, options);
      }
export type AddPersonaToCollectionMutationHookResult = ReturnType<typeof useAddPersonaToCollectionMutation>;
export type AddPersonaToCollectionMutationResult = Apollo.MutationResult<AddPersonaToCollectionMutation>;
export type AddPersonaToCollectionMutationOptions = Apollo.BaseMutationOptions<AddPersonaToCollectionMutation, AddPersonaToCollectionMutationVariables>;
export const ProfileDropdownDocument = gql`
    query ProfileDropdown {
  user {
    id
    canSendMessage
    currentOrganization {
      id
      name
    }
    organizations {
      id
      name
    }
    tokenConfiguration {
      id
      monthlyTokenLimit
      tokensUsedThisMonth
      resetDate
    }
  }
}
    `;

/**
 * __useProfileDropdownQuery__
 *
 * To run a query within a React component, call `useProfileDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileDropdownQuery(baseOptions?: Apollo.QueryHookOptions<ProfileDropdownQuery, ProfileDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileDropdownQuery, ProfileDropdownQueryVariables>(ProfileDropdownDocument, options);
      }
export function useProfileDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileDropdownQuery, ProfileDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileDropdownQuery, ProfileDropdownQueryVariables>(ProfileDropdownDocument, options);
        }
// @ts-ignore
export function useProfileDropdownSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProfileDropdownQuery, ProfileDropdownQueryVariables>): Apollo.UseSuspenseQueryResult<ProfileDropdownQuery, ProfileDropdownQueryVariables>;
export function useProfileDropdownSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileDropdownQuery, ProfileDropdownQueryVariables>): Apollo.UseSuspenseQueryResult<ProfileDropdownQuery | undefined, ProfileDropdownQueryVariables>;
export function useProfileDropdownSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileDropdownQuery, ProfileDropdownQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileDropdownQuery, ProfileDropdownQueryVariables>(ProfileDropdownDocument, options);
        }
export type ProfileDropdownQueryHookResult = ReturnType<typeof useProfileDropdownQuery>;
export type ProfileDropdownLazyQueryHookResult = ReturnType<typeof useProfileDropdownLazyQuery>;
export type ProfileDropdownSuspenseQueryHookResult = ReturnType<typeof useProfileDropdownSuspenseQuery>;
export type ProfileDropdownQueryResult = Apollo.QueryResult<ProfileDropdownQuery, ProfileDropdownQueryVariables>;
export const SetUserOrganizationDocument = gql`
    mutation SetUserOrganization($orgId: String!) {
  setUserOrganization(orgId: $orgId) {
    id
    currentOrganization {
      id
      name
    }
  }
}
    `;
export type SetUserOrganizationMutationFn = Apollo.MutationFunction<SetUserOrganizationMutation, SetUserOrganizationMutationVariables>;

/**
 * __useSetUserOrganizationMutation__
 *
 * To run a mutation, you first call `useSetUserOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserOrganizationMutation, { data, loading, error }] = useSetUserOrganizationMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useSetUserOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<SetUserOrganizationMutation, SetUserOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserOrganizationMutation, SetUserOrganizationMutationVariables>(SetUserOrganizationDocument, options);
      }
export type SetUserOrganizationMutationHookResult = ReturnType<typeof useSetUserOrganizationMutation>;
export type SetUserOrganizationMutationResult = Apollo.MutationResult<SetUserOrganizationMutation>;
export type SetUserOrganizationMutationOptions = Apollo.BaseMutationOptions<SetUserOrganizationMutation, SetUserOrganizationMutationVariables>;
export const GetMyCustomAgentsDocument = gql`
    query GetMyCustomAgents($ownedOnly: Boolean) {
  getMyCustomAgents(ownedOnly: $ownedOnly) {
    id
    name
    description
    avatarUrl
    organizationId
    status
    createdAt
    lastConnectionTestAt
    apiEndpoint
    apiAuthType
    systemPrompt
    temperature
    maxTokens
    isOwner
    owner {
      id
      fullName
      email
    }
    canEdit
    shareCount
    projectCount
    connectionType
    connectorStatus
    lastConnectorPingAt
    gatewayHealth
    gatewayHealthReason
    orgShares {
      organizationId
      organizationName
      canEdit
    }
  }
}
    `;

/**
 * __useGetMyCustomAgentsQuery__
 *
 * To run a query within a React component, call `useGetMyCustomAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCustomAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCustomAgentsQuery({
 *   variables: {
 *      ownedOnly: // value for 'ownedOnly'
 *   },
 * });
 */
export function useGetMyCustomAgentsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyCustomAgentsQuery, GetMyCustomAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCustomAgentsQuery, GetMyCustomAgentsQueryVariables>(GetMyCustomAgentsDocument, options);
      }
export function useGetMyCustomAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCustomAgentsQuery, GetMyCustomAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCustomAgentsQuery, GetMyCustomAgentsQueryVariables>(GetMyCustomAgentsDocument, options);
        }
// @ts-ignore
export function useGetMyCustomAgentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyCustomAgentsQuery, GetMyCustomAgentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyCustomAgentsQuery, GetMyCustomAgentsQueryVariables>;
export function useGetMyCustomAgentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyCustomAgentsQuery, GetMyCustomAgentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyCustomAgentsQuery | undefined, GetMyCustomAgentsQueryVariables>;
export function useGetMyCustomAgentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyCustomAgentsQuery, GetMyCustomAgentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyCustomAgentsQuery, GetMyCustomAgentsQueryVariables>(GetMyCustomAgentsDocument, options);
        }
export type GetMyCustomAgentsQueryHookResult = ReturnType<typeof useGetMyCustomAgentsQuery>;
export type GetMyCustomAgentsLazyQueryHookResult = ReturnType<typeof useGetMyCustomAgentsLazyQuery>;
export type GetMyCustomAgentsSuspenseQueryHookResult = ReturnType<typeof useGetMyCustomAgentsSuspenseQuery>;
export type GetMyCustomAgentsQueryResult = Apollo.QueryResult<GetMyCustomAgentsQuery, GetMyCustomAgentsQueryVariables>;
export const GetCustomAgentDocument = gql`
    query GetCustomAgent($id: String!) {
  getCustomAgent(id: $id) {
    id
    name
    description
    avatarUrl
    organizationId
    status
    createdAt
    lastConnectionTestAt
    apiEndpoint
    apiAuthType
    systemPrompt
    temperature
    maxTokens
    isOwner
    owner {
      id
      fullName
      email
    }
    canEdit
    shareCount
    projectCount
    snapshotEnabled
    snapshot {
      id
      createdAt
      updatedAt
      systemPrompt
      temperature
      maxTokens
      apiEndpoint
      apiAuthType
    }
    connectionType
    connectorStatus
    lastConnectorPingAt
    gatewayHealth
    gatewayHealthReason
    orgShares {
      organizationId
      organizationName
      canEdit
    }
  }
}
    `;

/**
 * __useGetCustomAgentQuery__
 *
 * To run a query within a React component, call `useGetCustomAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomAgentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomAgentQuery(baseOptions: Apollo.QueryHookOptions<GetCustomAgentQuery, GetCustomAgentQueryVariables> & ({ variables: GetCustomAgentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomAgentQuery, GetCustomAgentQueryVariables>(GetCustomAgentDocument, options);
      }
export function useGetCustomAgentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomAgentQuery, GetCustomAgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomAgentQuery, GetCustomAgentQueryVariables>(GetCustomAgentDocument, options);
        }
// @ts-ignore
export function useGetCustomAgentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomAgentQuery, GetCustomAgentQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomAgentQuery, GetCustomAgentQueryVariables>;
export function useGetCustomAgentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomAgentQuery, GetCustomAgentQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomAgentQuery | undefined, GetCustomAgentQueryVariables>;
export function useGetCustomAgentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomAgentQuery, GetCustomAgentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomAgentQuery, GetCustomAgentQueryVariables>(GetCustomAgentDocument, options);
        }
export type GetCustomAgentQueryHookResult = ReturnType<typeof useGetCustomAgentQuery>;
export type GetCustomAgentLazyQueryHookResult = ReturnType<typeof useGetCustomAgentLazyQuery>;
export type GetCustomAgentSuspenseQueryHookResult = ReturnType<typeof useGetCustomAgentSuspenseQuery>;
export type GetCustomAgentQueryResult = Apollo.QueryResult<GetCustomAgentQuery, GetCustomAgentQueryVariables>;
export const GetAgentCreationLimitsDocument = gql`
    query GetAgentCreationLimits {
  user {
    usageLimits {
      maxAgents
      currentAgentCount
      canCreateAgent
    }
  }
}
    `;

/**
 * __useGetAgentCreationLimitsQuery__
 *
 * To run a query within a React component, call `useGetAgentCreationLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentCreationLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentCreationLimitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgentCreationLimitsQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentCreationLimitsQuery, GetAgentCreationLimitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentCreationLimitsQuery, GetAgentCreationLimitsQueryVariables>(GetAgentCreationLimitsDocument, options);
      }
export function useGetAgentCreationLimitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentCreationLimitsQuery, GetAgentCreationLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentCreationLimitsQuery, GetAgentCreationLimitsQueryVariables>(GetAgentCreationLimitsDocument, options);
        }
// @ts-ignore
export function useGetAgentCreationLimitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentCreationLimitsQuery, GetAgentCreationLimitsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentCreationLimitsQuery, GetAgentCreationLimitsQueryVariables>;
export function useGetAgentCreationLimitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentCreationLimitsQuery, GetAgentCreationLimitsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentCreationLimitsQuery | undefined, GetAgentCreationLimitsQueryVariables>;
export function useGetAgentCreationLimitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentCreationLimitsQuery, GetAgentCreationLimitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentCreationLimitsQuery, GetAgentCreationLimitsQueryVariables>(GetAgentCreationLimitsDocument, options);
        }
export type GetAgentCreationLimitsQueryHookResult = ReturnType<typeof useGetAgentCreationLimitsQuery>;
export type GetAgentCreationLimitsLazyQueryHookResult = ReturnType<typeof useGetAgentCreationLimitsLazyQuery>;
export type GetAgentCreationLimitsSuspenseQueryHookResult = ReturnType<typeof useGetAgentCreationLimitsSuspenseQuery>;
export type GetAgentCreationLimitsQueryResult = Apollo.QueryResult<GetAgentCreationLimitsQuery, GetAgentCreationLimitsQueryVariables>;
export const GetAgentMonitoringLogsDocument = gql`
    query GetAgentMonitoringLogs($agentId: String!, $days: Int) {
  getAgentMonitoringLogs(agentId: $agentId, days: $days) {
    id
    scanDate
    status
    responseTime
    errorMessage
    behaviorFlags
  }
}
    `;

/**
 * __useGetAgentMonitoringLogsQuery__
 *
 * To run a query within a React component, call `useGetAgentMonitoringLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentMonitoringLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentMonitoringLogsQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      days: // value for 'days'
 *   },
 * });
 */
export function useGetAgentMonitoringLogsQuery(baseOptions: Apollo.QueryHookOptions<GetAgentMonitoringLogsQuery, GetAgentMonitoringLogsQueryVariables> & ({ variables: GetAgentMonitoringLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentMonitoringLogsQuery, GetAgentMonitoringLogsQueryVariables>(GetAgentMonitoringLogsDocument, options);
      }
export function useGetAgentMonitoringLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentMonitoringLogsQuery, GetAgentMonitoringLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentMonitoringLogsQuery, GetAgentMonitoringLogsQueryVariables>(GetAgentMonitoringLogsDocument, options);
        }
// @ts-ignore
export function useGetAgentMonitoringLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentMonitoringLogsQuery, GetAgentMonitoringLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentMonitoringLogsQuery, GetAgentMonitoringLogsQueryVariables>;
export function useGetAgentMonitoringLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentMonitoringLogsQuery, GetAgentMonitoringLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentMonitoringLogsQuery | undefined, GetAgentMonitoringLogsQueryVariables>;
export function useGetAgentMonitoringLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentMonitoringLogsQuery, GetAgentMonitoringLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentMonitoringLogsQuery, GetAgentMonitoringLogsQueryVariables>(GetAgentMonitoringLogsDocument, options);
        }
export type GetAgentMonitoringLogsQueryHookResult = ReturnType<typeof useGetAgentMonitoringLogsQuery>;
export type GetAgentMonitoringLogsLazyQueryHookResult = ReturnType<typeof useGetAgentMonitoringLogsLazyQuery>;
export type GetAgentMonitoringLogsSuspenseQueryHookResult = ReturnType<typeof useGetAgentMonitoringLogsSuspenseQuery>;
export type GetAgentMonitoringLogsQueryResult = Apollo.QueryResult<GetAgentMonitoringLogsQuery, GetAgentMonitoringLogsQueryVariables>;
export const GetAgentHealthSummaryDocument = gql`
    query GetAgentHealthSummary {
  getAgentHealthSummary {
    healthy
    warning
    error
    total
  }
}
    `;

/**
 * __useGetAgentHealthSummaryQuery__
 *
 * To run a query within a React component, call `useGetAgentHealthSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentHealthSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentHealthSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgentHealthSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentHealthSummaryQuery, GetAgentHealthSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentHealthSummaryQuery, GetAgentHealthSummaryQueryVariables>(GetAgentHealthSummaryDocument, options);
      }
export function useGetAgentHealthSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentHealthSummaryQuery, GetAgentHealthSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentHealthSummaryQuery, GetAgentHealthSummaryQueryVariables>(GetAgentHealthSummaryDocument, options);
        }
// @ts-ignore
export function useGetAgentHealthSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentHealthSummaryQuery, GetAgentHealthSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentHealthSummaryQuery, GetAgentHealthSummaryQueryVariables>;
export function useGetAgentHealthSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentHealthSummaryQuery, GetAgentHealthSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentHealthSummaryQuery | undefined, GetAgentHealthSummaryQueryVariables>;
export function useGetAgentHealthSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentHealthSummaryQuery, GetAgentHealthSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentHealthSummaryQuery, GetAgentHealthSummaryQueryVariables>(GetAgentHealthSummaryDocument, options);
        }
export type GetAgentHealthSummaryQueryHookResult = ReturnType<typeof useGetAgentHealthSummaryQuery>;
export type GetAgentHealthSummaryLazyQueryHookResult = ReturnType<typeof useGetAgentHealthSummaryLazyQuery>;
export type GetAgentHealthSummarySuspenseQueryHookResult = ReturnType<typeof useGetAgentHealthSummarySuspenseQuery>;
export type GetAgentHealthSummaryQueryResult = Apollo.QueryResult<GetAgentHealthSummaryQuery, GetAgentHealthSummaryQueryVariables>;
export const GetAgentsByProjectDocument = gql`
    query GetAgentsByProject($projectId: String!) {
  getAgentsByProject(projectId: $projectId) {
    id
    name
    description
    avatarUrl
    status
    lastConnectionTestAt
    isOwner
    canEdit
    shareCount
    connectionType
    connectorStatus
    lastConnectorPingAt
    gatewayHealth
    gatewayHealthReason
    orgShares {
      organizationId
      organizationName
      canEdit
    }
  }
}
    `;

/**
 * __useGetAgentsByProjectQuery__
 *
 * To run a query within a React component, call `useGetAgentsByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentsByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentsByProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetAgentsByProjectQuery(baseOptions: Apollo.QueryHookOptions<GetAgentsByProjectQuery, GetAgentsByProjectQueryVariables> & ({ variables: GetAgentsByProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentsByProjectQuery, GetAgentsByProjectQueryVariables>(GetAgentsByProjectDocument, options);
      }
export function useGetAgentsByProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentsByProjectQuery, GetAgentsByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentsByProjectQuery, GetAgentsByProjectQueryVariables>(GetAgentsByProjectDocument, options);
        }
// @ts-ignore
export function useGetAgentsByProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentsByProjectQuery, GetAgentsByProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentsByProjectQuery, GetAgentsByProjectQueryVariables>;
export function useGetAgentsByProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentsByProjectQuery, GetAgentsByProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentsByProjectQuery | undefined, GetAgentsByProjectQueryVariables>;
export function useGetAgentsByProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentsByProjectQuery, GetAgentsByProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentsByProjectQuery, GetAgentsByProjectQueryVariables>(GetAgentsByProjectDocument, options);
        }
export type GetAgentsByProjectQueryHookResult = ReturnType<typeof useGetAgentsByProjectQuery>;
export type GetAgentsByProjectLazyQueryHookResult = ReturnType<typeof useGetAgentsByProjectLazyQuery>;
export type GetAgentsByProjectSuspenseQueryHookResult = ReturnType<typeof useGetAgentsByProjectSuspenseQuery>;
export type GetAgentsByProjectQueryResult = Apollo.QueryResult<GetAgentsByProjectQuery, GetAgentsByProjectQueryVariables>;
export const CreateCustomAgentDocument = gql`
    mutation CreateCustomAgent($input: CreateCustomAgentInput!) {
  createCustomAgent(input: $input) {
    id
    name
    description
    avatarUrl
    organizationId
    status
    lastConnectionTestAt
    apiEndpoint
    apiAuthType
    systemPrompt
    temperature
    maxTokens
    isOwner
    canEdit
    shareCount
    projectCount
    connectionType
    connectorStatus
    lastConnectorPingAt
    gatewayHealth
    gatewayHealthReason
    orgShares {
      organizationId
      organizationName
      canEdit
    }
  }
}
    `;
export type CreateCustomAgentMutationFn = Apollo.MutationFunction<CreateCustomAgentMutation, CreateCustomAgentMutationVariables>;

/**
 * __useCreateCustomAgentMutation__
 *
 * To run a mutation, you first call `useCreateCustomAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomAgentMutation, { data, loading, error }] = useCreateCustomAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomAgentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomAgentMutation, CreateCustomAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomAgentMutation, CreateCustomAgentMutationVariables>(CreateCustomAgentDocument, options);
      }
export type CreateCustomAgentMutationHookResult = ReturnType<typeof useCreateCustomAgentMutation>;
export type CreateCustomAgentMutationResult = Apollo.MutationResult<CreateCustomAgentMutation>;
export type CreateCustomAgentMutationOptions = Apollo.BaseMutationOptions<CreateCustomAgentMutation, CreateCustomAgentMutationVariables>;
export const UpdateCustomAgentDocument = gql`
    mutation UpdateCustomAgent($id: String!, $input: UpdateCustomAgentInput!) {
  updateCustomAgent(id: $id, input: $input) {
    id
    name
    description
    avatarUrl
    organizationId
    status
    lastConnectionTestAt
    apiEndpoint
    apiAuthType
    systemPrompt
    temperature
    maxTokens
    isOwner
    canEdit
    shareCount
    projectCount
    snapshotEnabled
    snapshot {
      id
      createdAt
      updatedAt
    }
    connectionType
    connectorStatus
    lastConnectorPingAt
    gatewayHealth
    gatewayHealthReason
    orgShares {
      organizationId
      organizationName
      canEdit
    }
  }
}
    `;
export type UpdateCustomAgentMutationFn = Apollo.MutationFunction<UpdateCustomAgentMutation, UpdateCustomAgentMutationVariables>;

/**
 * __useUpdateCustomAgentMutation__
 *
 * To run a mutation, you first call `useUpdateCustomAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomAgentMutation, { data, loading, error }] = useUpdateCustomAgentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomAgentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomAgentMutation, UpdateCustomAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomAgentMutation, UpdateCustomAgentMutationVariables>(UpdateCustomAgentDocument, options);
      }
export type UpdateCustomAgentMutationHookResult = ReturnType<typeof useUpdateCustomAgentMutation>;
export type UpdateCustomAgentMutationResult = Apollo.MutationResult<UpdateCustomAgentMutation>;
export type UpdateCustomAgentMutationOptions = Apollo.BaseMutationOptions<UpdateCustomAgentMutation, UpdateCustomAgentMutationVariables>;
export const DeleteCustomAgentDocument = gql`
    mutation DeleteCustomAgent($id: String!) {
  deleteCustomAgent(id: $id)
}
    `;
export type DeleteCustomAgentMutationFn = Apollo.MutationFunction<DeleteCustomAgentMutation, DeleteCustomAgentMutationVariables>;

/**
 * __useDeleteCustomAgentMutation__
 *
 * To run a mutation, you first call `useDeleteCustomAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomAgentMutation, { data, loading, error }] = useDeleteCustomAgentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomAgentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomAgentMutation, DeleteCustomAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomAgentMutation, DeleteCustomAgentMutationVariables>(DeleteCustomAgentDocument, options);
      }
export type DeleteCustomAgentMutationHookResult = ReturnType<typeof useDeleteCustomAgentMutation>;
export type DeleteCustomAgentMutationResult = Apollo.MutationResult<DeleteCustomAgentMutation>;
export type DeleteCustomAgentMutationOptions = Apollo.BaseMutationOptions<DeleteCustomAgentMutation, DeleteCustomAgentMutationVariables>;
export const ShareAgentWithOrganizationDocument = gql`
    mutation ShareAgentWithOrganization($agentId: String!, $organizationId: String!, $canEdit: Boolean) {
  shareAgentWithOrganization(
    agentId: $agentId
    organizationId: $organizationId
    canEdit: $canEdit
  ) {
    id
    shareCount
    orgShares {
      organizationId
      organizationName
      canEdit
    }
  }
}
    `;
export type ShareAgentWithOrganizationMutationFn = Apollo.MutationFunction<ShareAgentWithOrganizationMutation, ShareAgentWithOrganizationMutationVariables>;

/**
 * __useShareAgentWithOrganizationMutation__
 *
 * To run a mutation, you first call `useShareAgentWithOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareAgentWithOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareAgentWithOrganizationMutation, { data, loading, error }] = useShareAgentWithOrganizationMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      organizationId: // value for 'organizationId'
 *      canEdit: // value for 'canEdit'
 *   },
 * });
 */
export function useShareAgentWithOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<ShareAgentWithOrganizationMutation, ShareAgentWithOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareAgentWithOrganizationMutation, ShareAgentWithOrganizationMutationVariables>(ShareAgentWithOrganizationDocument, options);
      }
export type ShareAgentWithOrganizationMutationHookResult = ReturnType<typeof useShareAgentWithOrganizationMutation>;
export type ShareAgentWithOrganizationMutationResult = Apollo.MutationResult<ShareAgentWithOrganizationMutation>;
export type ShareAgentWithOrganizationMutationOptions = Apollo.BaseMutationOptions<ShareAgentWithOrganizationMutation, ShareAgentWithOrganizationMutationVariables>;
export const UnshareAgentWithOrganizationDocument = gql`
    mutation UnshareAgentWithOrganization($agentId: String!, $organizationId: String!) {
  unshareAgentWithOrganization(agentId: $agentId, organizationId: $organizationId) {
    id
    shareCount
    orgShares {
      organizationId
      organizationName
      canEdit
    }
  }
}
    `;
export type UnshareAgentWithOrganizationMutationFn = Apollo.MutationFunction<UnshareAgentWithOrganizationMutation, UnshareAgentWithOrganizationMutationVariables>;

/**
 * __useUnshareAgentWithOrganizationMutation__
 *
 * To run a mutation, you first call `useUnshareAgentWithOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnshareAgentWithOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unshareAgentWithOrganizationMutation, { data, loading, error }] = useUnshareAgentWithOrganizationMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useUnshareAgentWithOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UnshareAgentWithOrganizationMutation, UnshareAgentWithOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnshareAgentWithOrganizationMutation, UnshareAgentWithOrganizationMutationVariables>(UnshareAgentWithOrganizationDocument, options);
      }
export type UnshareAgentWithOrganizationMutationHookResult = ReturnType<typeof useUnshareAgentWithOrganizationMutation>;
export type UnshareAgentWithOrganizationMutationResult = Apollo.MutationResult<UnshareAgentWithOrganizationMutation>;
export type UnshareAgentWithOrganizationMutationOptions = Apollo.BaseMutationOptions<UnshareAgentWithOrganizationMutation, UnshareAgentWithOrganizationMutationVariables>;
export const AddAgentToProjectDocument = gql`
    mutation AddAgentToProject($agentId: String!, $projectId: String!) {
  addAgentToProject(agentId: $agentId, projectId: $projectId)
}
    `;
export type AddAgentToProjectMutationFn = Apollo.MutationFunction<AddAgentToProjectMutation, AddAgentToProjectMutationVariables>;

/**
 * __useAddAgentToProjectMutation__
 *
 * To run a mutation, you first call `useAddAgentToProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAgentToProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAgentToProjectMutation, { data, loading, error }] = useAddAgentToProjectMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useAddAgentToProjectMutation(baseOptions?: Apollo.MutationHookOptions<AddAgentToProjectMutation, AddAgentToProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAgentToProjectMutation, AddAgentToProjectMutationVariables>(AddAgentToProjectDocument, options);
      }
export type AddAgentToProjectMutationHookResult = ReturnType<typeof useAddAgentToProjectMutation>;
export type AddAgentToProjectMutationResult = Apollo.MutationResult<AddAgentToProjectMutation>;
export type AddAgentToProjectMutationOptions = Apollo.BaseMutationOptions<AddAgentToProjectMutation, AddAgentToProjectMutationVariables>;
export const RemoveAgentFromProjectDocument = gql`
    mutation RemoveAgentFromProject($agentId: String!, $projectId: String!) {
  removeAgentFromProject(agentId: $agentId, projectId: $projectId)
}
    `;
export type RemoveAgentFromProjectMutationFn = Apollo.MutationFunction<RemoveAgentFromProjectMutation, RemoveAgentFromProjectMutationVariables>;

/**
 * __useRemoveAgentFromProjectMutation__
 *
 * To run a mutation, you first call `useRemoveAgentFromProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAgentFromProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAgentFromProjectMutation, { data, loading, error }] = useRemoveAgentFromProjectMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useRemoveAgentFromProjectMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAgentFromProjectMutation, RemoveAgentFromProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAgentFromProjectMutation, RemoveAgentFromProjectMutationVariables>(RemoveAgentFromProjectDocument, options);
      }
export type RemoveAgentFromProjectMutationHookResult = ReturnType<typeof useRemoveAgentFromProjectMutation>;
export type RemoveAgentFromProjectMutationResult = Apollo.MutationResult<RemoveAgentFromProjectMutation>;
export type RemoveAgentFromProjectMutationOptions = Apollo.BaseMutationOptions<RemoveAgentFromProjectMutation, RemoveAgentFromProjectMutationVariables>;
export const VerifyAgentDocument = gql`
    mutation VerifyAgent($agentId: String!) {
  verifyAgent(agentId: $agentId) {
    id
    status
    lastConnectionTestAt
  }
}
    `;
export type VerifyAgentMutationFn = Apollo.MutationFunction<VerifyAgentMutation, VerifyAgentMutationVariables>;

/**
 * __useVerifyAgentMutation__
 *
 * To run a mutation, you first call `useVerifyAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAgentMutation, { data, loading, error }] = useVerifyAgentMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useVerifyAgentMutation(baseOptions?: Apollo.MutationHookOptions<VerifyAgentMutation, VerifyAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyAgentMutation, VerifyAgentMutationVariables>(VerifyAgentDocument, options);
      }
export type VerifyAgentMutationHookResult = ReturnType<typeof useVerifyAgentMutation>;
export type VerifyAgentMutationResult = Apollo.MutationResult<VerifyAgentMutation>;
export type VerifyAgentMutationOptions = Apollo.BaseMutationOptions<VerifyAgentMutation, VerifyAgentMutationVariables>;
export const GetMyAgentCollectionsDocument = gql`
    query GetMyAgentCollections {
  getMyAgentCollections {
    id
    name
    description
    createdAt
    updatedAt
    agentCount
    digitalTwinCount
    agents {
      id
      name
      status
      connectionType
      connectorStatus
      gatewayHealth
      gatewayHealthReason
    }
    digitalTwins {
      id
      type
    }
  }
}
    `;

/**
 * __useGetMyAgentCollectionsQuery__
 *
 * To run a query within a React component, call `useGetMyAgentCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAgentCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAgentCollectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyAgentCollectionsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyAgentCollectionsQuery, GetMyAgentCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAgentCollectionsQuery, GetMyAgentCollectionsQueryVariables>(GetMyAgentCollectionsDocument, options);
      }
export function useGetMyAgentCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAgentCollectionsQuery, GetMyAgentCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAgentCollectionsQuery, GetMyAgentCollectionsQueryVariables>(GetMyAgentCollectionsDocument, options);
        }
// @ts-ignore
export function useGetMyAgentCollectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyAgentCollectionsQuery, GetMyAgentCollectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyAgentCollectionsQuery, GetMyAgentCollectionsQueryVariables>;
export function useGetMyAgentCollectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyAgentCollectionsQuery, GetMyAgentCollectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyAgentCollectionsQuery | undefined, GetMyAgentCollectionsQueryVariables>;
export function useGetMyAgentCollectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyAgentCollectionsQuery, GetMyAgentCollectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyAgentCollectionsQuery, GetMyAgentCollectionsQueryVariables>(GetMyAgentCollectionsDocument, options);
        }
export type GetMyAgentCollectionsQueryHookResult = ReturnType<typeof useGetMyAgentCollectionsQuery>;
export type GetMyAgentCollectionsLazyQueryHookResult = ReturnType<typeof useGetMyAgentCollectionsLazyQuery>;
export type GetMyAgentCollectionsSuspenseQueryHookResult = ReturnType<typeof useGetMyAgentCollectionsSuspenseQuery>;
export type GetMyAgentCollectionsQueryResult = Apollo.QueryResult<GetMyAgentCollectionsQuery, GetMyAgentCollectionsQueryVariables>;
export const GetAgentCollectionDocument = gql`
    query GetAgentCollection($id: String!) {
  getAgentCollection(id: $id) {
    id
    name
    description
    createdAt
    updatedAt
    agentCount
    digitalTwinCount
    agents {
      id
      name
      description
      avatarUrl
      status
      lastConnectionTestAt
      isOwner
      canEdit
      connectionType
      connectorStatus
      lastConnectorPingAt
      gatewayHealth
      gatewayHealthReason
    }
    digitalTwins {
      id
      name
      type
    }
  }
}
    `;

/**
 * __useGetAgentCollectionQuery__
 *
 * To run a query within a React component, call `useGetAgentCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentCollectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAgentCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetAgentCollectionQuery, GetAgentCollectionQueryVariables> & ({ variables: GetAgentCollectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentCollectionQuery, GetAgentCollectionQueryVariables>(GetAgentCollectionDocument, options);
      }
export function useGetAgentCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentCollectionQuery, GetAgentCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentCollectionQuery, GetAgentCollectionQueryVariables>(GetAgentCollectionDocument, options);
        }
// @ts-ignore
export function useGetAgentCollectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentCollectionQuery, GetAgentCollectionQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentCollectionQuery, GetAgentCollectionQueryVariables>;
export function useGetAgentCollectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentCollectionQuery, GetAgentCollectionQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentCollectionQuery | undefined, GetAgentCollectionQueryVariables>;
export function useGetAgentCollectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentCollectionQuery, GetAgentCollectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentCollectionQuery, GetAgentCollectionQueryVariables>(GetAgentCollectionDocument, options);
        }
export type GetAgentCollectionQueryHookResult = ReturnType<typeof useGetAgentCollectionQuery>;
export type GetAgentCollectionLazyQueryHookResult = ReturnType<typeof useGetAgentCollectionLazyQuery>;
export type GetAgentCollectionSuspenseQueryHookResult = ReturnType<typeof useGetAgentCollectionSuspenseQuery>;
export type GetAgentCollectionQueryResult = Apollo.QueryResult<GetAgentCollectionQuery, GetAgentCollectionQueryVariables>;
export const CreateAgentCollectionDocument = gql`
    mutation CreateAgentCollection($input: CreateAgentCollectionInput!) {
  createAgentCollection(input: $input) {
    id
    name
    description
    createdAt
    updatedAt
    agentCount
  }
}
    `;
export type CreateAgentCollectionMutationFn = Apollo.MutationFunction<CreateAgentCollectionMutation, CreateAgentCollectionMutationVariables>;

/**
 * __useCreateAgentCollectionMutation__
 *
 * To run a mutation, you first call `useCreateAgentCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgentCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgentCollectionMutation, { data, loading, error }] = useCreateAgentCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgentCollectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgentCollectionMutation, CreateAgentCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgentCollectionMutation, CreateAgentCollectionMutationVariables>(CreateAgentCollectionDocument, options);
      }
export type CreateAgentCollectionMutationHookResult = ReturnType<typeof useCreateAgentCollectionMutation>;
export type CreateAgentCollectionMutationResult = Apollo.MutationResult<CreateAgentCollectionMutation>;
export type CreateAgentCollectionMutationOptions = Apollo.BaseMutationOptions<CreateAgentCollectionMutation, CreateAgentCollectionMutationVariables>;
export const UpdateAgentCollectionDocument = gql`
    mutation UpdateAgentCollection($id: String!, $input: UpdateAgentCollectionInput!) {
  updateAgentCollection(id: $id, input: $input) {
    id
    name
    description
    createdAt
    updatedAt
    agentCount
  }
}
    `;
export type UpdateAgentCollectionMutationFn = Apollo.MutationFunction<UpdateAgentCollectionMutation, UpdateAgentCollectionMutationVariables>;

/**
 * __useUpdateAgentCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateAgentCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgentCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgentCollectionMutation, { data, loading, error }] = useUpdateAgentCollectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAgentCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgentCollectionMutation, UpdateAgentCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgentCollectionMutation, UpdateAgentCollectionMutationVariables>(UpdateAgentCollectionDocument, options);
      }
export type UpdateAgentCollectionMutationHookResult = ReturnType<typeof useUpdateAgentCollectionMutation>;
export type UpdateAgentCollectionMutationResult = Apollo.MutationResult<UpdateAgentCollectionMutation>;
export type UpdateAgentCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateAgentCollectionMutation, UpdateAgentCollectionMutationVariables>;
export const DeleteAgentCollectionDocument = gql`
    mutation DeleteAgentCollection($id: String!) {
  deleteAgentCollection(id: $id)
}
    `;
export type DeleteAgentCollectionMutationFn = Apollo.MutationFunction<DeleteAgentCollectionMutation, DeleteAgentCollectionMutationVariables>;

/**
 * __useDeleteAgentCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteAgentCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAgentCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAgentCollectionMutation, { data, loading, error }] = useDeleteAgentCollectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAgentCollectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAgentCollectionMutation, DeleteAgentCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAgentCollectionMutation, DeleteAgentCollectionMutationVariables>(DeleteAgentCollectionDocument, options);
      }
export type DeleteAgentCollectionMutationHookResult = ReturnType<typeof useDeleteAgentCollectionMutation>;
export type DeleteAgentCollectionMutationResult = Apollo.MutationResult<DeleteAgentCollectionMutation>;
export type DeleteAgentCollectionMutationOptions = Apollo.BaseMutationOptions<DeleteAgentCollectionMutation, DeleteAgentCollectionMutationVariables>;
export const AddAgentToCollectionDocument = gql`
    mutation AddAgentToCollection($collectionId: String!, $agentId: String!) {
  addAgentToCollection(collectionId: $collectionId, agentId: $agentId) {
    id
    name
    agentCount
  }
}
    `;
export type AddAgentToCollectionMutationFn = Apollo.MutationFunction<AddAgentToCollectionMutation, AddAgentToCollectionMutationVariables>;

/**
 * __useAddAgentToCollectionMutation__
 *
 * To run a mutation, you first call `useAddAgentToCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAgentToCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAgentToCollectionMutation, { data, loading, error }] = useAddAgentToCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useAddAgentToCollectionMutation(baseOptions?: Apollo.MutationHookOptions<AddAgentToCollectionMutation, AddAgentToCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAgentToCollectionMutation, AddAgentToCollectionMutationVariables>(AddAgentToCollectionDocument, options);
      }
export type AddAgentToCollectionMutationHookResult = ReturnType<typeof useAddAgentToCollectionMutation>;
export type AddAgentToCollectionMutationResult = Apollo.MutationResult<AddAgentToCollectionMutation>;
export type AddAgentToCollectionMutationOptions = Apollo.BaseMutationOptions<AddAgentToCollectionMutation, AddAgentToCollectionMutationVariables>;
export const RemoveAgentFromCollectionDocument = gql`
    mutation RemoveAgentFromCollection($collectionId: String!, $agentId: String!) {
  removeAgentFromCollection(collectionId: $collectionId, agentId: $agentId) {
    id
    name
    agentCount
  }
}
    `;
export type RemoveAgentFromCollectionMutationFn = Apollo.MutationFunction<RemoveAgentFromCollectionMutation, RemoveAgentFromCollectionMutationVariables>;

/**
 * __useRemoveAgentFromCollectionMutation__
 *
 * To run a mutation, you first call `useRemoveAgentFromCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAgentFromCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAgentFromCollectionMutation, { data, loading, error }] = useRemoveAgentFromCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useRemoveAgentFromCollectionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAgentFromCollectionMutation, RemoveAgentFromCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAgentFromCollectionMutation, RemoveAgentFromCollectionMutationVariables>(RemoveAgentFromCollectionDocument, options);
      }
export type RemoveAgentFromCollectionMutationHookResult = ReturnType<typeof useRemoveAgentFromCollectionMutation>;
export type RemoveAgentFromCollectionMutationResult = Apollo.MutationResult<RemoveAgentFromCollectionMutation>;
export type RemoveAgentFromCollectionMutationOptions = Apollo.BaseMutationOptions<RemoveAgentFromCollectionMutation, RemoveAgentFromCollectionMutationVariables>;
export const AddDigitalTwinToCollectionDocument = gql`
    mutation AddDigitalTwinToCollection($collectionId: String!, $digitalTwinId: String!) {
  addDigitalTwinToCollection(
    collectionId: $collectionId
    digitalTwinId: $digitalTwinId
  ) {
    id
    name
    agentCount
    digitalTwinCount
  }
}
    `;
export type AddDigitalTwinToCollectionMutationFn = Apollo.MutationFunction<AddDigitalTwinToCollectionMutation, AddDigitalTwinToCollectionMutationVariables>;

/**
 * __useAddDigitalTwinToCollectionMutation__
 *
 * To run a mutation, you first call `useAddDigitalTwinToCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDigitalTwinToCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDigitalTwinToCollectionMutation, { data, loading, error }] = useAddDigitalTwinToCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      digitalTwinId: // value for 'digitalTwinId'
 *   },
 * });
 */
export function useAddDigitalTwinToCollectionMutation(baseOptions?: Apollo.MutationHookOptions<AddDigitalTwinToCollectionMutation, AddDigitalTwinToCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDigitalTwinToCollectionMutation, AddDigitalTwinToCollectionMutationVariables>(AddDigitalTwinToCollectionDocument, options);
      }
export type AddDigitalTwinToCollectionMutationHookResult = ReturnType<typeof useAddDigitalTwinToCollectionMutation>;
export type AddDigitalTwinToCollectionMutationResult = Apollo.MutationResult<AddDigitalTwinToCollectionMutation>;
export type AddDigitalTwinToCollectionMutationOptions = Apollo.BaseMutationOptions<AddDigitalTwinToCollectionMutation, AddDigitalTwinToCollectionMutationVariables>;
export const RemoveDigitalTwinFromCollectionDocument = gql`
    mutation RemoveDigitalTwinFromCollection($collectionId: String!, $digitalTwinId: String!) {
  removeDigitalTwinFromCollection(
    collectionId: $collectionId
    digitalTwinId: $digitalTwinId
  ) {
    id
    name
    agentCount
    digitalTwinCount
  }
}
    `;
export type RemoveDigitalTwinFromCollectionMutationFn = Apollo.MutationFunction<RemoveDigitalTwinFromCollectionMutation, RemoveDigitalTwinFromCollectionMutationVariables>;

/**
 * __useRemoveDigitalTwinFromCollectionMutation__
 *
 * To run a mutation, you first call `useRemoveDigitalTwinFromCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDigitalTwinFromCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDigitalTwinFromCollectionMutation, { data, loading, error }] = useRemoveDigitalTwinFromCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      digitalTwinId: // value for 'digitalTwinId'
 *   },
 * });
 */
export function useRemoveDigitalTwinFromCollectionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDigitalTwinFromCollectionMutation, RemoveDigitalTwinFromCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDigitalTwinFromCollectionMutation, RemoveDigitalTwinFromCollectionMutationVariables>(RemoveDigitalTwinFromCollectionDocument, options);
      }
export type RemoveDigitalTwinFromCollectionMutationHookResult = ReturnType<typeof useRemoveDigitalTwinFromCollectionMutation>;
export type RemoveDigitalTwinFromCollectionMutationResult = Apollo.MutationResult<RemoveDigitalTwinFromCollectionMutation>;
export type RemoveDigitalTwinFromCollectionMutationOptions = Apollo.BaseMutationOptions<RemoveDigitalTwinFromCollectionMutation, RemoveDigitalTwinFromCollectionMutationVariables>;
export const RevertAgentToSnapshotDocument = gql`
    mutation RevertAgentToSnapshot($agentId: String!) {
  revertAgentToSnapshot(agentId: $agentId) {
    id
    systemPrompt
    temperature
    maxTokens
    snapshotEnabled
    snapshot {
      id
      createdAt
      updatedAt
    }
  }
}
    `;
export type RevertAgentToSnapshotMutationFn = Apollo.MutationFunction<RevertAgentToSnapshotMutation, RevertAgentToSnapshotMutationVariables>;

/**
 * __useRevertAgentToSnapshotMutation__
 *
 * To run a mutation, you first call `useRevertAgentToSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertAgentToSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertAgentToSnapshotMutation, { data, loading, error }] = useRevertAgentToSnapshotMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useRevertAgentToSnapshotMutation(baseOptions?: Apollo.MutationHookOptions<RevertAgentToSnapshotMutation, RevertAgentToSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevertAgentToSnapshotMutation, RevertAgentToSnapshotMutationVariables>(RevertAgentToSnapshotDocument, options);
      }
export type RevertAgentToSnapshotMutationHookResult = ReturnType<typeof useRevertAgentToSnapshotMutation>;
export type RevertAgentToSnapshotMutationResult = Apollo.MutationResult<RevertAgentToSnapshotMutation>;
export type RevertAgentToSnapshotMutationOptions = Apollo.BaseMutationOptions<RevertAgentToSnapshotMutation, RevertAgentToSnapshotMutationVariables>;
export const RefreshAgentSnapshotDocument = gql`
    mutation RefreshAgentSnapshot($agentId: String!) {
  refreshAgentSnapshot(agentId: $agentId) {
    id
    createdAt
    updatedAt
  }
}
    `;
export type RefreshAgentSnapshotMutationFn = Apollo.MutationFunction<RefreshAgentSnapshotMutation, RefreshAgentSnapshotMutationVariables>;

/**
 * __useRefreshAgentSnapshotMutation__
 *
 * To run a mutation, you first call `useRefreshAgentSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshAgentSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshAgentSnapshotMutation, { data, loading, error }] = useRefreshAgentSnapshotMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useRefreshAgentSnapshotMutation(baseOptions?: Apollo.MutationHookOptions<RefreshAgentSnapshotMutation, RefreshAgentSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshAgentSnapshotMutation, RefreshAgentSnapshotMutationVariables>(RefreshAgentSnapshotDocument, options);
      }
export type RefreshAgentSnapshotMutationHookResult = ReturnType<typeof useRefreshAgentSnapshotMutation>;
export type RefreshAgentSnapshotMutationResult = Apollo.MutationResult<RefreshAgentSnapshotMutation>;
export type RefreshAgentSnapshotMutationOptions = Apollo.BaseMutationOptions<RefreshAgentSnapshotMutation, RefreshAgentSnapshotMutationVariables>;
export const GenerateConnectorEnrollmentDocument = gql`
    mutation GenerateConnectorEnrollment($agentId: String!) {
  generateConnectorEnrollment(agentId: $agentId) {
    enrollmentCode
    expiresAt
    instructions
  }
}
    `;
export type GenerateConnectorEnrollmentMutationFn = Apollo.MutationFunction<GenerateConnectorEnrollmentMutation, GenerateConnectorEnrollmentMutationVariables>;

/**
 * __useGenerateConnectorEnrollmentMutation__
 *
 * To run a mutation, you first call `useGenerateConnectorEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateConnectorEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateConnectorEnrollmentMutation, { data, loading, error }] = useGenerateConnectorEnrollmentMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useGenerateConnectorEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<GenerateConnectorEnrollmentMutation, GenerateConnectorEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateConnectorEnrollmentMutation, GenerateConnectorEnrollmentMutationVariables>(GenerateConnectorEnrollmentDocument, options);
      }
export type GenerateConnectorEnrollmentMutationHookResult = ReturnType<typeof useGenerateConnectorEnrollmentMutation>;
export type GenerateConnectorEnrollmentMutationResult = Apollo.MutationResult<GenerateConnectorEnrollmentMutation>;
export type GenerateConnectorEnrollmentMutationOptions = Apollo.BaseMutationOptions<GenerateConnectorEnrollmentMutation, GenerateConnectorEnrollmentMutationVariables>;
export const RevokeConnectorEnrollmentDocument = gql`
    mutation RevokeConnectorEnrollment($agentId: String!) {
  revokeConnectorEnrollment(agentId: $agentId)
}
    `;
export type RevokeConnectorEnrollmentMutationFn = Apollo.MutationFunction<RevokeConnectorEnrollmentMutation, RevokeConnectorEnrollmentMutationVariables>;

/**
 * __useRevokeConnectorEnrollmentMutation__
 *
 * To run a mutation, you first call `useRevokeConnectorEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeConnectorEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeConnectorEnrollmentMutation, { data, loading, error }] = useRevokeConnectorEnrollmentMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useRevokeConnectorEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<RevokeConnectorEnrollmentMutation, RevokeConnectorEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeConnectorEnrollmentMutation, RevokeConnectorEnrollmentMutationVariables>(RevokeConnectorEnrollmentDocument, options);
      }
export type RevokeConnectorEnrollmentMutationHookResult = ReturnType<typeof useRevokeConnectorEnrollmentMutation>;
export type RevokeConnectorEnrollmentMutationResult = Apollo.MutationResult<RevokeConnectorEnrollmentMutation>;
export type RevokeConnectorEnrollmentMutationOptions = Apollo.BaseMutationOptions<RevokeConnectorEnrollmentMutation, RevokeConnectorEnrollmentMutationVariables>;
export const GetConnectorStatusDocument = gql`
    query GetConnectorStatus($agentId: String!) {
  getConnectorStatus(agentId: $agentId) {
    status
    lastPingAt
    connectedSince
    enrollmentStatus
    gatewayHealth
    gatewayHealthReason
  }
}
    `;

/**
 * __useGetConnectorStatusQuery__
 *
 * To run a query within a React component, call `useGetConnectorStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectorStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectorStatusQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useGetConnectorStatusQuery(baseOptions: Apollo.QueryHookOptions<GetConnectorStatusQuery, GetConnectorStatusQueryVariables> & ({ variables: GetConnectorStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectorStatusQuery, GetConnectorStatusQueryVariables>(GetConnectorStatusDocument, options);
      }
export function useGetConnectorStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectorStatusQuery, GetConnectorStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectorStatusQuery, GetConnectorStatusQueryVariables>(GetConnectorStatusDocument, options);
        }
// @ts-ignore
export function useGetConnectorStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConnectorStatusQuery, GetConnectorStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetConnectorStatusQuery, GetConnectorStatusQueryVariables>;
export function useGetConnectorStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConnectorStatusQuery, GetConnectorStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetConnectorStatusQuery | undefined, GetConnectorStatusQueryVariables>;
export function useGetConnectorStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConnectorStatusQuery, GetConnectorStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConnectorStatusQuery, GetConnectorStatusQueryVariables>(GetConnectorStatusDocument, options);
        }
export type GetConnectorStatusQueryHookResult = ReturnType<typeof useGetConnectorStatusQuery>;
export type GetConnectorStatusLazyQueryHookResult = ReturnType<typeof useGetConnectorStatusLazyQuery>;
export type GetConnectorStatusSuspenseQueryHookResult = ReturnType<typeof useGetConnectorStatusSuspenseQuery>;
export type GetConnectorStatusQueryResult = Apollo.QueryResult<GetConnectorStatusQuery, GetConnectorStatusQueryVariables>;
export const ProjectsDocument = gql`
    query Projects {
  user {
    id
    canCreateProject
    canSendMessage
    currentOrganization {
      id
      initialProjects {
        id
        numberTwins
        type
        createdByYou
        topic
        name
        status
        createdAt
        subtopics {
          name
        }
        digitalTwinType
        viewedAt
        subtopicsShortened
        topicShortened
      }
    }
  }
}
    `;

/**
 * __useProjectsQuery__
 *
 * To run a query within a React component, call `useProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectsQuery(baseOptions?: Apollo.QueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
      }
export function useProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
        }
// @ts-ignore
export function useProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectsQuery, ProjectsQueryVariables>;
export function useProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectsQuery | undefined, ProjectsQueryVariables>;
export function useProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
        }
export type ProjectsQueryHookResult = ReturnType<typeof useProjectsQuery>;
export type ProjectsLazyQueryHookResult = ReturnType<typeof useProjectsLazyQuery>;
export type ProjectsSuspenseQueryHookResult = ReturnType<typeof useProjectsSuspenseQuery>;
export type ProjectsQueryResult = Apollo.QueryResult<ProjectsQuery, ProjectsQueryVariables>;
export const ProjectTemplatesDocument = gql`
    query ProjectTemplates {
  user {
    id
    canCreateProject
    canSendMessage
  }
  getMyProjectTemplates {
    id
    topic
    topicShortened
    digitalTwinType
    subtopicsShortened
    createdByYou
    projectCount
    latestProjectDate
    latestCompletedProjectId
    hasCompletedProject
    agentCount
    latestProjectId
    latestProjectStatus
    latestProjectErrorMessage
    nextScheduledUpdate
    updateFrequency
    autoUpdateEnabled
    type
    agentName
  }
}
    `;

/**
 * __useProjectTemplatesQuery__
 *
 * To run a query within a React component, call `useProjectTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>(ProjectTemplatesDocument, options);
      }
export function useProjectTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>(ProjectTemplatesDocument, options);
        }
// @ts-ignore
export function useProjectTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>;
export function useProjectTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectTemplatesQuery | undefined, ProjectTemplatesQueryVariables>;
export function useProjectTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>(ProjectTemplatesDocument, options);
        }
export type ProjectTemplatesQueryHookResult = ReturnType<typeof useProjectTemplatesQuery>;
export type ProjectTemplatesLazyQueryHookResult = ReturnType<typeof useProjectTemplatesLazyQuery>;
export type ProjectTemplatesSuspenseQueryHookResult = ReturnType<typeof useProjectTemplatesSuspenseQuery>;
export type ProjectTemplatesQueryResult = Apollo.QueryResult<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>;
export const ProjectDocument = gql`
    query Project($id: String!) {
  getRecentConversationsBasicData(projectId: $id) {
    ...ConversationsBasicData
  }
  project(id: $id) {
    type
    sessionId
    evalInputTokens
    evalOutputTokens
    timelineProjects {
      id
      dateCreated
      evalInputTokens
      evalOutputTokens
    }
    files {
      id
      fileName
      fileUrl
    }
    createdByYou
    canManageWatch
    stagedAgents {
      id
      name
    }
    status
    errorMessage
    id
    digitalTwinType
    createdAt
    digitalTwinCollection {
      id
      name
      digitalTwins {
        ...DigitalTwinData
      }
    }
    topic
    name
    perspectives {
      ...PerspectiveBaseInfo
    }
    subtopics {
      name
      leftTitle
      rightTitle
    }
    questions {
      topic
      question
    }
    userSurveyResponse {
      id
      responses {
        question
        topic
        response
      }
    }
    projectTemplateId
  }
}
    ${ConversationsBasicDataFragmentDoc}
${DigitalTwinDataFragmentDoc}
${PerspectiveBaseInfoFragmentDoc}`;

/**
 * __useProjectQuery__
 *
 * To run a query within a React component, call `useProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectQuery(baseOptions: Apollo.QueryHookOptions<ProjectQuery, ProjectQueryVariables> & ({ variables: ProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, options);
      }
export function useProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectQuery, ProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, options);
        }
// @ts-ignore
export function useProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectQuery, ProjectQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectQuery, ProjectQueryVariables>;
export function useProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectQuery, ProjectQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectQuery | undefined, ProjectQueryVariables>;
export function useProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectQuery, ProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, options);
        }
export type ProjectQueryHookResult = ReturnType<typeof useProjectQuery>;
export type ProjectLazyQueryHookResult = ReturnType<typeof useProjectLazyQuery>;
export type ProjectSuspenseQueryHookResult = ReturnType<typeof useProjectSuspenseQuery>;
export type ProjectQueryResult = Apollo.QueryResult<ProjectQuery, ProjectQueryVariables>;
export const PerspectiveDocument = gql`
    query Perspective($id: String!) {
  getPerspective(id: $id) {
    ...PerspectiveBaseInfo
    opinions {
      id
      question
      answer
    }
    comparisons {
      id
      type
      score
      digitalTwin {
        ...DigitalTwinData
      }
      customAgent {
        ...CustomAgentPerspectiveData
      }
    }
  }
}
    ${PerspectiveBaseInfoFragmentDoc}
${DigitalTwinDataFragmentDoc}
${CustomAgentPerspectiveDataFragmentDoc}`;

/**
 * __usePerspectiveQuery__
 *
 * To run a query within a React component, call `usePerspectiveQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerspectiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerspectiveQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePerspectiveQuery(baseOptions: Apollo.QueryHookOptions<PerspectiveQuery, PerspectiveQueryVariables> & ({ variables: PerspectiveQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PerspectiveQuery, PerspectiveQueryVariables>(PerspectiveDocument, options);
      }
export function usePerspectiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PerspectiveQuery, PerspectiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PerspectiveQuery, PerspectiveQueryVariables>(PerspectiveDocument, options);
        }
// @ts-ignore
export function usePerspectiveSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PerspectiveQuery, PerspectiveQueryVariables>): Apollo.UseSuspenseQueryResult<PerspectiveQuery, PerspectiveQueryVariables>;
export function usePerspectiveSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PerspectiveQuery, PerspectiveQueryVariables>): Apollo.UseSuspenseQueryResult<PerspectiveQuery | undefined, PerspectiveQueryVariables>;
export function usePerspectiveSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PerspectiveQuery, PerspectiveQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PerspectiveQuery, PerspectiveQueryVariables>(PerspectiveDocument, options);
        }
export type PerspectiveQueryHookResult = ReturnType<typeof usePerspectiveQuery>;
export type PerspectiveLazyQueryHookResult = ReturnType<typeof usePerspectiveLazyQuery>;
export type PerspectiveSuspenseQueryHookResult = ReturnType<typeof usePerspectiveSuspenseQuery>;
export type PerspectiveQueryResult = Apollo.QueryResult<PerspectiveQuery, PerspectiveQueryVariables>;
export const CreateProjectProposalDocument = gql`
    mutation CreateProjectProposal($input: CreateProposalInput!) {
  createProposal(input: $input) {
    id
    title
    notes
    type
    createdByYou
    upvoteData {
      count
      upvotedByYou
    }
  }
}
    `;
export type CreateProjectProposalMutationFn = Apollo.MutationFunction<CreateProjectProposalMutation, CreateProjectProposalMutationVariables>;

/**
 * __useCreateProjectProposalMutation__
 *
 * To run a mutation, you first call `useCreateProjectProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectProposalMutation, { data, loading, error }] = useCreateProjectProposalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectProposalMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectProposalMutation, CreateProjectProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectProposalMutation, CreateProjectProposalMutationVariables>(CreateProjectProposalDocument, options);
      }
export type CreateProjectProposalMutationHookResult = ReturnType<typeof useCreateProjectProposalMutation>;
export type CreateProjectProposalMutationResult = Apollo.MutationResult<CreateProjectProposalMutation>;
export type CreateProjectProposalMutationOptions = Apollo.BaseMutationOptions<CreateProjectProposalMutation, CreateProjectProposalMutationVariables>;
export const MarkAsViewedDocument = gql`
    mutation MarkAsViewed($id: String!) {
  markProjectViewed(id: $id) {
    id
    viewedAt
  }
}
    `;
export type MarkAsViewedMutationFn = Apollo.MutationFunction<MarkAsViewedMutation, MarkAsViewedMutationVariables>;

/**
 * __useMarkAsViewedMutation__
 *
 * To run a mutation, you first call `useMarkAsViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAsViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAsViewedMutation, { data, loading, error }] = useMarkAsViewedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkAsViewedMutation(baseOptions?: Apollo.MutationHookOptions<MarkAsViewedMutation, MarkAsViewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAsViewedMutation, MarkAsViewedMutationVariables>(MarkAsViewedDocument, options);
      }
export type MarkAsViewedMutationHookResult = ReturnType<typeof useMarkAsViewedMutation>;
export type MarkAsViewedMutationResult = Apollo.MutationResult<MarkAsViewedMutation>;
export type MarkAsViewedMutationOptions = Apollo.BaseMutationOptions<MarkAsViewedMutation, MarkAsViewedMutationVariables>;
export const MarkTwisViewedDocument = gql`
    mutation MarkTwisViewed($id: String!) {
  markTwinViewed(id: $id)
}
    `;
export type MarkTwisViewedMutationFn = Apollo.MutationFunction<MarkTwisViewedMutation, MarkTwisViewedMutationVariables>;

/**
 * __useMarkTwisViewedMutation__
 *
 * To run a mutation, you first call `useMarkTwisViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkTwisViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markTwisViewedMutation, { data, loading, error }] = useMarkTwisViewedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkTwisViewedMutation(baseOptions?: Apollo.MutationHookOptions<MarkTwisViewedMutation, MarkTwisViewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkTwisViewedMutation, MarkTwisViewedMutationVariables>(MarkTwisViewedDocument, options);
      }
export type MarkTwisViewedMutationHookResult = ReturnType<typeof useMarkTwisViewedMutation>;
export type MarkTwisViewedMutationResult = Apollo.MutationResult<MarkTwisViewedMutation>;
export type MarkTwisViewedMutationOptions = Apollo.BaseMutationOptions<MarkTwisViewedMutation, MarkTwisViewedMutationVariables>;
export const DeleteProjectDocument = gql`
    mutation DeleteProject($id: String!) {
  deleteExplorable(id: $id)
}
    `;
export type DeleteProjectMutationFn = Apollo.MutationFunction<DeleteProjectMutation, DeleteProjectMutationVariables>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectMutation, DeleteProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, options);
      }
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const DeleteProjectTemplateDocument = gql`
    mutation DeleteProjectTemplate($id: String!) {
  deleteProjectTemplate(id: $id)
}
    `;
export type DeleteProjectTemplateMutationFn = Apollo.MutationFunction<DeleteProjectTemplateMutation, DeleteProjectTemplateMutationVariables>;

/**
 * __useDeleteProjectTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteProjectTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectTemplateMutation, { data, loading, error }] = useDeleteProjectTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectTemplateMutation, DeleteProjectTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectTemplateMutation, DeleteProjectTemplateMutationVariables>(DeleteProjectTemplateDocument, options);
      }
export type DeleteProjectTemplateMutationHookResult = ReturnType<typeof useDeleteProjectTemplateMutation>;
export type DeleteProjectTemplateMutationResult = Apollo.MutationResult<DeleteProjectTemplateMutation>;
export type DeleteProjectTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteProjectTemplateMutation, DeleteProjectTemplateMutationVariables>;
export const GetPerspectiveByDtTopicProjectDocument = gql`
    query GetPerspectiveByDtTopicProject($dtId: String!, $projectId: String!, $topic: String!) {
  getPerspectiveByDtTopicProject(
    dtId: $dtId
    projectId: $projectId
    topic: $topic
  ) {
    ...PerspectiveBaseInfo
    opinions {
      id
      question
      answer
    }
    comparisons {
      id
      type
      score
      digitalTwin {
        ...DigitalTwinData
      }
    }
  }
}
    ${PerspectiveBaseInfoFragmentDoc}
${DigitalTwinDataFragmentDoc}`;

/**
 * __useGetPerspectiveByDtTopicProjectQuery__
 *
 * To run a query within a React component, call `useGetPerspectiveByDtTopicProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPerspectiveByDtTopicProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPerspectiveByDtTopicProjectQuery({
 *   variables: {
 *      dtId: // value for 'dtId'
 *      projectId: // value for 'projectId'
 *      topic: // value for 'topic'
 *   },
 * });
 */
export function useGetPerspectiveByDtTopicProjectQuery(baseOptions: Apollo.QueryHookOptions<GetPerspectiveByDtTopicProjectQuery, GetPerspectiveByDtTopicProjectQueryVariables> & ({ variables: GetPerspectiveByDtTopicProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPerspectiveByDtTopicProjectQuery, GetPerspectiveByDtTopicProjectQueryVariables>(GetPerspectiveByDtTopicProjectDocument, options);
      }
export function useGetPerspectiveByDtTopicProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPerspectiveByDtTopicProjectQuery, GetPerspectiveByDtTopicProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPerspectiveByDtTopicProjectQuery, GetPerspectiveByDtTopicProjectQueryVariables>(GetPerspectiveByDtTopicProjectDocument, options);
        }
// @ts-ignore
export function useGetPerspectiveByDtTopicProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPerspectiveByDtTopicProjectQuery, GetPerspectiveByDtTopicProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetPerspectiveByDtTopicProjectQuery, GetPerspectiveByDtTopicProjectQueryVariables>;
export function useGetPerspectiveByDtTopicProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPerspectiveByDtTopicProjectQuery, GetPerspectiveByDtTopicProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetPerspectiveByDtTopicProjectQuery | undefined, GetPerspectiveByDtTopicProjectQueryVariables>;
export function useGetPerspectiveByDtTopicProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPerspectiveByDtTopicProjectQuery, GetPerspectiveByDtTopicProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPerspectiveByDtTopicProjectQuery, GetPerspectiveByDtTopicProjectQueryVariables>(GetPerspectiveByDtTopicProjectDocument, options);
        }
export type GetPerspectiveByDtTopicProjectQueryHookResult = ReturnType<typeof useGetPerspectiveByDtTopicProjectQuery>;
export type GetPerspectiveByDtTopicProjectLazyQueryHookResult = ReturnType<typeof useGetPerspectiveByDtTopicProjectLazyQuery>;
export type GetPerspectiveByDtTopicProjectSuspenseQueryHookResult = ReturnType<typeof useGetPerspectiveByDtTopicProjectSuspenseQuery>;
export type GetPerspectiveByDtTopicProjectQueryResult = Apollo.QueryResult<GetPerspectiveByDtTopicProjectQuery, GetPerspectiveByDtTopicProjectQueryVariables>;
export const GetAnswerSimilaritiesDocument = gql`
    query GetAnswerSimilarities($agentId: String!, $topic: String!, $versionAId: String!, $versionBId: String!) {
  getAnswerSimilarities(
    agentId: $agentId
    topic: $topic
    versionAId: $versionAId
    versionBId: $versionBId
  ) {
    question
    similarity
  }
}
    `;

/**
 * __useGetAnswerSimilaritiesQuery__
 *
 * To run a query within a React component, call `useGetAnswerSimilaritiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnswerSimilaritiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnswerSimilaritiesQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      topic: // value for 'topic'
 *      versionAId: // value for 'versionAId'
 *      versionBId: // value for 'versionBId'
 *   },
 * });
 */
export function useGetAnswerSimilaritiesQuery(baseOptions: Apollo.QueryHookOptions<GetAnswerSimilaritiesQuery, GetAnswerSimilaritiesQueryVariables> & ({ variables: GetAnswerSimilaritiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnswerSimilaritiesQuery, GetAnswerSimilaritiesQueryVariables>(GetAnswerSimilaritiesDocument, options);
      }
export function useGetAnswerSimilaritiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnswerSimilaritiesQuery, GetAnswerSimilaritiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnswerSimilaritiesQuery, GetAnswerSimilaritiesQueryVariables>(GetAnswerSimilaritiesDocument, options);
        }
// @ts-ignore
export function useGetAnswerSimilaritiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnswerSimilaritiesQuery, GetAnswerSimilaritiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnswerSimilaritiesQuery, GetAnswerSimilaritiesQueryVariables>;
export function useGetAnswerSimilaritiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnswerSimilaritiesQuery, GetAnswerSimilaritiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnswerSimilaritiesQuery | undefined, GetAnswerSimilaritiesQueryVariables>;
export function useGetAnswerSimilaritiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnswerSimilaritiesQuery, GetAnswerSimilaritiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnswerSimilaritiesQuery, GetAnswerSimilaritiesQueryVariables>(GetAnswerSimilaritiesDocument, options);
        }
export type GetAnswerSimilaritiesQueryHookResult = ReturnType<typeof useGetAnswerSimilaritiesQuery>;
export type GetAnswerSimilaritiesLazyQueryHookResult = ReturnType<typeof useGetAnswerSimilaritiesLazyQuery>;
export type GetAnswerSimilaritiesSuspenseQueryHookResult = ReturnType<typeof useGetAnswerSimilaritiesSuspenseQuery>;
export type GetAnswerSimilaritiesQueryResult = Apollo.QueryResult<GetAnswerSimilaritiesQuery, GetAnswerSimilaritiesQueryVariables>;
export const GetPlanSimilaritiesDocument = gql`
    query GetPlanSimilarities($agentId: String!, $versionAId: String!, $versionBId: String!) {
  getPlanSimilarities(
    agentId: $agentId
    versionAId: $versionAId
    versionBId: $versionBId
  ) {
    task
    similarity
  }
}
    `;

/**
 * __useGetPlanSimilaritiesQuery__
 *
 * To run a query within a React component, call `useGetPlanSimilaritiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanSimilaritiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanSimilaritiesQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      versionAId: // value for 'versionAId'
 *      versionBId: // value for 'versionBId'
 *   },
 * });
 */
export function useGetPlanSimilaritiesQuery(baseOptions: Apollo.QueryHookOptions<GetPlanSimilaritiesQuery, GetPlanSimilaritiesQueryVariables> & ({ variables: GetPlanSimilaritiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanSimilaritiesQuery, GetPlanSimilaritiesQueryVariables>(GetPlanSimilaritiesDocument, options);
      }
export function useGetPlanSimilaritiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanSimilaritiesQuery, GetPlanSimilaritiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanSimilaritiesQuery, GetPlanSimilaritiesQueryVariables>(GetPlanSimilaritiesDocument, options);
        }
// @ts-ignore
export function useGetPlanSimilaritiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlanSimilaritiesQuery, GetPlanSimilaritiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlanSimilaritiesQuery, GetPlanSimilaritiesQueryVariables>;
export function useGetPlanSimilaritiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanSimilaritiesQuery, GetPlanSimilaritiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlanSimilaritiesQuery | undefined, GetPlanSimilaritiesQueryVariables>;
export function useGetPlanSimilaritiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanSimilaritiesQuery, GetPlanSimilaritiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlanSimilaritiesQuery, GetPlanSimilaritiesQueryVariables>(GetPlanSimilaritiesDocument, options);
        }
export type GetPlanSimilaritiesQueryHookResult = ReturnType<typeof useGetPlanSimilaritiesQuery>;
export type GetPlanSimilaritiesLazyQueryHookResult = ReturnType<typeof useGetPlanSimilaritiesLazyQuery>;
export type GetPlanSimilaritiesSuspenseQueryHookResult = ReturnType<typeof useGetPlanSimilaritiesSuspenseQuery>;
export type GetPlanSimilaritiesQueryResult = Apollo.QueryResult<GetPlanSimilaritiesQuery, GetPlanSimilaritiesQueryVariables>;
export const GeneratePlanningTasksDocument = gql`
    mutation GeneratePlanningTasks($projectDescription: String!, $count: Int) {
  generatePlanningTasks(projectDescription: $projectDescription, count: $count) {
    name
    task
    prompt
  }
}
    `;
export type GeneratePlanningTasksMutationFn = Apollo.MutationFunction<GeneratePlanningTasksMutation, GeneratePlanningTasksMutationVariables>;

/**
 * __useGeneratePlanningTasksMutation__
 *
 * To run a mutation, you first call `useGeneratePlanningTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePlanningTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePlanningTasksMutation, { data, loading, error }] = useGeneratePlanningTasksMutation({
 *   variables: {
 *      projectDescription: // value for 'projectDescription'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGeneratePlanningTasksMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePlanningTasksMutation, GeneratePlanningTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePlanningTasksMutation, GeneratePlanningTasksMutationVariables>(GeneratePlanningTasksDocument, options);
      }
export type GeneratePlanningTasksMutationHookResult = ReturnType<typeof useGeneratePlanningTasksMutation>;
export type GeneratePlanningTasksMutationResult = Apollo.MutationResult<GeneratePlanningTasksMutation>;
export type GeneratePlanningTasksMutationOptions = Apollo.BaseMutationOptions<GeneratePlanningTasksMutation, GeneratePlanningTasksMutationVariables>;
export const SuggestWatchTitleDocument = gql`
    mutation SuggestWatchTitle($projectDescription: String!) {
  suggestWatchTitle(projectDescription: $projectDescription)
}
    `;
export type SuggestWatchTitleMutationFn = Apollo.MutationFunction<SuggestWatchTitleMutation, SuggestWatchTitleMutationVariables>;

/**
 * __useSuggestWatchTitleMutation__
 *
 * To run a mutation, you first call `useSuggestWatchTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuggestWatchTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suggestWatchTitleMutation, { data, loading, error }] = useSuggestWatchTitleMutation({
 *   variables: {
 *      projectDescription: // value for 'projectDescription'
 *   },
 * });
 */
export function useSuggestWatchTitleMutation(baseOptions?: Apollo.MutationHookOptions<SuggestWatchTitleMutation, SuggestWatchTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuggestWatchTitleMutation, SuggestWatchTitleMutationVariables>(SuggestWatchTitleDocument, options);
      }
export type SuggestWatchTitleMutationHookResult = ReturnType<typeof useSuggestWatchTitleMutation>;
export type SuggestWatchTitleMutationResult = Apollo.MutationResult<SuggestWatchTitleMutation>;
export type SuggestWatchTitleMutationOptions = Apollo.BaseMutationOptions<SuggestWatchTitleMutation, SuggestWatchTitleMutationVariables>;
export const CreatePlanningProbeDocument = gql`
    mutation CreatePlanningProbe($input: CreatePlanningProbeInput!) {
  createPlanningProbe(input: $input) {
    id
    type
    status
    projectTemplateId
  }
}
    `;
export type CreatePlanningProbeMutationFn = Apollo.MutationFunction<CreatePlanningProbeMutation, CreatePlanningProbeMutationVariables>;

/**
 * __useCreatePlanningProbeMutation__
 *
 * To run a mutation, you first call `useCreatePlanningProbeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlanningProbeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlanningProbeMutation, { data, loading, error }] = useCreatePlanningProbeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlanningProbeMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlanningProbeMutation, CreatePlanningProbeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlanningProbeMutation, CreatePlanningProbeMutationVariables>(CreatePlanningProbeDocument, options);
      }
export type CreatePlanningProbeMutationHookResult = ReturnType<typeof useCreatePlanningProbeMutation>;
export type CreatePlanningProbeMutationResult = Apollo.MutationResult<CreatePlanningProbeMutation>;
export type CreatePlanningProbeMutationOptions = Apollo.BaseMutationOptions<CreatePlanningProbeMutation, CreatePlanningProbeMutationVariables>;
export const AddYourselfDocument = gql`
    mutation AddYourself($input: AddYourselfInput!) {
  addYourself(input: $input) {
    id
    viewedAt
    perspectives {
      ...PerspectiveBaseInfo
    }
  }
}
    ${PerspectiveBaseInfoFragmentDoc}`;
export type AddYourselfMutationFn = Apollo.MutationFunction<AddYourselfMutation, AddYourselfMutationVariables>;

/**
 * __useAddYourselfMutation__
 *
 * To run a mutation, you first call `useAddYourselfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddYourselfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addYourselfMutation, { data, loading, error }] = useAddYourselfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddYourselfMutation(baseOptions?: Apollo.MutationHookOptions<AddYourselfMutation, AddYourselfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddYourselfMutation, AddYourselfMutationVariables>(AddYourselfDocument, options);
      }
export type AddYourselfMutationHookResult = ReturnType<typeof useAddYourselfMutation>;
export type AddYourselfMutationResult = Apollo.MutationResult<AddYourselfMutation>;
export type AddYourselfMutationOptions = Apollo.BaseMutationOptions<AddYourselfMutation, AddYourselfMutationVariables>;
export const CreateProjectDocument = gql`
    mutation CreateProject($input: CreateProjectInput!) {
  createProject(input: $input) {
    id
    topic
    name
    digitalTwinType
    projectTemplateId
  }
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const CreateNewProjectModalDocument = gql`
    query CreateNewProjectModal {
  user {
    id
    canSendMessage
    currentOrganization {
      id
      personaAccessTypes
    }
  }
}
    `;

/**
 * __useCreateNewProjectModalQuery__
 *
 * To run a query within a React component, call `useCreateNewProjectModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateNewProjectModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateNewProjectModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateNewProjectModalQuery(baseOptions?: Apollo.QueryHookOptions<CreateNewProjectModalQuery, CreateNewProjectModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateNewProjectModalQuery, CreateNewProjectModalQueryVariables>(CreateNewProjectModalDocument, options);
      }
export function useCreateNewProjectModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateNewProjectModalQuery, CreateNewProjectModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateNewProjectModalQuery, CreateNewProjectModalQueryVariables>(CreateNewProjectModalDocument, options);
        }
// @ts-ignore
export function useCreateNewProjectModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CreateNewProjectModalQuery, CreateNewProjectModalQueryVariables>): Apollo.UseSuspenseQueryResult<CreateNewProjectModalQuery, CreateNewProjectModalQueryVariables>;
export function useCreateNewProjectModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateNewProjectModalQuery, CreateNewProjectModalQueryVariables>): Apollo.UseSuspenseQueryResult<CreateNewProjectModalQuery | undefined, CreateNewProjectModalQueryVariables>;
export function useCreateNewProjectModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateNewProjectModalQuery, CreateNewProjectModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateNewProjectModalQuery, CreateNewProjectModalQueryVariables>(CreateNewProjectModalDocument, options);
        }
export type CreateNewProjectModalQueryHookResult = ReturnType<typeof useCreateNewProjectModalQuery>;
export type CreateNewProjectModalLazyQueryHookResult = ReturnType<typeof useCreateNewProjectModalLazyQuery>;
export type CreateNewProjectModalSuspenseQueryHookResult = ReturnType<typeof useCreateNewProjectModalSuspenseQuery>;
export type CreateNewProjectModalQueryResult = Apollo.QueryResult<CreateNewProjectModalQuery, CreateNewProjectModalQueryVariables>;
export const GenerateProjectDocument = gql`
    mutation GenerateProject($input: GenerateProjectInput!) {
  generateProject(input: $input) {
    id
    topic
    name
    digitalTwinType
    subtopics {
      name
    }
  }
}
    `;
export type GenerateProjectMutationFn = Apollo.MutationFunction<GenerateProjectMutation, GenerateProjectMutationVariables>;

/**
 * __useGenerateProjectMutation__
 *
 * To run a mutation, you first call `useGenerateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateProjectMutation, { data, loading, error }] = useGenerateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateProjectMutation(baseOptions?: Apollo.MutationHookOptions<GenerateProjectMutation, GenerateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateProjectMutation, GenerateProjectMutationVariables>(GenerateProjectDocument, options);
      }
export type GenerateProjectMutationHookResult = ReturnType<typeof useGenerateProjectMutation>;
export type GenerateProjectMutationResult = Apollo.MutationResult<GenerateProjectMutation>;
export type GenerateProjectMutationOptions = Apollo.BaseMutationOptions<GenerateProjectMutation, GenerateProjectMutationVariables>;
export const ConfirmSubtopicsDocument = gql`
    mutation ConfirmSubtopics($input: ConfirmSubtopicsInput!) {
  confirmSubtopics(input: $input) {
    id
    topic
    subtopics {
      name
    }
  }
}
    `;
export type ConfirmSubtopicsMutationFn = Apollo.MutationFunction<ConfirmSubtopicsMutation, ConfirmSubtopicsMutationVariables>;

/**
 * __useConfirmSubtopicsMutation__
 *
 * To run a mutation, you first call `useConfirmSubtopicsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmSubtopicsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmSubtopicsMutation, { data, loading, error }] = useConfirmSubtopicsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmSubtopicsMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmSubtopicsMutation, ConfirmSubtopicsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmSubtopicsMutation, ConfirmSubtopicsMutationVariables>(ConfirmSubtopicsDocument, options);
      }
export type ConfirmSubtopicsMutationHookResult = ReturnType<typeof useConfirmSubtopicsMutation>;
export type ConfirmSubtopicsMutationResult = Apollo.MutationResult<ConfirmSubtopicsMutation>;
export type ConfirmSubtopicsMutationOptions = Apollo.BaseMutationOptions<ConfirmSubtopicsMutation, ConfirmSubtopicsMutationVariables>;
export const GetProjectSettingsDocument = gql`
    query GetProjectSettings($projectTemplateId: String!) {
  getProjectSettings(projectTemplateId: $projectTemplateId) {
    id
    updateFrequency
    customUpdateIntervalHours
    lastUpdatedAt
    nextScheduledUpdate
    autoUpdateEnabled
    changeDetectionEnabled
    sensitivityStdDevs
    burnInPeriod
    qualityTrackingEnabled
    notificationFrequency
    summaryIntervalHours
    notificationsEnabled
    notifyOnCompletion
    notifyOnErrors
    notifyOnNewInsights
    notificationChannels
    notificationEmail
  }
}
    `;

/**
 * __useGetProjectSettingsQuery__
 *
 * To run a query within a React component, call `useGetProjectSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSettingsQuery({
 *   variables: {
 *      projectTemplateId: // value for 'projectTemplateId'
 *   },
 * });
 */
export function useGetProjectSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetProjectSettingsQuery, GetProjectSettingsQueryVariables> & ({ variables: GetProjectSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>(GetProjectSettingsDocument, options);
      }
export function useGetProjectSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>(GetProjectSettingsDocument, options);
        }
// @ts-ignore
export function useGetProjectSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>;
export function useGetProjectSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectSettingsQuery | undefined, GetProjectSettingsQueryVariables>;
export function useGetProjectSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>(GetProjectSettingsDocument, options);
        }
export type GetProjectSettingsQueryHookResult = ReturnType<typeof useGetProjectSettingsQuery>;
export type GetProjectSettingsLazyQueryHookResult = ReturnType<typeof useGetProjectSettingsLazyQuery>;
export type GetProjectSettingsSuspenseQueryHookResult = ReturnType<typeof useGetProjectSettingsSuspenseQuery>;
export type GetProjectSettingsQueryResult = Apollo.QueryResult<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>;
export const UpdateProjectSettingsDocument = gql`
    mutation UpdateProjectSettings($input: UpdateProjectSettingsInput!) {
  updateProjectSettings(input: $input) {
    id
    updateFrequency
    customUpdateIntervalHours
    lastUpdatedAt
    nextScheduledUpdate
    autoUpdateEnabled
    changeDetectionEnabled
    sensitivityStdDevs
    burnInPeriod
    qualityTrackingEnabled
    notificationFrequency
    summaryIntervalHours
    notificationsEnabled
    notifyOnCompletion
    notifyOnErrors
    notifyOnNewInsights
    notificationChannels
    notificationEmail
  }
}
    `;
export type UpdateProjectSettingsMutationFn = Apollo.MutationFunction<UpdateProjectSettingsMutation, UpdateProjectSettingsMutationVariables>;

/**
 * __useUpdateProjectSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateProjectSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectSettingsMutation, { data, loading, error }] = useUpdateProjectSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectSettingsMutation, UpdateProjectSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectSettingsMutation, UpdateProjectSettingsMutationVariables>(UpdateProjectSettingsDocument, options);
      }
export type UpdateProjectSettingsMutationHookResult = ReturnType<typeof useUpdateProjectSettingsMutation>;
export type UpdateProjectSettingsMutationResult = Apollo.MutationResult<UpdateProjectSettingsMutation>;
export type UpdateProjectSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateProjectSettingsMutation, UpdateProjectSettingsMutationVariables>;
export const GetMonitoringTopicsDocument = gql`
    query GetMonitoringTopics($dtType: DtType) {
  getMonitoringTopics(dtType: $dtType) {
    id
    name
    description
    category
    isActive
    sortOrder
    applicableDtTypes
    subtopics {
      id
      name
      description
      isActive
      sortOrder
      spectrumLeftTitle
      spectrumRightTitle
      questions
    }
  }
}
    `;

/**
 * __useGetMonitoringTopicsQuery__
 *
 * To run a query within a React component, call `useGetMonitoringTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMonitoringTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMonitoringTopicsQuery({
 *   variables: {
 *      dtType: // value for 'dtType'
 *   },
 * });
 */
export function useGetMonitoringTopicsQuery(baseOptions?: Apollo.QueryHookOptions<GetMonitoringTopicsQuery, GetMonitoringTopicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMonitoringTopicsQuery, GetMonitoringTopicsQueryVariables>(GetMonitoringTopicsDocument, options);
      }
export function useGetMonitoringTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMonitoringTopicsQuery, GetMonitoringTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMonitoringTopicsQuery, GetMonitoringTopicsQueryVariables>(GetMonitoringTopicsDocument, options);
        }
// @ts-ignore
export function useGetMonitoringTopicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMonitoringTopicsQuery, GetMonitoringTopicsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMonitoringTopicsQuery, GetMonitoringTopicsQueryVariables>;
export function useGetMonitoringTopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMonitoringTopicsQuery, GetMonitoringTopicsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMonitoringTopicsQuery | undefined, GetMonitoringTopicsQueryVariables>;
export function useGetMonitoringTopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMonitoringTopicsQuery, GetMonitoringTopicsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMonitoringTopicsQuery, GetMonitoringTopicsQueryVariables>(GetMonitoringTopicsDocument, options);
        }
export type GetMonitoringTopicsQueryHookResult = ReturnType<typeof useGetMonitoringTopicsQuery>;
export type GetMonitoringTopicsLazyQueryHookResult = ReturnType<typeof useGetMonitoringTopicsLazyQuery>;
export type GetMonitoringTopicsSuspenseQueryHookResult = ReturnType<typeof useGetMonitoringTopicsSuspenseQuery>;
export type GetMonitoringTopicsQueryResult = Apollo.QueryResult<GetMonitoringTopicsQuery, GetMonitoringTopicsQueryVariables>;
export const ShareProjectDocument = gql`
    mutation ShareProject($input: ShareProjectInput!) {
  shareProject(input: $input) {
    success
    sentTo
    failedTo
  }
}
    `;
export type ShareProjectMutationFn = Apollo.MutationFunction<ShareProjectMutation, ShareProjectMutationVariables>;

/**
 * __useShareProjectMutation__
 *
 * To run a mutation, you first call `useShareProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareProjectMutation, { data, loading, error }] = useShareProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareProjectMutation(baseOptions?: Apollo.MutationHookOptions<ShareProjectMutation, ShareProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareProjectMutation, ShareProjectMutationVariables>(ShareProjectDocument, options);
      }
export type ShareProjectMutationHookResult = ReturnType<typeof useShareProjectMutation>;
export type ShareProjectMutationResult = Apollo.MutationResult<ShareProjectMutation>;
export type ShareProjectMutationOptions = Apollo.BaseMutationOptions<ShareProjectMutation, ShareProjectMutationVariables>;
export const TriggerProjectUpdateDocument = gql`
    mutation TriggerProjectUpdate($input: TriggerProjectUpdateInput!) {
  triggerProjectUpdate(input: $input) {
    id
    topic
    status
  }
}
    `;
export type TriggerProjectUpdateMutationFn = Apollo.MutationFunction<TriggerProjectUpdateMutation, TriggerProjectUpdateMutationVariables>;

/**
 * __useTriggerProjectUpdateMutation__
 *
 * To run a mutation, you first call `useTriggerProjectUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerProjectUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerProjectUpdateMutation, { data, loading, error }] = useTriggerProjectUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerProjectUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TriggerProjectUpdateMutation, TriggerProjectUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerProjectUpdateMutation, TriggerProjectUpdateMutationVariables>(TriggerProjectUpdateDocument, options);
      }
export type TriggerProjectUpdateMutationHookResult = ReturnType<typeof useTriggerProjectUpdateMutation>;
export type TriggerProjectUpdateMutationResult = Apollo.MutationResult<TriggerProjectUpdateMutation>;
export type TriggerProjectUpdateMutationOptions = Apollo.BaseMutationOptions<TriggerProjectUpdateMutation, TriggerProjectUpdateMutationVariables>;
export const RetryProjectDocument = gql`
    mutation RetryProject($projectId: String!) {
  retryProject(projectId: $projectId) {
    id
    status
    errorMessage
  }
}
    `;
export type RetryProjectMutationFn = Apollo.MutationFunction<RetryProjectMutation, RetryProjectMutationVariables>;

/**
 * __useRetryProjectMutation__
 *
 * To run a mutation, you first call `useRetryProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryProjectMutation, { data, loading, error }] = useRetryProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useRetryProjectMutation(baseOptions?: Apollo.MutationHookOptions<RetryProjectMutation, RetryProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryProjectMutation, RetryProjectMutationVariables>(RetryProjectDocument, options);
      }
export type RetryProjectMutationHookResult = ReturnType<typeof useRetryProjectMutation>;
export type RetryProjectMutationResult = Apollo.MutationResult<RetryProjectMutation>;
export type RetryProjectMutationOptions = Apollo.BaseMutationOptions<RetryProjectMutation, RetryProjectMutationVariables>;
export const GetOrganizationMembersForSharingDocument = gql`
    query GetOrganizationMembersForSharing($organizationId: String!) {
  getOrganizationWithMembers(organizationId: $organizationId) {
    id
    name
    type
    members {
      id
      email
      fullName
    }
  }
}
    `;

/**
 * __useGetOrganizationMembersForSharingQuery__
 *
 * To run a query within a React component, call `useGetOrganizationMembersForSharingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationMembersForSharingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationMembersForSharingQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationMembersForSharingQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationMembersForSharingQuery, GetOrganizationMembersForSharingQueryVariables> & ({ variables: GetOrganizationMembersForSharingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationMembersForSharingQuery, GetOrganizationMembersForSharingQueryVariables>(GetOrganizationMembersForSharingDocument, options);
      }
export function useGetOrganizationMembersForSharingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationMembersForSharingQuery, GetOrganizationMembersForSharingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationMembersForSharingQuery, GetOrganizationMembersForSharingQueryVariables>(GetOrganizationMembersForSharingDocument, options);
        }
// @ts-ignore
export function useGetOrganizationMembersForSharingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationMembersForSharingQuery, GetOrganizationMembersForSharingQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationMembersForSharingQuery, GetOrganizationMembersForSharingQueryVariables>;
export function useGetOrganizationMembersForSharingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationMembersForSharingQuery, GetOrganizationMembersForSharingQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationMembersForSharingQuery | undefined, GetOrganizationMembersForSharingQueryVariables>;
export function useGetOrganizationMembersForSharingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationMembersForSharingQuery, GetOrganizationMembersForSharingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationMembersForSharingQuery, GetOrganizationMembersForSharingQueryVariables>(GetOrganizationMembersForSharingDocument, options);
        }
export type GetOrganizationMembersForSharingQueryHookResult = ReturnType<typeof useGetOrganizationMembersForSharingQuery>;
export type GetOrganizationMembersForSharingLazyQueryHookResult = ReturnType<typeof useGetOrganizationMembersForSharingLazyQuery>;
export type GetOrganizationMembersForSharingSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationMembersForSharingSuspenseQuery>;
export type GetOrganizationMembersForSharingQueryResult = Apollo.QueryResult<GetOrganizationMembersForSharingQuery, GetOrganizationMembersForSharingQueryVariables>;
export const ListConnectorSessionsDocument = gql`
    query ListConnectorSessions($agentId: String!) {
  listConnectorSessions(agentId: $agentId) {
    sessionId
    title
    lastModified
    sizeBytes
    cwd
  }
}
    `;

/**
 * __useListConnectorSessionsQuery__
 *
 * To run a query within a React component, call `useListConnectorSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConnectorSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConnectorSessionsQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useListConnectorSessionsQuery(baseOptions: Apollo.QueryHookOptions<ListConnectorSessionsQuery, ListConnectorSessionsQueryVariables> & ({ variables: ListConnectorSessionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListConnectorSessionsQuery, ListConnectorSessionsQueryVariables>(ListConnectorSessionsDocument, options);
      }
export function useListConnectorSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListConnectorSessionsQuery, ListConnectorSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListConnectorSessionsQuery, ListConnectorSessionsQueryVariables>(ListConnectorSessionsDocument, options);
        }
// @ts-ignore
export function useListConnectorSessionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListConnectorSessionsQuery, ListConnectorSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListConnectorSessionsQuery, ListConnectorSessionsQueryVariables>;
export function useListConnectorSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListConnectorSessionsQuery, ListConnectorSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListConnectorSessionsQuery | undefined, ListConnectorSessionsQueryVariables>;
export function useListConnectorSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListConnectorSessionsQuery, ListConnectorSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListConnectorSessionsQuery, ListConnectorSessionsQueryVariables>(ListConnectorSessionsDocument, options);
        }
export type ListConnectorSessionsQueryHookResult = ReturnType<typeof useListConnectorSessionsQuery>;
export type ListConnectorSessionsLazyQueryHookResult = ReturnType<typeof useListConnectorSessionsLazyQuery>;
export type ListConnectorSessionsSuspenseQueryHookResult = ReturnType<typeof useListConnectorSessionsSuspenseQuery>;
export type ListConnectorSessionsQueryResult = Apollo.QueryResult<ListConnectorSessionsQuery, ListConnectorSessionsQueryVariables>;
export const TriggerCompactionAnalysisDocument = gql`
    mutation TriggerCompactionAnalysis($input: TriggerCompactionAnalysisInput!) {
  triggerCompactionAnalysis(input: $input) {
    id
    status
  }
}
    `;
export type TriggerCompactionAnalysisMutationFn = Apollo.MutationFunction<TriggerCompactionAnalysisMutation, TriggerCompactionAnalysisMutationVariables>;

/**
 * __useTriggerCompactionAnalysisMutation__
 *
 * To run a mutation, you first call `useTriggerCompactionAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerCompactionAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerCompactionAnalysisMutation, { data, loading, error }] = useTriggerCompactionAnalysisMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerCompactionAnalysisMutation(baseOptions?: Apollo.MutationHookOptions<TriggerCompactionAnalysisMutation, TriggerCompactionAnalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerCompactionAnalysisMutation, TriggerCompactionAnalysisMutationVariables>(TriggerCompactionAnalysisDocument, options);
      }
export type TriggerCompactionAnalysisMutationHookResult = ReturnType<typeof useTriggerCompactionAnalysisMutation>;
export type TriggerCompactionAnalysisMutationResult = Apollo.MutationResult<TriggerCompactionAnalysisMutation>;
export type TriggerCompactionAnalysisMutationOptions = Apollo.BaseMutationOptions<TriggerCompactionAnalysisMutation, TriggerCompactionAnalysisMutationVariables>;
export const TriggerInjectionAnalysisDocument = gql`
    mutation TriggerInjectionAnalysis($input: TriggerInjectionAnalysisInput!) {
  triggerInjectionAnalysis(input: $input) {
    id
    status
  }
}
    `;
export type TriggerInjectionAnalysisMutationFn = Apollo.MutationFunction<TriggerInjectionAnalysisMutation, TriggerInjectionAnalysisMutationVariables>;

/**
 * __useTriggerInjectionAnalysisMutation__
 *
 * To run a mutation, you first call `useTriggerInjectionAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerInjectionAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerInjectionAnalysisMutation, { data, loading, error }] = useTriggerInjectionAnalysisMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerInjectionAnalysisMutation(baseOptions?: Apollo.MutationHookOptions<TriggerInjectionAnalysisMutation, TriggerInjectionAnalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerInjectionAnalysisMutation, TriggerInjectionAnalysisMutationVariables>(TriggerInjectionAnalysisDocument, options);
      }
export type TriggerInjectionAnalysisMutationHookResult = ReturnType<typeof useTriggerInjectionAnalysisMutation>;
export type TriggerInjectionAnalysisMutationResult = Apollo.MutationResult<TriggerInjectionAnalysisMutation>;
export type TriggerInjectionAnalysisMutationOptions = Apollo.BaseMutationOptions<TriggerInjectionAnalysisMutation, TriggerInjectionAnalysisMutationVariables>;
export const SteeringRunDocument = gql`
    query SteeringRun($id: String!) {
  steeringRun(id: $id) {
    id
    status
    errorMessage
    progressDone
    progressTotal
    progressLabel
    results {
      recommended {
        message
        similarity
        isBaseline
      }
      candidates {
        message
        similarity
        isBaseline
      }
    }
  }
}
    `;

/**
 * __useSteeringRunQuery__
 *
 * To run a query within a React component, call `useSteeringRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useSteeringRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSteeringRunQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSteeringRunQuery(baseOptions: Apollo.QueryHookOptions<SteeringRunQuery, SteeringRunQueryVariables> & ({ variables: SteeringRunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SteeringRunQuery, SteeringRunQueryVariables>(SteeringRunDocument, options);
      }
export function useSteeringRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SteeringRunQuery, SteeringRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SteeringRunQuery, SteeringRunQueryVariables>(SteeringRunDocument, options);
        }
// @ts-ignore
export function useSteeringRunSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SteeringRunQuery, SteeringRunQueryVariables>): Apollo.UseSuspenseQueryResult<SteeringRunQuery, SteeringRunQueryVariables>;
export function useSteeringRunSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SteeringRunQuery, SteeringRunQueryVariables>): Apollo.UseSuspenseQueryResult<SteeringRunQuery | undefined, SteeringRunQueryVariables>;
export function useSteeringRunSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SteeringRunQuery, SteeringRunQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SteeringRunQuery, SteeringRunQueryVariables>(SteeringRunDocument, options);
        }
export type SteeringRunQueryHookResult = ReturnType<typeof useSteeringRunQuery>;
export type SteeringRunLazyQueryHookResult = ReturnType<typeof useSteeringRunLazyQuery>;
export type SteeringRunSuspenseQueryHookResult = ReturnType<typeof useSteeringRunSuspenseQuery>;
export type SteeringRunQueryResult = Apollo.QueryResult<SteeringRunQuery, SteeringRunQueryVariables>;
export const RequestsDocument = gql`
    query Requests {
  getAllRequests {
    ...ProposalData
  }
}
    ${ProposalDataFragmentDoc}`;

/**
 * __useRequestsQuery__
 *
 * To run a query within a React component, call `useRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRequestsQuery(baseOptions?: Apollo.QueryHookOptions<RequestsQuery, RequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestsQuery, RequestsQueryVariables>(RequestsDocument, options);
      }
export function useRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestsQuery, RequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestsQuery, RequestsQueryVariables>(RequestsDocument, options);
        }
// @ts-ignore
export function useRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RequestsQuery, RequestsQueryVariables>): Apollo.UseSuspenseQueryResult<RequestsQuery, RequestsQueryVariables>;
export function useRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequestsQuery, RequestsQueryVariables>): Apollo.UseSuspenseQueryResult<RequestsQuery | undefined, RequestsQueryVariables>;
export function useRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequestsQuery, RequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RequestsQuery, RequestsQueryVariables>(RequestsDocument, options);
        }
export type RequestsQueryHookResult = ReturnType<typeof useRequestsQuery>;
export type RequestsLazyQueryHookResult = ReturnType<typeof useRequestsLazyQuery>;
export type RequestsSuspenseQueryHookResult = ReturnType<typeof useRequestsSuspenseQuery>;
export type RequestsQueryResult = Apollo.QueryResult<RequestsQuery, RequestsQueryVariables>;
export const DeleteRequestDocument = gql`
    mutation DeleteRequest($id: String!) {
  deleteProposal(id: $id)
}
    `;
export type DeleteRequestMutationFn = Apollo.MutationFunction<DeleteRequestMutation, DeleteRequestMutationVariables>;

/**
 * __useDeleteRequestMutation__
 *
 * To run a mutation, you first call `useDeleteRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRequestMutation, { data, loading, error }] = useDeleteRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRequestMutation, DeleteRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRequestMutation, DeleteRequestMutationVariables>(DeleteRequestDocument, options);
      }
export type DeleteRequestMutationHookResult = ReturnType<typeof useDeleteRequestMutation>;
export type DeleteRequestMutationResult = Apollo.MutationResult<DeleteRequestMutation>;
export type DeleteRequestMutationOptions = Apollo.BaseMutationOptions<DeleteRequestMutation, DeleteRequestMutationVariables>;
export const CreateFeatureRequestFeedbackDocument = gql`
    mutation CreateFeatureRequestFeedback($description: String!, $type: FeatureRequestFeedbackType!) {
  createFeatureRequestFeedback(description: $description, type: $type)
}
    `;
export type CreateFeatureRequestFeedbackMutationFn = Apollo.MutationFunction<CreateFeatureRequestFeedbackMutation, CreateFeatureRequestFeedbackMutationVariables>;

/**
 * __useCreateFeatureRequestFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateFeatureRequestFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeatureRequestFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeatureRequestFeedbackMutation, { data, loading, error }] = useCreateFeatureRequestFeedbackMutation({
 *   variables: {
 *      description: // value for 'description'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateFeatureRequestFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeatureRequestFeedbackMutation, CreateFeatureRequestFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeatureRequestFeedbackMutation, CreateFeatureRequestFeedbackMutationVariables>(CreateFeatureRequestFeedbackDocument, options);
      }
export type CreateFeatureRequestFeedbackMutationHookResult = ReturnType<typeof useCreateFeatureRequestFeedbackMutation>;
export type CreateFeatureRequestFeedbackMutationResult = Apollo.MutationResult<CreateFeatureRequestFeedbackMutation>;
export type CreateFeatureRequestFeedbackMutationOptions = Apollo.BaseMutationOptions<CreateFeatureRequestFeedbackMutation, CreateFeatureRequestFeedbackMutationVariables>;
export const GetMyOrganizationsWithRolesDocument = gql`
    query GetMyOrganizationsWithRoles {
  getMyOrganizationsWithRoles {
    id
    name
    role
    type
  }
}
    `;

/**
 * __useGetMyOrganizationsWithRolesQuery__
 *
 * To run a query within a React component, call `useGetMyOrganizationsWithRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOrganizationsWithRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOrganizationsWithRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyOrganizationsWithRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetMyOrganizationsWithRolesQuery, GetMyOrganizationsWithRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyOrganizationsWithRolesQuery, GetMyOrganizationsWithRolesQueryVariables>(GetMyOrganizationsWithRolesDocument, options);
      }
export function useGetMyOrganizationsWithRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyOrganizationsWithRolesQuery, GetMyOrganizationsWithRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyOrganizationsWithRolesQuery, GetMyOrganizationsWithRolesQueryVariables>(GetMyOrganizationsWithRolesDocument, options);
        }
// @ts-ignore
export function useGetMyOrganizationsWithRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyOrganizationsWithRolesQuery, GetMyOrganizationsWithRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyOrganizationsWithRolesQuery, GetMyOrganizationsWithRolesQueryVariables>;
export function useGetMyOrganizationsWithRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyOrganizationsWithRolesQuery, GetMyOrganizationsWithRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyOrganizationsWithRolesQuery | undefined, GetMyOrganizationsWithRolesQueryVariables>;
export function useGetMyOrganizationsWithRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyOrganizationsWithRolesQuery, GetMyOrganizationsWithRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyOrganizationsWithRolesQuery, GetMyOrganizationsWithRolesQueryVariables>(GetMyOrganizationsWithRolesDocument, options);
        }
export type GetMyOrganizationsWithRolesQueryHookResult = ReturnType<typeof useGetMyOrganizationsWithRolesQuery>;
export type GetMyOrganizationsWithRolesLazyQueryHookResult = ReturnType<typeof useGetMyOrganizationsWithRolesLazyQuery>;
export type GetMyOrganizationsWithRolesSuspenseQueryHookResult = ReturnType<typeof useGetMyOrganizationsWithRolesSuspenseQuery>;
export type GetMyOrganizationsWithRolesQueryResult = Apollo.QueryResult<GetMyOrganizationsWithRolesQuery, GetMyOrganizationsWithRolesQueryVariables>;
export const GetOrganizationWithMembersDocument = gql`
    query GetOrganizationWithMembers($organizationId: String!) {
  getOrganizationWithMembers(organizationId: $organizationId) {
    id
    name
    currentUserRole
    members {
      id
      email
      fullName
      role
      joinedAt
    }
    pendingInvitations {
      id
      email
      role
      status
      createdAt
      expiresAt
      invitedByUser {
        id
        fullName
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationWithMembersQuery__
 *
 * To run a query within a React component, call `useGetOrganizationWithMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationWithMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationWithMembersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationWithMembersQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationWithMembersQuery, GetOrganizationWithMembersQueryVariables> & ({ variables: GetOrganizationWithMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationWithMembersQuery, GetOrganizationWithMembersQueryVariables>(GetOrganizationWithMembersDocument, options);
      }
export function useGetOrganizationWithMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationWithMembersQuery, GetOrganizationWithMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationWithMembersQuery, GetOrganizationWithMembersQueryVariables>(GetOrganizationWithMembersDocument, options);
        }
// @ts-ignore
export function useGetOrganizationWithMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationWithMembersQuery, GetOrganizationWithMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationWithMembersQuery, GetOrganizationWithMembersQueryVariables>;
export function useGetOrganizationWithMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationWithMembersQuery, GetOrganizationWithMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationWithMembersQuery | undefined, GetOrganizationWithMembersQueryVariables>;
export function useGetOrganizationWithMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationWithMembersQuery, GetOrganizationWithMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationWithMembersQuery, GetOrganizationWithMembersQueryVariables>(GetOrganizationWithMembersDocument, options);
        }
export type GetOrganizationWithMembersQueryHookResult = ReturnType<typeof useGetOrganizationWithMembersQuery>;
export type GetOrganizationWithMembersLazyQueryHookResult = ReturnType<typeof useGetOrganizationWithMembersLazyQuery>;
export type GetOrganizationWithMembersSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationWithMembersSuspenseQuery>;
export type GetOrganizationWithMembersQueryResult = Apollo.QueryResult<GetOrganizationWithMembersQuery, GetOrganizationWithMembersQueryVariables>;
export const GetPendingInvitationsDocument = gql`
    query GetPendingInvitations {
  getPendingInvitations {
    id
    email
    role
    status
    createdAt
    expiresAt
    token
    organization {
      id
      name
    }
    invitedByUser {
      id
      fullName
    }
  }
}
    `;

/**
 * __useGetPendingInvitationsQuery__
 *
 * To run a query within a React component, call `useGetPendingInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingInvitationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPendingInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingInvitationsQuery, GetPendingInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingInvitationsQuery, GetPendingInvitationsQueryVariables>(GetPendingInvitationsDocument, options);
      }
export function useGetPendingInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingInvitationsQuery, GetPendingInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingInvitationsQuery, GetPendingInvitationsQueryVariables>(GetPendingInvitationsDocument, options);
        }
// @ts-ignore
export function useGetPendingInvitationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPendingInvitationsQuery, GetPendingInvitationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPendingInvitationsQuery, GetPendingInvitationsQueryVariables>;
export function useGetPendingInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingInvitationsQuery, GetPendingInvitationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPendingInvitationsQuery | undefined, GetPendingInvitationsQueryVariables>;
export function useGetPendingInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingInvitationsQuery, GetPendingInvitationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPendingInvitationsQuery, GetPendingInvitationsQueryVariables>(GetPendingInvitationsDocument, options);
        }
export type GetPendingInvitationsQueryHookResult = ReturnType<typeof useGetPendingInvitationsQuery>;
export type GetPendingInvitationsLazyQueryHookResult = ReturnType<typeof useGetPendingInvitationsLazyQuery>;
export type GetPendingInvitationsSuspenseQueryHookResult = ReturnType<typeof useGetPendingInvitationsSuspenseQuery>;
export type GetPendingInvitationsQueryResult = Apollo.QueryResult<GetPendingInvitationsQuery, GetPendingInvitationsQueryVariables>;
export const GetInvitationByTokenDocument = gql`
    query GetInvitationByToken($token: String!) {
  getInvitationByToken(token: $token) {
    id
    email
    role
    status
    createdAt
    expiresAt
    organization {
      id
      name
    }
    invitedByUser {
      id
      fullName
    }
  }
}
    `;

/**
 * __useGetInvitationByTokenQuery__
 *
 * To run a query within a React component, call `useGetInvitationByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitationByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitationByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetInvitationByTokenQuery(baseOptions: Apollo.QueryHookOptions<GetInvitationByTokenQuery, GetInvitationByTokenQueryVariables> & ({ variables: GetInvitationByTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvitationByTokenQuery, GetInvitationByTokenQueryVariables>(GetInvitationByTokenDocument, options);
      }
export function useGetInvitationByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvitationByTokenQuery, GetInvitationByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvitationByTokenQuery, GetInvitationByTokenQueryVariables>(GetInvitationByTokenDocument, options);
        }
// @ts-ignore
export function useGetInvitationByTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvitationByTokenQuery, GetInvitationByTokenQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvitationByTokenQuery, GetInvitationByTokenQueryVariables>;
export function useGetInvitationByTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvitationByTokenQuery, GetInvitationByTokenQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvitationByTokenQuery | undefined, GetInvitationByTokenQueryVariables>;
export function useGetInvitationByTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvitationByTokenQuery, GetInvitationByTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvitationByTokenQuery, GetInvitationByTokenQueryVariables>(GetInvitationByTokenDocument, options);
        }
export type GetInvitationByTokenQueryHookResult = ReturnType<typeof useGetInvitationByTokenQuery>;
export type GetInvitationByTokenLazyQueryHookResult = ReturnType<typeof useGetInvitationByTokenLazyQuery>;
export type GetInvitationByTokenSuspenseQueryHookResult = ReturnType<typeof useGetInvitationByTokenSuspenseQuery>;
export type GetInvitationByTokenQueryResult = Apollo.QueryResult<GetInvitationByTokenQuery, GetInvitationByTokenQueryVariables>;
export const CreateOrganizationWithOwnerDocument = gql`
    mutation CreateOrganizationWithOwner($name: String!) {
  createOrganizationWithOwner(name: $name) {
    id
    name
  }
}
    `;
export type CreateOrganizationWithOwnerMutationFn = Apollo.MutationFunction<CreateOrganizationWithOwnerMutation, CreateOrganizationWithOwnerMutationVariables>;

/**
 * __useCreateOrganizationWithOwnerMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationWithOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationWithOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationWithOwnerMutation, { data, loading, error }] = useCreateOrganizationWithOwnerMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateOrganizationWithOwnerMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationWithOwnerMutation, CreateOrganizationWithOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationWithOwnerMutation, CreateOrganizationWithOwnerMutationVariables>(CreateOrganizationWithOwnerDocument, options);
      }
export type CreateOrganizationWithOwnerMutationHookResult = ReturnType<typeof useCreateOrganizationWithOwnerMutation>;
export type CreateOrganizationWithOwnerMutationResult = Apollo.MutationResult<CreateOrganizationWithOwnerMutation>;
export type CreateOrganizationWithOwnerMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationWithOwnerMutation, CreateOrganizationWithOwnerMutationVariables>;
export const DeleteOrganizationDocument = gql`
    mutation DeleteOrganization($organizationId: String!) {
  deleteOrganization(organizationId: $organizationId)
}
    `;
export type DeleteOrganizationMutationFn = Apollo.MutationFunction<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(DeleteOrganizationDocument, options);
      }
export type DeleteOrganizationMutationHookResult = ReturnType<typeof useDeleteOrganizationMutation>;
export type DeleteOrganizationMutationResult = Apollo.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;
export const InviteToOrganizationDocument = gql`
    mutation InviteToOrganization($input: InviteToOrganizationInput!) {
  inviteToOrganization(input: $input) {
    id
    email
    role
    status
    createdAt
    expiresAt
  }
}
    `;
export type InviteToOrganizationMutationFn = Apollo.MutationFunction<InviteToOrganizationMutation, InviteToOrganizationMutationVariables>;

/**
 * __useInviteToOrganizationMutation__
 *
 * To run a mutation, you first call `useInviteToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteToOrganizationMutation, { data, loading, error }] = useInviteToOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteToOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<InviteToOrganizationMutation, InviteToOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteToOrganizationMutation, InviteToOrganizationMutationVariables>(InviteToOrganizationDocument, options);
      }
export type InviteToOrganizationMutationHookResult = ReturnType<typeof useInviteToOrganizationMutation>;
export type InviteToOrganizationMutationResult = Apollo.MutationResult<InviteToOrganizationMutation>;
export type InviteToOrganizationMutationOptions = Apollo.BaseMutationOptions<InviteToOrganizationMutation, InviteToOrganizationMutationVariables>;
export const AcceptInvitationDocument = gql`
    mutation AcceptInvitation($token: String!) {
  acceptInvitation(token: $token) {
    id
    name
  }
}
    `;
export type AcceptInvitationMutationFn = Apollo.MutationFunction<AcceptInvitationMutation, AcceptInvitationMutationVariables>;

/**
 * __useAcceptInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInvitationMutation, { data, loading, error }] = useAcceptInvitationMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAcceptInvitationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInvitationMutation, AcceptInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInvitationMutation, AcceptInvitationMutationVariables>(AcceptInvitationDocument, options);
      }
export type AcceptInvitationMutationHookResult = ReturnType<typeof useAcceptInvitationMutation>;
export type AcceptInvitationMutationResult = Apollo.MutationResult<AcceptInvitationMutation>;
export type AcceptInvitationMutationOptions = Apollo.BaseMutationOptions<AcceptInvitationMutation, AcceptInvitationMutationVariables>;
export const DeclineInvitationDocument = gql`
    mutation DeclineInvitation($token: String!) {
  declineInvitation(token: $token)
}
    `;
export type DeclineInvitationMutationFn = Apollo.MutationFunction<DeclineInvitationMutation, DeclineInvitationMutationVariables>;

/**
 * __useDeclineInvitationMutation__
 *
 * To run a mutation, you first call `useDeclineInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineInvitationMutation, { data, loading, error }] = useDeclineInvitationMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useDeclineInvitationMutation(baseOptions?: Apollo.MutationHookOptions<DeclineInvitationMutation, DeclineInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineInvitationMutation, DeclineInvitationMutationVariables>(DeclineInvitationDocument, options);
      }
export type DeclineInvitationMutationHookResult = ReturnType<typeof useDeclineInvitationMutation>;
export type DeclineInvitationMutationResult = Apollo.MutationResult<DeclineInvitationMutation>;
export type DeclineInvitationMutationOptions = Apollo.BaseMutationOptions<DeclineInvitationMutation, DeclineInvitationMutationVariables>;
export const ResendInvitationDocument = gql`
    mutation ResendInvitation($invitationId: String!) {
  resendInvitation(invitationId: $invitationId) {
    id
    email
    expiresAt
  }
}
    `;
export type ResendInvitationMutationFn = Apollo.MutationFunction<ResendInvitationMutation, ResendInvitationMutationVariables>;

/**
 * __useResendInvitationMutation__
 *
 * To run a mutation, you first call `useResendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInvitationMutation, { data, loading, error }] = useResendInvitationMutation({
 *   variables: {
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function useResendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendInvitationMutation, ResendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInvitationMutation, ResendInvitationMutationVariables>(ResendInvitationDocument, options);
      }
export type ResendInvitationMutationHookResult = ReturnType<typeof useResendInvitationMutation>;
export type ResendInvitationMutationResult = Apollo.MutationResult<ResendInvitationMutation>;
export type ResendInvitationMutationOptions = Apollo.BaseMutationOptions<ResendInvitationMutation, ResendInvitationMutationVariables>;
export const RevokeInvitationDocument = gql`
    mutation RevokeInvitation($invitationId: String!) {
  revokeInvitation(invitationId: $invitationId)
}
    `;
export type RevokeInvitationMutationFn = Apollo.MutationFunction<RevokeInvitationMutation, RevokeInvitationMutationVariables>;

/**
 * __useRevokeInvitationMutation__
 *
 * To run a mutation, you first call `useRevokeInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeInvitationMutation, { data, loading, error }] = useRevokeInvitationMutation({
 *   variables: {
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function useRevokeInvitationMutation(baseOptions?: Apollo.MutationHookOptions<RevokeInvitationMutation, RevokeInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeInvitationMutation, RevokeInvitationMutationVariables>(RevokeInvitationDocument, options);
      }
export type RevokeInvitationMutationHookResult = ReturnType<typeof useRevokeInvitationMutation>;
export type RevokeInvitationMutationResult = Apollo.MutationResult<RevokeInvitationMutation>;
export type RevokeInvitationMutationOptions = Apollo.BaseMutationOptions<RevokeInvitationMutation, RevokeInvitationMutationVariables>;
export const UpdateMemberRoleDocument = gql`
    mutation UpdateMemberRole($input: UpdateMemberRoleInput!) {
  updateMemberRole(input: $input) {
    id
    email
    fullName
    role
  }
}
    `;
export type UpdateMemberRoleMutationFn = Apollo.MutationFunction<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>;

/**
 * __useUpdateMemberRoleMutation__
 *
 * To run a mutation, you first call `useUpdateMemberRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberRoleMutation, { data, loading, error }] = useUpdateMemberRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMemberRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>(UpdateMemberRoleDocument, options);
      }
export type UpdateMemberRoleMutationHookResult = ReturnType<typeof useUpdateMemberRoleMutation>;
export type UpdateMemberRoleMutationResult = Apollo.MutationResult<UpdateMemberRoleMutation>;
export type UpdateMemberRoleMutationOptions = Apollo.BaseMutationOptions<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>;
export const RemoveMemberDocument = gql`
    mutation RemoveMember($organizationId: String!, $userId: String!) {
  removeMember(organizationId: $organizationId, userId: $userId)
}
    `;
export type RemoveMemberMutationFn = Apollo.MutationFunction<RemoveMemberMutation, RemoveMemberMutationVariables>;

/**
 * __useRemoveMemberMutation__
 *
 * To run a mutation, you first call `useRemoveMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberMutation, { data, loading, error }] = useRemoveMemberMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMemberMutation, RemoveMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMemberMutation, RemoveMemberMutationVariables>(RemoveMemberDocument, options);
      }
export type RemoveMemberMutationHookResult = ReturnType<typeof useRemoveMemberMutation>;
export type RemoveMemberMutationResult = Apollo.MutationResult<RemoveMemberMutation>;
export type RemoveMemberMutationOptions = Apollo.BaseMutationOptions<RemoveMemberMutation, RemoveMemberMutationVariables>;
export const TransferOwnershipDocument = gql`
    mutation TransferOwnership($organizationId: String!, $newOwnerId: String!) {
  transferOwnership(organizationId: $organizationId, newOwnerId: $newOwnerId) {
    id
    name
  }
}
    `;
export type TransferOwnershipMutationFn = Apollo.MutationFunction<TransferOwnershipMutation, TransferOwnershipMutationVariables>;

/**
 * __useTransferOwnershipMutation__
 *
 * To run a mutation, you first call `useTransferOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferOwnershipMutation, { data, loading, error }] = useTransferOwnershipMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      newOwnerId: // value for 'newOwnerId'
 *   },
 * });
 */
export function useTransferOwnershipMutation(baseOptions?: Apollo.MutationHookOptions<TransferOwnershipMutation, TransferOwnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferOwnershipMutation, TransferOwnershipMutationVariables>(TransferOwnershipDocument, options);
      }
export type TransferOwnershipMutationHookResult = ReturnType<typeof useTransferOwnershipMutation>;
export type TransferOwnershipMutationResult = Apollo.MutationResult<TransferOwnershipMutation>;
export type TransferOwnershipMutationOptions = Apollo.BaseMutationOptions<TransferOwnershipMutation, TransferOwnershipMutationVariables>;
export const LeaveOrganizationDocument = gql`
    mutation LeaveOrganization($organizationId: String!) {
  leaveOrganization(organizationId: $organizationId)
}
    `;
export type LeaveOrganizationMutationFn = Apollo.MutationFunction<LeaveOrganizationMutation, LeaveOrganizationMutationVariables>;

/**
 * __useLeaveOrganizationMutation__
 *
 * To run a mutation, you first call `useLeaveOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveOrganizationMutation, { data, loading, error }] = useLeaveOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useLeaveOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<LeaveOrganizationMutation, LeaveOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveOrganizationMutation, LeaveOrganizationMutationVariables>(LeaveOrganizationDocument, options);
      }
export type LeaveOrganizationMutationHookResult = ReturnType<typeof useLeaveOrganizationMutation>;
export type LeaveOrganizationMutationResult = Apollo.MutationResult<LeaveOrganizationMutation>;
export type LeaveOrganizationMutationOptions = Apollo.BaseMutationOptions<LeaveOrganizationMutation, LeaveOrganizationMutationVariables>;
export const DeleteMyAccountDocument = gql`
    mutation DeleteMyAccount {
  deleteMyAccount
}
    `;
export type DeleteMyAccountMutationFn = Apollo.MutationFunction<DeleteMyAccountMutation, DeleteMyAccountMutationVariables>;

/**
 * __useDeleteMyAccountMutation__
 *
 * To run a mutation, you first call `useDeleteMyAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMyAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMyAccountMutation, { data, loading, error }] = useDeleteMyAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteMyAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMyAccountMutation, DeleteMyAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMyAccountMutation, DeleteMyAccountMutationVariables>(DeleteMyAccountDocument, options);
      }
export type DeleteMyAccountMutationHookResult = ReturnType<typeof useDeleteMyAccountMutation>;
export type DeleteMyAccountMutationResult = Apollo.MutationResult<DeleteMyAccountMutation>;
export type DeleteMyAccountMutationOptions = Apollo.BaseMutationOptions<DeleteMyAccountMutation, DeleteMyAccountMutationVariables>;
export const GetUsageLimitsDocument = gql`
    query GetUsageLimits {
  user {
    id
    plan
    usageLimits {
      plan
      maxAgents
      currentAgentCount
      canCreateAgent
      maxProjects
      currentProjectCount
      canCreateProject
      updateFrequencyInHours
      changesDetectedThisMonth
    }
  }
}
    `;

/**
 * __useGetUsageLimitsQuery__
 *
 * To run a query within a React component, call `useGetUsageLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsageLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsageLimitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsageLimitsQuery(baseOptions?: Apollo.QueryHookOptions<GetUsageLimitsQuery, GetUsageLimitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsageLimitsQuery, GetUsageLimitsQueryVariables>(GetUsageLimitsDocument, options);
      }
export function useGetUsageLimitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsageLimitsQuery, GetUsageLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsageLimitsQuery, GetUsageLimitsQueryVariables>(GetUsageLimitsDocument, options);
        }
// @ts-ignore
export function useGetUsageLimitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsageLimitsQuery, GetUsageLimitsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsageLimitsQuery, GetUsageLimitsQueryVariables>;
export function useGetUsageLimitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsageLimitsQuery, GetUsageLimitsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsageLimitsQuery | undefined, GetUsageLimitsQueryVariables>;
export function useGetUsageLimitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsageLimitsQuery, GetUsageLimitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsageLimitsQuery, GetUsageLimitsQueryVariables>(GetUsageLimitsDocument, options);
        }
export type GetUsageLimitsQueryHookResult = ReturnType<typeof useGetUsageLimitsQuery>;
export type GetUsageLimitsLazyQueryHookResult = ReturnType<typeof useGetUsageLimitsLazyQuery>;
export type GetUsageLimitsSuspenseQueryHookResult = ReturnType<typeof useGetUsageLimitsSuspenseQuery>;
export type GetUsageLimitsQueryResult = Apollo.QueryResult<GetUsageLimitsQuery, GetUsageLimitsQueryVariables>;
export const GetSurveysDocument = gql`
    query GetSurveys {
  getSurveys {
    id
    title
    status
    description
    type
    bountyInCents
    createdAt
    createdByUser {
      id
      fullName
    }
    organization {
      id
      name
    }
    questions {
      id
      title
      type
    }
    responses {
      id
      questionResponses {
        id
        response
      }
    }
  }
}
    `;

/**
 * __useGetSurveysQuery__
 *
 * To run a query within a React component, call `useGetSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSurveysQuery(baseOptions?: Apollo.QueryHookOptions<GetSurveysQuery, GetSurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveysQuery, GetSurveysQueryVariables>(GetSurveysDocument, options);
      }
export function useGetSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveysQuery, GetSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveysQuery, GetSurveysQueryVariables>(GetSurveysDocument, options);
        }
// @ts-ignore
export function useGetSurveysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSurveysQuery, GetSurveysQueryVariables>): Apollo.UseSuspenseQueryResult<GetSurveysQuery, GetSurveysQueryVariables>;
export function useGetSurveysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSurveysQuery, GetSurveysQueryVariables>): Apollo.UseSuspenseQueryResult<GetSurveysQuery | undefined, GetSurveysQueryVariables>;
export function useGetSurveysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSurveysQuery, GetSurveysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSurveysQuery, GetSurveysQueryVariables>(GetSurveysDocument, options);
        }
export type GetSurveysQueryHookResult = ReturnType<typeof useGetSurveysQuery>;
export type GetSurveysLazyQueryHookResult = ReturnType<typeof useGetSurveysLazyQuery>;
export type GetSurveysSuspenseQueryHookResult = ReturnType<typeof useGetSurveysSuspenseQuery>;
export type GetSurveysQueryResult = Apollo.QueryResult<GetSurveysQuery, GetSurveysQueryVariables>;
export const CreateSurveyWithQuestionsDocument = gql`
    mutation CreateSurveyWithQuestions($input: CreateSurveyWithQuestionsInput!) {
  createSurveyWithQuestions(input: $input) {
    id
    title
    description
    bountyInCents
  }
}
    `;
export type CreateSurveyWithQuestionsMutationFn = Apollo.MutationFunction<CreateSurveyWithQuestionsMutation, CreateSurveyWithQuestionsMutationVariables>;

/**
 * __useCreateSurveyWithQuestionsMutation__
 *
 * To run a mutation, you first call `useCreateSurveyWithQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSurveyWithQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSurveyWithQuestionsMutation, { data, loading, error }] = useCreateSurveyWithQuestionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSurveyWithQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateSurveyWithQuestionsMutation, CreateSurveyWithQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSurveyWithQuestionsMutation, CreateSurveyWithQuestionsMutationVariables>(CreateSurveyWithQuestionsDocument, options);
      }
export type CreateSurveyWithQuestionsMutationHookResult = ReturnType<typeof useCreateSurveyWithQuestionsMutation>;
export type CreateSurveyWithQuestionsMutationResult = Apollo.MutationResult<CreateSurveyWithQuestionsMutation>;
export type CreateSurveyWithQuestionsMutationOptions = Apollo.BaseMutationOptions<CreateSurveyWithQuestionsMutation, CreateSurveyWithQuestionsMutationVariables>;
export const GetSurveyGroupByIdDocument = gql`
    query GetSurveyGroupById($id: ID!) {
  getSurveyGroupById(id: $id) {
    id
    name
    digitalTwins {
      id
      name
      type
      surveyUserData {
        ...SurveyUserDataFragment
      }
    }
    surveys {
      id
      title
    }
  }
}
    ${SurveyUserDataFragmentFragmentDoc}`;

/**
 * __useGetSurveyGroupByIdQuery__
 *
 * To run a query within a React component, call `useGetSurveyGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyGroupByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSurveyGroupByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSurveyGroupByIdQuery, GetSurveyGroupByIdQueryVariables> & ({ variables: GetSurveyGroupByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveyGroupByIdQuery, GetSurveyGroupByIdQueryVariables>(GetSurveyGroupByIdDocument, options);
      }
export function useGetSurveyGroupByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveyGroupByIdQuery, GetSurveyGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveyGroupByIdQuery, GetSurveyGroupByIdQueryVariables>(GetSurveyGroupByIdDocument, options);
        }
// @ts-ignore
export function useGetSurveyGroupByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSurveyGroupByIdQuery, GetSurveyGroupByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetSurveyGroupByIdQuery, GetSurveyGroupByIdQueryVariables>;
export function useGetSurveyGroupByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSurveyGroupByIdQuery, GetSurveyGroupByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetSurveyGroupByIdQuery | undefined, GetSurveyGroupByIdQueryVariables>;
export function useGetSurveyGroupByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSurveyGroupByIdQuery, GetSurveyGroupByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSurveyGroupByIdQuery, GetSurveyGroupByIdQueryVariables>(GetSurveyGroupByIdDocument, options);
        }
export type GetSurveyGroupByIdQueryHookResult = ReturnType<typeof useGetSurveyGroupByIdQuery>;
export type GetSurveyGroupByIdLazyQueryHookResult = ReturnType<typeof useGetSurveyGroupByIdLazyQuery>;
export type GetSurveyGroupByIdSuspenseQueryHookResult = ReturnType<typeof useGetSurveyGroupByIdSuspenseQuery>;
export type GetSurveyGroupByIdQueryResult = Apollo.QueryResult<GetSurveyGroupByIdQuery, GetSurveyGroupByIdQueryVariables>;
export const GetSurveyByIdDocument = gql`
    query GetSurveyById($id: ID!) {
  getSurveyById(id: $id) {
    id
    title
    status
    description
    baseQuestion
    bountyInCents
    createdAt
    type
    createdByUser {
      id
      fullName
    }
    questions {
      id
      title
      type
    }
    responses {
      id
      createdAt
      digitalTwin {
        id
        name
        surveyUserData {
          ...SurveyUserDataFragment
        }
      }
      questionResponses {
        id
        responseCounts {
          answer
          count
        }
        response
        question {
          id
          title
          type
        }
      }
    }
  }
}
    ${SurveyUserDataFragmentFragmentDoc}`;

/**
 * __useGetSurveyByIdQuery__
 *
 * To run a query within a React component, call `useGetSurveyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSurveyByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSurveyByIdQuery, GetSurveyByIdQueryVariables> & ({ variables: GetSurveyByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveyByIdQuery, GetSurveyByIdQueryVariables>(GetSurveyByIdDocument, options);
      }
export function useGetSurveyByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveyByIdQuery, GetSurveyByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveyByIdQuery, GetSurveyByIdQueryVariables>(GetSurveyByIdDocument, options);
        }
// @ts-ignore
export function useGetSurveyByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSurveyByIdQuery, GetSurveyByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetSurveyByIdQuery, GetSurveyByIdQueryVariables>;
export function useGetSurveyByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSurveyByIdQuery, GetSurveyByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetSurveyByIdQuery | undefined, GetSurveyByIdQueryVariables>;
export function useGetSurveyByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSurveyByIdQuery, GetSurveyByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSurveyByIdQuery, GetSurveyByIdQueryVariables>(GetSurveyByIdDocument, options);
        }
export type GetSurveyByIdQueryHookResult = ReturnType<typeof useGetSurveyByIdQuery>;
export type GetSurveyByIdLazyQueryHookResult = ReturnType<typeof useGetSurveyByIdLazyQuery>;
export type GetSurveyByIdSuspenseQueryHookResult = ReturnType<typeof useGetSurveyByIdSuspenseQuery>;
export type GetSurveyByIdQueryResult = Apollo.QueryResult<GetSurveyByIdQuery, GetSurveyByIdQueryVariables>;
export const CreateAbTestDocument = gql`
    mutation CreateABTest($input: CreateABTestInput!) {
  createABTest(input: $input) {
    id
    title
  }
}
    `;
export type CreateAbTestMutationFn = Apollo.MutationFunction<CreateAbTestMutation, CreateAbTestMutationVariables>;

/**
 * __useCreateAbTestMutation__
 *
 * To run a mutation, you first call `useCreateAbTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAbTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAbTestMutation, { data, loading, error }] = useCreateAbTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAbTestMutation(baseOptions?: Apollo.MutationHookOptions<CreateAbTestMutation, CreateAbTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAbTestMutation, CreateAbTestMutationVariables>(CreateAbTestDocument, options);
      }
export type CreateAbTestMutationHookResult = ReturnType<typeof useCreateAbTestMutation>;
export type CreateAbTestMutationResult = Apollo.MutationResult<CreateAbTestMutation>;
export type CreateAbTestMutationOptions = Apollo.BaseMutationOptions<CreateAbTestMutation, CreateAbTestMutationVariables>;
export const GetSurveyGroupNamesDocument = gql`
    query GetSurveyGroupNames {
  getSurveyGroupsBasicData {
    id
    name
  }
}
    `;

/**
 * __useGetSurveyGroupNamesQuery__
 *
 * To run a query within a React component, call `useGetSurveyGroupNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyGroupNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyGroupNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSurveyGroupNamesQuery(baseOptions?: Apollo.QueryHookOptions<GetSurveyGroupNamesQuery, GetSurveyGroupNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveyGroupNamesQuery, GetSurveyGroupNamesQueryVariables>(GetSurveyGroupNamesDocument, options);
      }
export function useGetSurveyGroupNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveyGroupNamesQuery, GetSurveyGroupNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveyGroupNamesQuery, GetSurveyGroupNamesQueryVariables>(GetSurveyGroupNamesDocument, options);
        }
// @ts-ignore
export function useGetSurveyGroupNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSurveyGroupNamesQuery, GetSurveyGroupNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSurveyGroupNamesQuery, GetSurveyGroupNamesQueryVariables>;
export function useGetSurveyGroupNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSurveyGroupNamesQuery, GetSurveyGroupNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSurveyGroupNamesQuery | undefined, GetSurveyGroupNamesQueryVariables>;
export function useGetSurveyGroupNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSurveyGroupNamesQuery, GetSurveyGroupNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSurveyGroupNamesQuery, GetSurveyGroupNamesQueryVariables>(GetSurveyGroupNamesDocument, options);
        }
export type GetSurveyGroupNamesQueryHookResult = ReturnType<typeof useGetSurveyGroupNamesQuery>;
export type GetSurveyGroupNamesLazyQueryHookResult = ReturnType<typeof useGetSurveyGroupNamesLazyQuery>;
export type GetSurveyGroupNamesSuspenseQueryHookResult = ReturnType<typeof useGetSurveyGroupNamesSuspenseQuery>;
export type GetSurveyGroupNamesQueryResult = Apollo.QueryResult<GetSurveyGroupNamesQuery, GetSurveyGroupNamesQueryVariables>;
export const GetSurveyGroupDetailsDocument = gql`
    query GetSurveyGroupDetails {
  getSurveyGroupsWithDetails {
    id
    name
    digitalTwins {
      id
      name
      surveyUserData {
        ...SurveyUserDataFragment
      }
      type
    }
    surveys {
      id
      title
    }
  }
}
    ${SurveyUserDataFragmentFragmentDoc}`;

/**
 * __useGetSurveyGroupDetailsQuery__
 *
 * To run a query within a React component, call `useGetSurveyGroupDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyGroupDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyGroupDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSurveyGroupDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetSurveyGroupDetailsQuery, GetSurveyGroupDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveyGroupDetailsQuery, GetSurveyGroupDetailsQueryVariables>(GetSurveyGroupDetailsDocument, options);
      }
export function useGetSurveyGroupDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveyGroupDetailsQuery, GetSurveyGroupDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveyGroupDetailsQuery, GetSurveyGroupDetailsQueryVariables>(GetSurveyGroupDetailsDocument, options);
        }
// @ts-ignore
export function useGetSurveyGroupDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSurveyGroupDetailsQuery, GetSurveyGroupDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSurveyGroupDetailsQuery, GetSurveyGroupDetailsQueryVariables>;
export function useGetSurveyGroupDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSurveyGroupDetailsQuery, GetSurveyGroupDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSurveyGroupDetailsQuery | undefined, GetSurveyGroupDetailsQueryVariables>;
export function useGetSurveyGroupDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSurveyGroupDetailsQuery, GetSurveyGroupDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSurveyGroupDetailsQuery, GetSurveyGroupDetailsQueryVariables>(GetSurveyGroupDetailsDocument, options);
        }
export type GetSurveyGroupDetailsQueryHookResult = ReturnType<typeof useGetSurveyGroupDetailsQuery>;
export type GetSurveyGroupDetailsLazyQueryHookResult = ReturnType<typeof useGetSurveyGroupDetailsLazyQuery>;
export type GetSurveyGroupDetailsSuspenseQueryHookResult = ReturnType<typeof useGetSurveyGroupDetailsSuspenseQuery>;
export type GetSurveyGroupDetailsQueryResult = Apollo.QueryResult<GetSurveyGroupDetailsQuery, GetSurveyGroupDetailsQueryVariables>;